import React, { useState, useRef, useEffect, useLayoutEffect, useId } from 'react';
import { Info, CloudUpload, X, ChevronDown, Search, Menu, Trash2, ChevronsUpDown, ChevronsDown, XCircle, ChevronRight, CircleCheck } from 'lucide-react';
import { useHistory, useLocation } from "react-router-dom";
import { getSpuNamesCache, ensureSpuNamesLoaded, invalidateSpuNamesCache } from '../../spuValidationCache';
import Tooltip from '../addentities/Tooltip.js';
import { ReactSortable } from 'react-sortablejs';
import { createPortal } from 'react-dom';
import apiHelper from '../../apiHelper';
import { Routes } from "../../routes";
import CharacterLimitedTextarea from '../../components/CharacterLimitedTextarea';
import DiscardConfirmationModal from '../../components/DiscardConfirmationModal.js';
import UnsavedChangesPrompt from '../../components/UnsavedChangesPrompt.js';
import SpuProgressStepper from '../../components/SpuProgressStepper.js';
import SortableHeader from '../../components/SortableHeader.js';
import MultiSelectSearch from '../../utils/MultiSelectSearch.js';
import noImage from '../../assets/img/brand/noImage.png'
import CalendarInput from '../../components/CalendarInput.js';
import AlertNotification from '../../components/AlertNotification';
import { ca } from 'date-fns/locale';
import ReactDOM from 'react-dom';
import Pagination from '../../components/Pagination.js';

//const MAX_IMAGES = 5;

const REFERENCE_OPTIONS = {
    Brands: [
        { label: 'Apple', value: 'apple' },
        { label: 'Samsung', value: 'samsung' },
        { label: 'OnePlus', value: 'oneplus' },
        { label: 'Xiaomi', value: 'xiaomi' },
    ],
    Categories: [
        { label: 'Mobile', value: 'mobile' },
        { label: 'Tablet', value: 'tablet' },
        { label: 'Laptop', value: 'laptop' },
    ],
    SPU: [
        { label: 'iPhone 16', value: 'iphone-16' },
        { label: 'iPhone 16e', value: 'iphone-16e' },
        { label: 'iPhone 16 Pro Max', value: 'iphone-16pm' },
    ],
    SKU: [
        { label: 'iPhone 16 - Black-256GB-Wifi', value: 'sku-b256' },
        { label: 'iPhone 16 - Black-512GB-Wifi', value: 'sku-b512' },
        { label: 'iPhone 16 - Black-1TB-Wifi', value: 'sku-b1tb' },
    ],
};

const renderLabel = (label) => {
    const parts = label.split(' - ');
    if (parts.length === 2) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: '#6C757D', fontSize: '12px', marginBottom: '5px' }}>{parts[0]}</span>
                <span style={{ fontSize: '14px' }}>{parts[1]}</span>
            </div>
        );
    }
    return label;
};

const portalRoot = document.getElementById('portal-root');
const OptionPortal = ({ children, style }) =>
    createPortal(
        <div className="options-container main-company-body-inner" style={{ ...style, overflow: 'visible', zIndex: 999, marginTop: '10px' }}>
            {children}
        </div>,
        portalRoot
    );

export default function AddSpu() {
    const history = useHistory();
    const location = useLocation();
    const fileInputRef = useRef(null);
    const tableRef = useRef(null);

    const [userSwitchedTab, setUserSwitchedTab] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const PAGE_SIZE = 10;

    const [uploadedImages, setUploadedImages] = useState([]);
    const [isDragging, setIsDragging] = useState(false);

    const [brands, setBrands] = useState([]);
    const [spus, setSpus] = useState(() => getSpuNamesCache() || []);
    const [spusLoading, setSpusLoading] = useState(() => getSpuNamesCache() === null);
    const [configImages, setConfigImages] = useState({});
    const [configNotes, setConfigNotes] = useState({});
    const [categories, setCategories] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [validationError, setValidationError] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [spuid, setSpuId] = useState('')
    const [showMissingVariationError, setShowMissingVariationError] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [tempParentCategorySearchTerm, setTempParentCategorySearchTerm] = useState("");
    const [tempSearchParentCategory, setTempSearchParentCategory] = useState([]);
    const [parentCategoryDropdownOpen, setParentCategoryDropdownOpen] = useState(false);
    const [skuAttributeOptions, setSkuAttributeOptions] = useState([]);
    const [productType, setProductType] = useState([]);
    const [configImageErrors, setConfigImageErrors] = useState({});
    const [skuNameErrors, setSkuNameErrors] = useState({});
    const [stepData, setStepData] = useState({
        spuData: {},
        skuData: {},
        skuConfigurationsData: {},
        skuCodeData: {},
    });
    const [variationErrors, setVariationErrors] = useState({});
    const [configErrors, setConfigErrors] = useState({});
    const [notification, setNotification] = useState({
        show: false,
        type: '',
        action: '',
        recordName: '',
        message:''
    });

    const [formData, setFormData] = useState({
        model_name: '',
        prefix: '',
        model_id: '',
        status: '1',
        set_type: '',
        brand_id: '',
        category_id: '',
        release_date: '',
        images: [],
        customised: [],
        notes: '',
    });

    const [errors, setFormErrors] = useState({
        model_name: '',
        model_id: '',
        brand_id: '',
        category_id: '',
        set_type: '',
        uploaded_images: ''
    });
    const [rows, setRows] = useState([]);
    const [rows2, setRows2] = useState([]);
    const [skuCodeRows, setSkuCodeRows] = useState([]);
    const [rowsCf, setRowsCf] = useState({});
    const [rows3, setRows3] = useState([]);

    const totalItems = skuCodeRows.length;
    const totalPages = Math.ceil(totalItems / PAGE_SIZE);
    const startIndex = (currentPage - 1) * PAGE_SIZE;
    const endIndex = Math.min(startIndex + PAGE_SIZE, totalItems);

    const paginatedRows = skuCodeRows.slice(startIndex, endIndex);
    
    const [showItemAlert, setShowItemAlert] = useState(false);
    const [alert, setAlert] = useState({ message: "", type: "" });
    
    const [showConfigTable, setShowConfigTable] = useState(false);
// Add this ref at the top of your component with other refs
const prevRows2Ref = useRef('');

// This useEffect should replace your existing useEffect that depends on rows2 for SKU generation
useEffect(() => {
    if (!isDirty) setIsDirty(true);
    
    // Check if variations were reordered (not just values changed)
    const currentVariationIds = rows2.map(r => r.fieldName).join('-');
    const prevVariationIds = prevRows2Ref.current || '';
    
    // Flag to determine if we should regenerate SKUs
    let shouldRegenerate = false;
    
    if (currentVariationIds !== prevVariationIds) {
        // Variations were reordered or changed, clear all manual edits
        setSkuCodeRows(prev => prev.map(row => ({
            ...row,
            isManuallyEdited: false
        })));
        shouldRegenerate = true;
    }
    
    prevRows2Ref.current = currentVariationIds;
    
    // Create a map of valid variation options for each attribute
    const validOptionsMap = {};
    rows2.forEach(variation => {
        if (variation.fieldName) {
            validOptionsMap[variation.fieldName] = new Set(
                variation.opts.map(opt => String(opt.value))
            );
        }
    });
    
    // Clean up rows3 (configurations) to remove invalid options
    const updatedRows3 = rows3.map(row => {
        if (!row.opts) return row;
        
        const cleanedOpts = {};
        Object.entries(row.opts).forEach(([attrId, optionIds]) => {
            const validOptions = validOptionsMap[attrId];
            if (validOptions) {
                // Filter out options that are no longer valid
                const filteredOptions = optionIds.filter(optId => 
                    validOptions.has(String(optId))
                );
                if (filteredOptions.length > 0) {
                    cleanedOpts[attrId] = filteredOptions;
                }
            }
        });
        
        return {
            ...row,
            opts: cleanedOpts
        };
    });
    
    // Update rows3 if any changes were made
    if (JSON.stringify(updatedRows3) !== JSON.stringify(rows3)) {
        setRows3(updatedRows3);
    }
    
    // Also clean up skuCodeRows if configurations exist
    if (rows3.length > 0 && skuCodeRows.length > 0) {
        // Filter skuCodeRows that have invalid variation combinations
        const validSkuCodeRows = skuCodeRows.filter(skuRow => {
            if (!skuRow.values) return true;
            
            // Check if all values in this SKU row are still valid
            return Object.entries(skuRow.values).every(([attrId, optionId]) => {
                const validOptions = validOptionsMap[attrId];
                return validOptions && validOptions.has(String(optionId));
            });
        });
        
        if (validSkuCodeRows.length !== skuCodeRows.length) {
            setSkuCodeRows(validSkuCodeRows);
            shouldRegenerate = true;
        }
    }
    
    // Check if any SKU code has been manually edited
    const hasManualEdits = skuCodeRows.some(row => row.isManuallyEdited);
    
    // Only regenerate if no manual edits exist OR variations were reordered
    if (!hasManualEdits || shouldRegenerate) {
        const generatedRows = generateCombinationsFromVariations(
            rows2,
            skuAttributeOptions,
            skuCodeRows
        );
        
        // If rows3 is empty (configurations skipped), we need to handle it differently
        if (rows3.length === 0 && generatedRows.length > 0) {
            // Add a default configuration temp key for all rows
            const rowsWithDefaultConfig = generatedRows.map(row => ({
                ...row,
                configuration_temp_key: 'default-config',
                // Make sure all required fields are present
                values: row.values || {},
                variationNames: row.variationNames || []
            }));
            setSkuCodeRows(rowsWithDefaultConfig);
        } else {
            setSkuCodeRows(generatedRows);
        }
    }
    
    // ✅ CRITICAL: Validate configurations when variations change
    // This will show errors in step 3 when user returns to it
    if (rows3.length > 0) {
    const validVariations = rows2.filter(v =>
        v.fieldName && v.opts && v.opts.length > 0
    );

    if (validVariations.length > 0) {
        const newConfigErrors = { ...configErrors };

        // --- Pass 1: missing / incomplete options ---
        rows3.forEach(config => {
            const selectedOptions = config.opts || {};

            let allGroupsHaveOptions = true;
            let noGroupsHaveOptions = true;

            validVariations.forEach(variationRow => {
                const attrId = variationRow.fieldName;
                const optionsForAttr = selectedOptions[attrId];

                if (optionsForAttr && Array.isArray(optionsForAttr) && optionsForAttr.length > 0) {
                    noGroupsHaveOptions = false;
                } else {
                    allGroupsHaveOptions = false;
                }
            });

            // Clear previous options error before re-evaluating
            if (newConfigErrors[config.id]) {
                delete newConfigErrors[config.id].options;
            }

            const hadPreviousOptions = config.opts && Object.keys(config.opts).length > 0;

            if (noGroupsHaveOptions) {
                if (hadPreviousOptions) {
                    // Config had options before but now all are invalid — force show error
                    newConfigErrors[config.id] = {
                        ...(newConfigErrors[config.id] || {}),
                        options: "Configuration Options are required",
                        _touched: true,
                        _options_force_show: true,
                    };
                }
                // If never had options, don't set any error — user hasn't interacted yet
            } else if (!allGroupsHaveOptions) {
                // Config has SOME options but not all variations covered — always show this
                newConfigErrors[config.id] = {
                    ...(newConfigErrors[config.id] || {}),
                    options: "Each Variation must have at least one option selected.",
                    _touched: true,
                    _options_force_show: true,
                };
            }
        });

        // --- Pass 2: overlapping configs ---
        const configsWithFullOptions = rows3.filter(config => {
            const selectedOptions = config.opts || {};
            return validVariations.every(variationRow => {
                const optionsForAttr = selectedOptions[variationRow.fieldName];
                return optionsForAttr && Array.isArray(optionsForAttr) && optionsForAttr.length > 0;
            });
        });

        if (configsWithFullOptions.length > 1) {
            for (let i = 0; i < configsWithFullOptions.length; i++) {
                for (let j = i + 1; j < configsWithFullOptions.length; j++) {
                    const configA = configsWithFullOptions[i];
                    const configB = configsWithFullOptions[j];

                    let allAttributesOverlap = true;

                    validVariations.forEach(variationRow => {
                        const attrId = variationRow.fieldName;
                        const optionsA = configA.opts[attrId] || [];
                        const optionsB = configB.opts[attrId] || [];
                        if (!optionsA.some(o => optionsB.includes(o))) {
                            allAttributesOverlap = false;
                        }
                    });

                    if (allAttributesOverlap) {
                        newConfigErrors[configA.id] = {
                            ...(newConfigErrors[configA.id] || {}),
                            options: "Please remove the overlapping Options",
                            _touched: true,
                            _options_force_show: true,
                        };
                        newConfigErrors[configB.id] = {
                            ...(newConfigErrors[configB.id] || {}),
                            options: "Please remove the overlapping Options",
                            _touched: true,
                            _options_force_show: true,
                        };
                    }
                }
            }
        }

        // Clean up entries that now have no actual errors
        Object.keys(newConfigErrors).forEach(key => {
            const entry = newConfigErrors[key];
            const hasRealError = Object.keys(entry).some(
                k => k !== '_touched' && k !== '_options_force_show' && entry[k]
            );
            if (!hasRealError) {
                delete newConfigErrors[key];
            }
        });

        setConfigErrors(newConfigErrors);
    } else {
        // No valid variations left — clear all config option errors
        setConfigErrors(prev => {
            const updated = { ...prev };
            Object.keys(updated).forEach(key => {
                if (updated[key]?.options) {
                    delete updated[key].options;
                    delete updated[key]._touched;
                    delete updated[key]._options_force_show;
                    if (Object.keys(updated[key]).length === 0) {
                        delete updated[key];
                    }
                }
            });
            return updated;
        });
    }
}
}, [rows2]); // Only depend on rows2 (variations)
const handleChange = (e) => {
    if (!isDirty) setIsDirty(true);
    const name = e.target?.name || e.currentTarget?.name;
    const value = e.target?.value || e.currentTarget?.value;

    if (name) {
        setFormData(prev => ({ ...prev, [name]: value }));
    }
};

  const handleChangeConfigNote = (value, tabKey) => {
    if (!isDirty) setIsDirty(true);
    setConfigNotes(prev => ({
        ...prev,
        [tabKey]: value
    }));
};

    useEffect(() => {
        return () => {
            uploadedImages.forEach(img => URL.revokeObjectURL(img.preview));
        };
    }, []);

    const handleBrowseClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    
    const [discardModalOpen, setDiscardModalOpen] = useState(false);
    const discardRef = useRef(null);
    
  const handleDiscard = (e) => {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    
    if (isDirty && !isSaving) {
        setDiscardModalOpen(true);
    } else {
        history.goBack();
    }
};
    
    const handleDiscardConfirm = (confirm) => {
        if (confirm) {
            setFormData({
                model_name: '',
                prefix: '',
                model_id: '',
                status: '1',
                set_type: '',
                brand_id: '',
                category_id: '',
                release_date: '',
                images: [],
                customised: [],
                notes: '',
            });
            
            setUploadedImages([]);
            setRows([]);
            setRows2([]);
            setRows3([]);
            setSkuCodeRows([]);
            setRowsCf({});
            setConfigImages({});
            setConfigNotes({});
            setStepData({
                spuData: {},
                skuData: {},
                skuConfigurationsData: {},
                skuCodeData: {},
            });
            setFormErrors({
                model_name: '',
                model_id: '',
                brand_id: '',
                category_id: '',
                set_type: '',
                uploaded_images: ''
            });
            setVariationErrors({});
            setConfigErrors({});
            
            setIsDirty(false);
            
            history.goBack();
        }
        setDiscardModalOpen(false);
    };

    const handleCancelDiscard = () => {
        setDiscardModalOpen(false);
    };
    const [skuCodeErrors, setSkuCodeErrors] = useState({});
    // Add this validation function
const validateSkuCodes = () => {
    const newErrors = {};
    let hasErrors = false;
    const seenCodes = {};
    
    skuCodeRows.forEach((row, index) => {
        if (!row.sku_code?.trim()) {
            newErrors[index] = "SKU Code is required";
            hasErrors = true;
        } else {
            const normalized = row.sku_code.trim().toLowerCase();
            const duplicateIndex = skuCodeRows.findIndex((r, i) => 
                i !== index && r?.sku_code?.trim().toLowerCase() === normalized
            );
            if (duplicateIndex !== -1) {
                newErrors[index] = "SKU Code already exists";
                hasErrors = true;
            }
        }
    });
    
    setSkuCodeErrors(newErrors);
    return !hasErrors;
};

    const [skuAttr, setSkuAttr] = useState([]);

useEffect(() => {
    async function fetchSkuAbbreviations() {
        const response = await apiHelper('settings/sku-attributes-abbrevations/', 'GET');
        if (response.ok) {
            const data = await response.json();
            setSkuAttr(data);
        }
    }
    fetchSkuAbbreviations();
}, []);

useEffect(() => {
    const totalPagesNow = Math.ceil(skuCodeRows.length / PAGE_SIZE);
    
    // If current page is now out of range, move to the last valid page
    if (currentPage > totalPagesNow) {
        setCurrentPage(totalPagesNow || 1);
    }
}, [skuCodeRows.length]);
// 🔹 Get SKU abbreviations from the API
    // const [skuAttr, setSkuAttr] = useState([]);
    
    // useEffect(() => {
    //     async function fetchSkuAbbreviations() {
    //         const response = await apiHelper('settings/sku-attributes-abbrevations/', 'GET');
    //         if (response.ok) {
    //             const data = await response.json();
    //             setSkuAttr(data);
    //         }
    //     }
    //     fetchSkuAbbreviations();
    // }, []);
    const [configError, setConfigError] = useState('');

    const updateSKU = async (skuId, data) => {
        try {
            const isFormData = data instanceof FormData;
            const contentType = isFormData ? 'multipart/form-data' : 'application/json';

            const response = await apiHelper(
                `inventory/sku/${skuId}/update/`,
                'PUT',
                data,
                contentType
            );

            if (!response.ok) throw new Error('Failed to update SKU');
            return await response.json();
        } catch (error) {
            console.error('Error updating SKU:', error);
            throw error;
        }
    };
    
    useEffect(() => {
        return () => {
            Object.values(configImages).forEach(images => {
                images.forEach(img => URL.revokeObjectURL(img.preview));
            });
        };
    }, []);
    
    const [categoryHierarchy, setCategoryHierarchy] = useState([]);

    useEffect(() => {
        async function fetchBrandsData() {
            const response = await apiHelper('inventory/brands/?is_archived=false&status=true');
            if (response?.ok) {
                const result = await response.json();
                setBrands(result || []);
            }
        }
        async function fetchCategoriesData() {
            const response = await apiHelper('inventory/categories/?is_archived=false&status=true');
            if (response?.ok) {
                const result = await response.json();
                setCategories(result || []);
                const fullHierarchy = getAllHierarchies(result || []);
                setCategoryHierarchy(fullHierarchy);
            }
        }
        async function fetchSKUAttributesData() {
            const response = await apiHelper('settings/sku-attributes/');
            if (response?.ok) {
                const result = await response.json();
                setSkuAttributes(result || []);
            }
        }
        async function fetchSKUAttributesOptionData() {
            const response = await apiHelper('settings/sku-attributes/options/');
            if (response?.ok) {
                const result = await response.json();
                setSkuAttributeOptions(result || []);
            }
        }

        async function fetchProductTypeData() {
             const res = await apiHelper("settings/sku-code-generation-rules/list/", "GET");
        const result = res.ok ? await res.json() : [];
        console.log("Fetched SKU rules:", result);
        setProductType(result);
        }

        fetchSKUAttributesData();
        fetchSKUAttributesOptionData();
        fetchBrandsData();
        fetchCategoriesData();
        fetchProductTypeData();
    }, []);

    const makeImageObjects = (files) => {
    return files
        .map(file => ({
            id: Date.now() + Math.random(),
            file,
            preview: URL.createObjectURL(file),
            user_image_name: file.name // Store the original filename
        }));
};

    const handleImageChange = (e) => {
        if (!isDirty) setIsDirty(true);
        const files = Array.from(e.target.files || []);
        setFormErrors(prev => ({ ...prev, uploaded_images: "" }));
        const validationError = validateImages(files);
        if (validationError) {
            setFormErrors(prev => ({
                ...prev,
                uploaded_images: validationError
            }));
            return;
        }

        const newImgs = makeImageObjects(files);
        setUploadedImages(prev => [...prev, ...newImgs]);
        setFormErrors(prev => ({ ...prev, uploaded_images: "" }));
    };

    const allowedImageTypes = ["image/jpeg", "image/png"];
    const maxSize = 1 * 1024 * 1024;

    const handleDrop = (e) => {
        if (!isDirty) setIsDirty(true);
        e.preventDefault();
        setIsDragging(false);
        const files = Array.from(e.dataTransfer.files || []);

        setFormErrors(prev => ({ ...prev, uploaded_images: "" }));

        const validationError = validateImages(files);
        if (validationError) {
            setFormErrors(prev => ({
                ...prev,
                uploaded_images: validationError
            }));
            return;
        }

        const newImgs = makeImageObjects(files);
        setUploadedImages(prev => [...prev, ...newImgs]);
        if (newImgs.length > 0) {
            setFormErrors(prev => ({ ...prev, uploaded_images: "" }));
        }
    };

    const handleRemove = (id) => {
        if (!isDirty) setIsDirty(true);
        setUploadedImages(uploadedImages.filter(x => x.id !== id));
        if (uploadedImages.length === 1) {
            setFormErrors(prev => ({ ...prev, uploaded_images: "" }));
        }
    };

const handleConfigImageChange = (e, tabKey) => {
    if (!isDirty) setIsDirty(true);
    const files = Array.from(e.target.files || []);
    const validationError = validateImages(files);
    
    if (validationError) {
        setConfigImageErrors(prev => ({
            ...prev,
            [tabKey]: validationError
        }));
        return;
    }
    
    // Clear error if validation passes
    setConfigImageErrors(prev => {
        const updated = { ...prev };
        delete updated[tabKey];
        return updated;
    });
    
    const newImgs = makeImageObjects(files);
    
    // Ensure each image is associated with the correct tab key
    setConfigImages(prev => ({
        ...prev,
        [tabKey]: [...(prev[tabKey] || []), ...newImgs]
    }));
};
const handleConfigDrop = (e, tabKey) => {
    if (!isDirty) setIsDirty(true);
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files || []);

    const validationError = validateImages(files);
    if (validationError) {
        setConfigImageErrors(prev => ({
            ...prev,
            [tabKey]: validationError
        }));
        return;
    }
    
    // Clear error if validation passes
    setConfigImageErrors(prev => {
        const updated = { ...prev };
        delete updated[tabKey];
        return updated;
    });

    const newImgs = makeImageObjects(files);
    
    setConfigImages(prev => ({
        ...prev,
        [tabKey]: [...(prev[tabKey] || []), ...newImgs]
    }));
};
const validateConfigurationsAgainstVariations = () => {
    const validVariations = rows2.filter(v => 
        v.fieldName && v.opts && v.opts.length > 0
    );
    
    const newConfigErrors = { ...configErrors };
    
    rows3.forEach(config => {
        const rowErrors = {};
        const selectedOptions = config.opts || {};
        
        // Check if each variation has at least one option selected
        let allGroupsHaveOptions = true;
        let noGroupsHaveOptions = true;
        
        validVariations.forEach(variationRow => {
            const attrId = variationRow.fieldName;
            const optionsForAttr = selectedOptions[attrId];
            
            if (optionsForAttr && Array.isArray(optionsForAttr) && optionsForAttr.length > 0) {
                noGroupsHaveOptions = false;
            } else {
                allGroupsHaveOptions = false;
            }
        });
        
        if (noGroupsHaveOptions) {
            rowErrors.options = 'Configuration Options are required';
        } else if (!allGroupsHaveOptions) {
            rowErrors.options = `Each Variation must have at least one option selected.`;
        }
        
        // Update errors
        if (Object.keys(rowErrors).length > 0) {
            newConfigErrors[config.id] = {
                ...newConfigErrors[config.id],
                ...rowErrors,
                _touched: true
            };
        } else {
            // Clear errors if all valid
            delete newConfigErrors[config.id];
        }
    });
    
    setConfigErrors(newConfigErrors);
    return Object.keys(newConfigErrors).length === 0;
};
 const handleConfigRemove = (id, tabKey) => {
    if (!isDirty) setIsDirty(true);
    setConfigImages(prev => {
        const tabImages = prev[tabKey] || [];
        const updatedTabImages = tabImages.filter(x => x.id !== id);
        
        // If there are no images left, remove the entire key
        if (updatedTabImages.length === 0) {
            const { [tabKey]: _, ...rest } = prev;
            return rest;
        }
        
        return {
            ...prev,
            [tabKey]: updatedTabImages
        };
    });
};

    const formatSize = size => {
        const mb = size / (1024 * 1024);
        return `${mb.toFixed(1)}mb`;
    };

function generateCombinationsFromVariations(
    rows2Data,
    skuAttributeOptions,
    existingSkuRows = []
) {
    if (!rows2Data?.length || !stepData?.spuData) return [];

    const { spuData } = stepData;

    // 🔹 Debug logging
    console.log("🔍 Debug SKU Generation:");
    console.log("SPU Data:", spuData);
    console.log("Product Types:", productType);
    console.log("SPU Set Type:", spuData.set_type);
    console.log("Rows3 (Configurations):", rows3.length);

    // 🔹 Find SKU rule by product_type
    const rule = productType.find(
        r => r.product_type && r.product_type.trim().toLowerCase() === 
             (spuData.set_type || '').trim().toLowerCase()
    );
    
    const scheme = rule?.scheme || "{BrandPrefix}{CategoryPrefix}{SPUPrefix}{SKUAbbr}";
    
    console.log("Selected Rule:", rule);
    console.log("Scheme:", scheme);

    // 🔹 Prefixes with fallbacks
    const brandPrefix = brands.find(b => b.brand_id === spuData.brand_id)?.prefix || "";
    const categoryPrefix = categories.find(c => c.category_id === spuData.category_id)?.prefix || "";
    const spuPrefix = spuData.prefix || "";

    console.log("Prefixes:", { brandPrefix, categoryPrefix, spuPrefix });

    // 🔹 Variations - preserve the order as they appear in rows2Data
    const variations = rows2Data
        .filter(r => r.fieldName && r.opts?.length)
        .map(r => ({
            attributeId: String(r.fieldName),
            attributeName: r.fieldNameLabel,
            options: r.opts.map(o => ({
                id: String(o.value),
                name: o.label
            }))
        }));

    console.log("Variations (in order):", variations);

    if (!variations.length) return [];

    // 🔹 Cartesian product - maintain variation order
    let combinations = [{}];
    variations.forEach(v => {
        const temp = [];
        combinations.forEach(c => {
            v.options.forEach(o => {
                temp.push({ ...c, [v.attributeId]: o.id });
            });
        });
        combinations = temp;
    });

    console.log("Combinations:", combinations);

    const result = combinations.map((combo, index) => {
        const values = {};
        const nameParts = [];
        const orderedValues = [];

        // 🔹 Build values map and name parts FOLLOWING VARIATION ORDER
        variations.forEach(v => {
            const optionId = combo[v.attributeId];
            values[v.attributeId] = optionId;
            orderedValues.push(optionId);

            const opt = v.options.find(o => o.id === optionId);
            if (opt) nameParts.push(opt.name);
        });

        // 🔥 BUILD SKUAbbr ONLY FROM skuAttr - MAINTAIN VARIATION ORDER
        // 🔥 BUILD SKUAbbr - MAINTAIN VARIATION ORDER
let skuAbbr = "";

// Get abbreviations in the SAME ORDER as variations
variations.forEach(v => {
    const optionId = values[v.attributeId];
    if (optionId) {
        const matchedAbbr = skuAttr.find(a => 
            String(a.sku_preset_option_id) === String(optionId)
        );
        
        if (matchedAbbr) {
            let abbreviationOrName = (matchedAbbr.sku_preset_option_abbreviation && 
                matchedAbbr.sku_preset_option_abbreviation.trim() !== '') 
                ? matchedAbbr.sku_preset_option_abbreviation.trim() 
                : matchedAbbr.sku_preset_option_name;
            
            // Remove spaces and hyphens
            skuAbbr += abbreviationOrName.replace(/[\s-]/g, '');
        }
        // 👇 NEW FALLBACK: If no abbreviation mapping exists, use the option name from SKU Name
        else {
            // Find the option in the variation data
            const option = v.options.find(o => o.id === optionId);
            if (option) {
                // Use the option name (same as what goes into SKU Name)
                let namePart = option.name;
                // Remove spaces and hyphens to keep SKU Code clean
                skuAbbr += namePart.replace(/[\s-]/g, '');
            }
        }
    }
});

        console.log("SKU Abbr:", skuAbbr);

        // 🔹 Match existing SKU
        const existing = existingSkuRows.find(r =>
            r.values &&
            JSON.stringify(normalizeValues(r.values)) ===
            JSON.stringify(normalizeValues(values))
        );

        // 🔹 Apply scheme
        const skuCode = applySkuScheme(scheme, {
            BrandPrefix: brandPrefix,
            CategoryPrefix: categoryPrefix,
            SPUPrefix: spuPrefix,
            SKUAbbr: skuAbbr,
        });

        console.log("Final SKU Code:", skuCode);

        return {
            sku_id: existing?.sku_id,
            id: existing?.id ?? index + 1,
            name: nameParts.join("-"), // Already in correct order
            sku_code: skuCode,
            status: existing?.status ?? "1",
            gtin: existing?.gtin ?? "",
            msrp: existing?.msrp ?? "",
            values,
            variationNames: variations.map(v => v.attributeName),
            _open: existing?._open ?? false,
            _dropdownPos: existing?._dropdownPos ?? null,
            isManuallyEdited: existing?.isManuallyEdited ?? false,
            configuration_temp_key: existing?.configuration_temp_key || null
        };
    });

    console.log("Final Result:", result);
    return result;
}

function normalizeValues(obj = {}) {
    return Object.keys(obj)
        .sort()
        .reduce((acc, key) => {
            acc[String(key)] = String(obj[key]);
            return acc;
        }, {});
}
const generateSkuName = (values, variations) => {
    const nameParts = [];
    
    // Follow the exact order of variations from rows2
    variations.forEach(variation => {
        const optionId = values[variation.attributeId];
        if (optionId) {
            const option = variation.options.find(o => o.id === optionId);
            if (option) {
                nameParts.push(option.name);
            }
        }
    });
    
    return nameParts.join("-");
};
function cleanSkuCode(code) {
    if (!code) return "";
    
    // Remove spaces, hyphens, and other unwanted characters
    return code.replace(/[\s-]/g, '');
}

// Update the applySkuScheme function
function applySkuScheme(scheme, data) {
    if (!scheme) return "";
    
    console.log("Applying scheme:", { scheme, data });
    
    const result = scheme.replace(
        /\{(\w+)\}/g,
        (_, key) => {
            let value = data[key] || "";
            
            // Clean SKUAbbr specifically
            if (key === 'SKUAbbr') {
                value = value.replace(/[\s-]/g, '');
            }
            
            console.log(`Placeholder {${key}}:`, value);
            return value;
        }
    );
    
    console.log("Scheme result:", result);
    return result.trim();
}
    function generateCombinationsForOpts(opts) {
        const keys = Object.keys(opts);

        let result = [{}];

        keys.forEach(key => {
            const temp = [];
            const values = opts[key];

            result.forEach(combo => {
                values.forEach(value => {
                    temp.push({ ...combo, [key]: value });
                });
            });

            result = temp;
        });
        const newResult = [];
        result.forEach((r, key) => {
            if (!newResult[key]) newResult[key] = {};
            newResult[key]['values'] = r;
            let name = '';
            Object.keys(r).map((optionID) => {
                name += (skuAttributeOptions?.find(ao => ao?.sku_preset_option_id == r[optionID])?.sku_preset_option_name || '') + '-';
            });
            newResult[key]['name'] = name.slice(0, -1);
            newResult[key]['sku_code'] = '';
            newResult[key]['status'] = '1';
            newResult[key]['gtin'] = '';
            newResult[key]['msrp'] = '';
        });
        return newResult;
    }

    function generateCombinations(variations) {
        if (!variations?.length) return [];
        const configs = variations.map(conf => {
            const combos = generateCombinationsForOpts(conf.opts);

            return {
                ...conf,
                combinations: combos
            };
        });
        return configs;
    }
const validateSkuNames = (isSaveOperation = false) => {
    let hasErrors = false;
    
    if (isSaveOperation) {
        // For SAVE operation: Show errors on ALL duplicate rows while preserving existing errors
        const nameToIndices = {}; // Map name to array of indices
        const newErrors = { ...skuNameErrors }; // Start with existing errors
        
        // First pass: collect all names and their indices
        skuCodeRows.forEach((row, index) => {
            if (row.name?.trim()) {
                const normalizedName = row.name.trim().toLowerCase();
                if (!nameToIndices[normalizedName]) {
                    nameToIndices[normalizedName] = [];
                }
                nameToIndices[normalizedName].push(index);
            }
        });
        
        // Second pass: find duplicates and mark ALL indices with that name
        Object.values(nameToIndices).forEach(indices => {
            if (indices.length > 1) {
                // This name appears multiple times - mark ALL occurrences
                indices.forEach(index => {
                    newErrors[index] = "SKU Name already exists";
                    hasErrors = true;
                });
            }
        });
        
        // Check for empty names (these are separate from duplicates)
        skuCodeRows.forEach((row, index) => {
            if (!row.name?.trim() && !newErrors[index]) {
                newErrors[index] = "SKU Name is required";
                hasErrors = true;
            } else if (!row.name?.trim() && newErrors[index]) {
                // If it's already marked with some other error, keep it
                hasErrors = true;
            }
        });
        
        setSkuNameErrors(newErrors);
        return !hasErrors;
    } else {
        // For regular validation (not save operation), we don't do anything
        // This is handled by onBlur
        return true;
    }
};

    useEffect(() => {
        function handleClickOutside(event) {
            if (discardRef.current && !discardRef.current.contains(event.target)) {
                setDiscardModalOpen(false);
            }
        }
        if (discardModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [discardModalOpen]);

    const rowRefs3 = useRef({});
    const prevRows3 = useRef(rows3);

 useEffect(() => {
    if (!isDirty) setIsDirty(true);
    
    // Check if any SKU code has been manually edited
    const hasManualEdits = skuCodeRows.some(row => row.isManuallyEdited);
    
    if (!hasManualEdits) {
        // Only regenerate if no manual edits exist
        const generatedRows = generateCombinationsFromVariations(
            rows2,
            skuAttributeOptions,
            skuCodeRows
        );
        
        // If rows3 is empty (configurations skipped), we need to handle it differently
        if (rows3.length === 0 && generatedRows.length > 0) {
            // Add a default configuration temp key for all rows
            const rowsWithDefaultConfig = generatedRows.map(row => ({
                ...row,
                configuration_temp_key: 'default-config',
                // Make sure all required fields are present
                values: row.values || {},
                variationNames: row.variationNames || []
            }));
            setSkuCodeRows(rowsWithDefaultConfig);
        } else {
            setSkuCodeRows(generatedRows);
        }
    }
}, [rows2, skuAttributeOptions, rows3.length]); // Add rows3.length to dependencies
//     useEffect(() => {
//     if (!isDirty) setIsDirty(true);
    
//     // Check if any SKU code has been manually edited
//     const hasManualEdits = skuCodeRows.some(row => row.isManuallyEdited);
    
//     if (!hasManualEdits) {
//         // Regenerate SKUs with current variation order
//         const generatedRows = generateCombinationsFromVariations(
//             rows2, // This now has the updated order
//             skuAttributeOptions,
//             skuCodeRows
//         );
        
//         setSkuCodeRows(generatedRows);
//     }
// }, [rows2, skuAttributeOptions]);

    const addRow3 = () => {
        // if (isAddConfigDisabled) return;
        if (!isDirty) setIsDirty(true);
        const newId = rows3.length ? Math.max(...rows3.map(r => r.id)) + 1 : 1;
        setRows3([...rows3, {
            id: newId,
            uniqueKey: `cf-${newId}-${Date.now()}`,
            fieldName: '',
            opts: {},
            isOpen: false
        }]);
    };
    
    const deleteRow3 = id => {
        if (!isDirty) setIsDirty(true);
        const rowToDelete = rows3.find(r => r.id === id);
        if (!rowToDelete) return;

        setConfigErrors((prev) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
        });

        if (rows3.length <= 1) {
            setRows3([]);
        } else {
            setRows3(rows3.filter(r => r.id !== id));
        }

        if (rowToDelete.uniqueKey) {
            setRowsCf(prev => {
                const updated = { ...prev };
                delete updated[rowToDelete.uniqueKey];
                return updated;
            });

            setConfigNotes(prev => {
                const updated = { ...prev };
                delete updated[rowToDelete.uniqueKey];
                return updated;
            });

            setConfigImages(prev => {
                const updated = { ...prev };
                delete updated[rowToDelete.uniqueKey];
                return updated;
            });
        }
    };

    const updateRow3 = (id, changes) => {
    // Only clear config errors if the field being changed might fix the error
    if (changes.fieldName !== undefined && configErrors[id]?.fieldName) {
        setConfigErrors(prev => {
            const updated = { ...prev };
            if (updated[id]) {
                delete updated[id].fieldName;
                if (Object.keys(updated[id]).length === 0) {
                    delete updated[id];
                }
            }
            return updated;
        });
    }
    
    setRows3(rows3.map(r => (r.id === id ? { ...r, ...changes } : r)));
}

    useEffect(() => {
        const handler = e => {
            const inPortal = portalRoot?.contains(e.target);
            setRows3(rs =>
                rs.map(r => {
                    const el = rowRefs3.current[r.id]?.current;
                    if (!inPortal && el && !el.contains(e.target)) {
                        return { ...r, isOpen: false };
                    }
                    return r;
                })
            );
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);
    
    const [isAddVariationDisabled, setIsAddVariationDisabled] = useState(false);
    const [isAddConfigDisabled, setIsAddConfigDisabled] = useState(false);
    const [allCompatibility, setAllCompatibility] = useState([
        { role_name: 'iPhone 16 Pro', id: '1' },
        { role_name: 'iPhone 16e', id: '2' },
        { role_name: 'iPhone 16 Pro Max', id: '3' },
        { role_name: 'iPhone 16', id: '4' },
    ]);

    useEffect(() => {
        if (rows2.length > 0) {
            const lastRow = rows2[rows2.length - 1];
            setIsAddVariationDisabled(!lastRow.fieldName || lastRow.opts.length === 0);
        } else {
            setIsAddVariationDisabled(false);
        }
    }, [rows2]);

    useEffect(() => {
        if (rows3.length > 0) {
            const lastRow = rows3[rows3.length - 1];
            const hasName = lastRow.fieldName?.trim().length > 0;
            const hasOptions = Object.keys(lastRow.opts || {}).length > 0;
            setIsAddConfigDisabled(!(hasName && hasOptions));
        } else {
            setIsAddConfigDisabled(false);
        }
    }, [rows3]);

    const [activeTab2, setActiveTab2] = useState('edit-spu');
    const breadcrumbs = ["Product", "SPU & SKU", "Add SPU & SKU"];

    const rowRefs = useRef({});
    const [isAddCustomDisabled, setIsAddCustomDisabled] = useState(false);
    const [isAddCustomDisabledCf, setIsAddCustomDisabledCf] = useState({});

    useEffect(() => {
        if (rows.length > 0) {
            const lastRow = rows[rows.length - 1];
            setIsAddCustomDisabled(!lastRow.fieldName.trim() || (lastRow.fieldType === 'Text' && !lastRow.value.trim()));
        } else {
            setIsAddCustomDisabled(false);
        }
    }, [rows]);

    useEffect(() => {
        const updateAddCustomFieldsCf = {};

        Object.keys(rowsCf).forEach((cfKey) => {
            const rows = rowsCf[cfKey];

            if (!Array.isArray(rows) || rows.length === 0) {
                updateAddCustomFieldsCf[cfKey] = false;
                return;
            }

            const lastRow = rows[rows.length - 1];

            if (!lastRow) {
                updateAddCustomFieldsCf[cfKey] = false;
                return;
            }

            updateAddCustomFieldsCf[cfKey] =
                !lastRow.fieldName?.trim() ||
                (lastRow.fieldType === 'Text' && !lastRow.value?.trim());
        });

        setIsAddCustomDisabledCf(updateAddCustomFieldsCf);
    }, [rowsCf]);

    const addRow = () => {
        if (!isDirty) setIsDirty(true);
        if (rows.length === 0) {
            setRows([{
                id: 1,
                fieldName: '',
                fieldType: 'Text',
                refChild: '',
                value: '',
                opts: [],
                typeOpen: false,
                refMenuOpen: false,
                isOpen: false,
                search: ''
            }]);
            setShowTable(true);
        } else {
            const newId = Math.max(...rows.map(r => r.id)) + 1;
            setRows([...rows, {
                id: newId,
                fieldName: '',
                fieldType: 'Text',
                refChild: '',
                value: '',
                opts: [],
                typeOpen: false,
                refMenuOpen: false,
                isOpen: false,
                search: ''
            }]);
        }
    };

const addRowCf = (tabID) => {
    if (!isDirty) setIsDirty(true);
    setRowsCf(prev => {
        const existingRows = prev[tabID] ?? [];
        
        const newId = existingRows.length ? Math.max(...existingRows.map(r => r.id)) + 1 : 1;
        const newRow = {
            id: newId,
            fieldName: '',
            fieldType: 'Text',
            refChild: '',
            value: '',
            opts: [],
            typeOpen: false,
            refMenuOpen: false,
            isOpen: false,
            search: '',
            error: '',
            valueError: ''
        };

        return {
            ...prev,
            [tabID]: [...existingRows, newRow]
        };
    });
};


// Update the useEffect that calculates isAddCustomDisabledCf:
    useEffect(() => {
    const updateAddCustomFieldsCf = {};

    Object.keys(rowsCf).forEach((cfKey) => {
        const rows = rowsCf[cfKey];

        if (!Array.isArray(rows) || rows.length === 0) {
            updateAddCustomFieldsCf[cfKey] = false; // Allow adding when no rows
            return;
        }

        const lastRow = rows[rows.length - 1];

        if (!lastRow) {
            updateAddCustomFieldsCf[cfKey] = false; // Allow adding
            return;
        }

        // Only disable if last row has actual errors, not just empty fields
        const hasFieldNameError = lastRow.error?.includes("Field Name");
        const hasFieldValueError = lastRow.valueError?.includes("Field Value");
        
        updateAddCustomFieldsCf[cfKey] = hasFieldNameError || hasFieldValueError;
    });

    setIsAddCustomDisabledCf(updateAddCustomFieldsCf);
}, [rowsCf]);

    const deleteRow = id => {
    if (!isDirty) setIsDirty(true);
    const newRows = rows.filter(r => r.id !== id);
    setRows(newRows);

    // Clear errors for the deleted row
    setFormErrors(prev => {
        const updated = { ...prev };
        delete updated[id];
        return updated;
    });

    if (newRows.length === 0) {
        setShowTable(false);
        // Clear all custom field errors
        const newErrors = { ...errors };
        Object.keys(newErrors).forEach(key => {
            if (typeof newErrors[key] === 'object' && newErrors[key] !== null) {
                delete newErrors[key];
            }
        });
        setFormErrors(newErrors);
    }
};

    const deleteRowCf = (id, tabID) => {
        if (!isDirty) setIsDirty(true);
        setRowsCf(prev => ({
            ...prev,
            [tabID]: prev[tabID].filter(r => r.id !== id)
        }));
    };

    const updateRowBulk = (id, changes) => {
        if (!isDirty) setIsDirty(true);
        setRows(rows.map(r => r.id === id ? { ...r, ...changes } : r));
    };

    const updateRowBulkCf = (id, changes, tabID) => {
        if (!isDirty) setIsDirty(true);
        setRowsCf(prev => ({
            ...prev,
            [tabID]: prev[tabID].map(r =>
                r.id === id ? { ...r, ...changes } : r
            )
        }));
    };

    useEffect(() => {
        const handler = e => {
            const inPortal = portalRoot?.contains(e.target);
            setRows(rs => rs.map(r => {
                const el = rowRefs.current[r.id]?.current;
                if (!inPortal && el && !el.contains(e.target)) {
                    return { ...r, typeOpen: false, refMenuOpen: false, isOpen: false };
                }
                return r;
            }));
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const [showMissingSku, setShowMissingSku] = useState(false);

    useEffect(() => {
        if (rows.length === 0) {
            setShowMissingSku(false);
        }
    }, [rows.length]);

    const archivedRef = useRef(null);
    const [archivedModalOpen, setArchivedModalOpen] = useState(false);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);

    const handleArchivedConfirm = () => {
        setArchivedModalOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (archivedRef.current && !archivedRef.current.contains(event.target)) {
                setArchivedModalOpen(false);
            }
        }

        if (archivedModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [archivedModalOpen]);

    const [skuAttributes, setSkuAttributes] = useState([]);

    const rowRefs2 = useRef({});
    const [showMissingVar, setShowMissingVar] = useState(false);

    useEffect(() => {
        if (rows2.length === 0) setShowMissingVar(false);
    }, [rows2.length]);

    const addRow2 = () => {
        //commented, add sku button should be enable all time
        // if (isAddVariationDisabled) return;
        if (!isDirty) setIsDirty(true);
        // const lastRow = rows2[rows2.length - 1];
        // if (rows2.length > 0 && (!lastRow.fieldName || lastRow.opts.length === 0)) {
        //     return;
        // }
        const newId = rows2.length > 0 ? Math.max(...rows2.map(r => r.id)) + 1 : 1;
        setRows2([...rows2, { id: newId, fieldName: '', opts: [], isOpen: false, search: '' }]);
    };

    const deleteRow2 = id => {
        if (!isDirty) setIsDirty(true);
        if (rows2.length <= 1) {
            setRows2([{ id: 1, fieldName: '', opts: [], isOpen: false, search: '' }]);
            setVariationErrors(prev => {
                const updated = { ...prev };
                delete updated[id];
                return updated;
            });
        } else {
            setRows2(rows2.filter(r => r.id !== id));
        }
    };

const updateRow2 = (id, changes) => {
    if (!isDirty) setIsDirty(true);
    
    // Update the row
    const updatedRows2 = rows2.map(r => (r.id === id ? { ...r, ...changes } : r));
    setRows2(updatedRows2);
    
    // Get the updated row
    const updatedRow = updatedRows2.find(r => r.id === id);
    
    // Only clear existing errors when user makes changes
    if (variationErrors[id]) {
        setVariationErrors(prev => {
            const updated = { ...prev };
            
            if (updated[id]) {
                // Clear fieldName error if fieldName is being set
                if (changes.fieldName !== undefined && changes.fieldName && changes.fieldName.trim()) {
                    // Check for duplicates
                    const isDuplicate = updatedRows2.some(r =>
                        r.id !== id && r.fieldName === changes.fieldName
                    );
                    
                    if (!isDuplicate) {
                        delete updated[id].fieldName;
                    } else {
                        updated[id].fieldName = "SKU Variation already exists";
                    }
                }
                
                // Clear options error if options are being added
                if (changes.opts !== undefined && changes.opts && changes.opts.length > 0) {
                    delete updated[id].options;
                }
                
                // Remove the entire entry if no errors left
                if (Object.keys(updated[id]).length === 0) {
                    delete updated[id];
                }
            }
            
            return updated;
        });
    }
};

    useEffect(() => {
        const handler = e => {
            const inPortal = portalRoot?.contains(e.target);
            setRows2(rs =>
                rs.map(r => {
                    const el = rowRefs2.current[r.id]?.current;
                    if (!inPortal && el && !el.contains(e.target)) {
                        return { ...r, isOpen: false };
                    }
                    return r;
                })
            );
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const currentRowsEmpty =
        activeTab2 === 'sku-variations'
            ? rows2.length === 0
            : activeTab2 === 'sku-configurations'
                ? false
                : activeTab2 === 'sku-code'
                    ? skuCodeRows.length === 0
                    : false;

    const [showMissingCfg, setShowMissingCfg] = useState(false);

    useEffect(() => {
        if (rows3.length === 0) {
            setShowMissingCfg(false);
        }
    }, [rows3.length]);

    const [showCfgExists, setShowCfgExists] = useState(false);

    useEffect(() => {
        const names = rows3.map(r => r.fieldName.trim()).filter(n => n);
        const hasDup = names.some((n, i) => names.indexOf(n) !== i);
        setShowCfgExists(hasDup);
    }, [rows3]);

    const productTabs = rows3
        .filter(row => row && row.uniqueKey)
        .map((row, ind) => ({
            id: row.uniqueKey || `cf-${ind + 1}`,
            key: (row.fieldName || `Configuration ${row.id}`).toLowerCase().replace(/\s+/g, '-'),
            label: row.fieldName || `Configuration ${row.id}`,
        }))
        .filter(tab => tab.id && tab.key);

    const [productTab, setProductTab] = useState('');
    const [activeTab, setActiveTab] = useState(productTabs[0]?.key || '');
    const [overflowTabs, setOverflowTabs] = useState([]);
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuStyles, setMenuStyles] = useState({ top: 0, left: 0, direction: "down" });
    const containerRef = useRef(null);
    const triggerRef = useRef(null);
    const tabRefs = useRef({});

    function calcOverflow() {
        if (!containerRef.current) return;
        const contW = containerRef.current.clientWidth;
        const trigW = triggerRef.current?.offsetWidth || 40;
        let used = 0;
        const vis = [];
        const over = [];

        productTabs.forEach(tab => {
            if (!tab || !tab.key) return;

            const btn = tabRefs.current[tab.key];
            if (!btn) return;
            const w = btn.offsetWidth;
            if (tab.key === activeTab || used + w < contW - trigW) {
                vis.push(tab.key);
                used += w;
            } else {
                over.push(tab.key);
            }
        });

        setOverflowTabs(over);
    }

    useLayoutEffect(() => {
        requestAnimationFrame(() => {
            calcOverflow();
            scrollActiveTabIntoView();
        });
    }, [activeTab, rows3]);

    function scrollActiveTabIntoView() {
        const activeEl = tabRefs.current[activeTab];
        if (activeEl && containerRef.current) {
            activeEl.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest"
            });
        }
    }

    useEffect(() => {
        window.addEventListener("resize", calcOverflow);
        return () => window.removeEventListener("resize", calcOverflow);
    }, []);

    useEffect(() => {
  if (!userSwitchedTab && productTabs.length > 0) {
    setActiveTab(productTabs[0].key);
  }
}, [productTabs]);

 useEffect(() => {
    if (rows3.length > 0 && (!prevRows3.current || prevRows3.current.length !== rows3.length)) {
        const firstTabKey = productTabs[0]?.key;
        if (firstTabKey && activeTab !== firstTabKey) {
            setActiveTab(firstTabKey);
        }
    }
    prevRows3.current = rows3;
}, [rows3, productTabs, activeTab]);
    useEffect(() => {
    // Initialize config notes for each tab
    rows3.forEach(row => {
        if (row.uniqueKey && !configNotes[row.uniqueKey]) {
            setConfigNotes(prev => ({
                ...prev,
                [row.uniqueKey]: ''
            }));
        }
    });
}, [rows3]);
    useEffect(() => {
        productTabs.forEach((tab) => {
            updateSkuConfigurationCustomFields(tab.id);
        });
    }, [productTabs]);

    useEffect(() => {
        // Always fetch fresh on mount so any SPUs created since last visit are included.
        invalidateSpuNamesCache();
        ensureSpuNamesLoaded().then(data => {
            if (Array.isArray(data)) setSpus(data);
            setSpusLoading(false);
        });
    }, []);

    // Re-check duplicate SPU as soon as all 4 fields are filled (or when spus loads).
    // useLayoutEffect (not useEffect) fires before paint, so the error appears in the
    // same frame as the field change — no visible delay or flash.
    useLayoutEffect(() => {
        const name = formData.model_name?.trim();
        const brand = formData.brand_id;
        const category = formData.category_id;
        const type = formData.set_type;

        if (!name || !brand || !category || !type) {
            setFormErrors(prev =>
                prev.model_name === "SPU Name already exists"
                    ? { ...prev, model_name: "" }
                    : prev
            );
            return;
        }

        const normalized = name.toLowerCase();
        const exists = spus.some(
            (m) =>
                m.model_name &&
                m.model_name.trim().toLowerCase() === normalized &&
                brand == m.brand_id &&
                category == m.category_id &&
                type == m.product_type
        );
        setFormErrors(prev => ({ ...prev, model_name: exists ? "SPU Name already exists" : (prev.model_name === "SPU Name already exists" ? "" : prev.model_name) }));
    }, [formData.model_name, formData.brand_id, formData.category_id, formData.set_type, spus]);

    const updateSkuConfigurationCustomFields = (key) => {
        if (!isDirty) setIsDirty(true);
        setRowsCf(prev => {
            if (prev.hasOwnProperty(key)) {
                return prev;
            }
            const newRow = {
                id: 1, fieldName: '',
                fieldType: 'Text',
                refChild: '',
                value: '',
                opts: [],
                typeOpen: false,
                refMenuOpen: false,
                isOpen: false,
                search: ''
            };

            return {
                ...prev,
                [key]: [newRow],
            };
        });
    };

    function toggleMenu(e) {
        if (!triggerRef.current) return;
        const rect = triggerRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const direction = spaceBelow < 200 ? "up" : "down";
            
        const prevEl = e.currentTarget.previousElementSibling;
        if (!prevEl) return;
        const prevElRect = prevEl.getBoundingClientRect();
        const prevElWidth = prevElRect.width;
        const prevElLeft = prevElRect.left + window.scrollX;
        
        setMenuStyles({
            width: '120',
            top: direction === "down" ? rect.bottom + window.scrollY : rect.top + window.scrollY,
            // left: prevElLeft, // rect.right + window.scrollX - 200,
            right: '50',
            direction
        });
        setMenuOpen(open => !open);
    }

    useEffect(() => {
        if (!menuOpen) return;
    
        const handleClickOutside = (e) => {
          setMenuOpen(false);
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);

    const portalMenu = menuOpen && createPortal(
        <ul
            className={`pt-portal-menu ${menuStyles.direction}`}
            style={{
                position: "absolute",
                top: `${menuStyles.top}px`,
                right: `${menuStyles.right}px`,
                width: `${menuStyles.width}px`,
            }}
        >
            {productTabs.map(tab => (
                <li key={tab.key}>
                    <button
                        className={`pt-portal-item ${activeTab === tab.key ? "selected" : ""}`}
                        onClick={() => {
                            setActiveTab(tab.key);
                            setMenuOpen(false);
                        }}
                    >
                        {tab.label}
                    </button>
                </li>
            ))}
        </ul>,
        document.body
    );

    const saveRef = useRef(null);
    const [saveModalOpen, setSaveModalOpen] = useState(false);
    const handleSaveConfirm = () => {
        let config_errors = [];
        for (let row of rows3) {
            if (!row.fieldName || Object.keys(row.opts || {}).length !== rows2.length) {
                config_errors.push('All configurations must have a name and one option selected per variation group.');
            }
        }
        if (config_errors.length) {
            setValidationError(config_errors);
            setShowCfgExists(true);
            setDisabled(false);
            return;
        }
        setSaveModalOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (saveRef.current && !saveRef.current.contains(event.target)) {
                setSaveModalOpen(false);
            }
        }

        if (saveModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [saveModalOpen]);

    const saveRef2 = useRef(null);
    const [saveModalOpen2, setSaveModalOpen2] = useState(false);
    const handleSaveConfirm2 = () => {
        setSaveModalOpen2(false);
    };

    useEffect(() => {
        function handleClickOutside2(event) {
            if (saveRef2.current && !saveRef2.current.contains(event.target)) {
                setSaveModalOpen2(false);
            }
        }

        if (saveModalOpen2) {
            document.addEventListener("mousedown", handleClickOutside2);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside2);
        };
    }, [saveModalOpen2]);

    const [isOsTypeOpen, setIsOsTypeOpen] = useState(false);
    const [osTypeSearch, setOsTypeSearch] = useState('');
    const osTypeRef = useRef(null);

    const toggleOsType = () => {
        setIsOsTypeOpen((prev) => !prev);
    };

    const filteredOsTypes = productType.filter((item) =>
    item.product_type
      ?.toLowerCase()
      .includes(osTypeSearch.toLowerCase())
  );

    const handleOsTypeSelect = (value) => {
        if (!isDirty) setIsDirty(true);
        setFormData(prev => ({ ...prev, set_type: value }));
        setIsOsTypeOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isOsTypeOpen && osTypeRef.current && !osTypeRef.current.contains(e.target)) {
                setIsOsTypeOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOsTypeOpen]);

    const [isCategoryOpen, setIsCategoryOpen] = useState(false);
    const [categorySearch, setCategorySearch] = useState('');
    const categoryRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isCategoryOpen && categoryRef.current && !categoryRef.current.contains(e.target)) {
                setIsCategoryOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isCategoryOpen]);

    const [isBrandOpen, setIsBrandOpen] = useState(false);
    const [brandSearch, setBrandSearch] = useState('');
    const brandRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isBrandOpen && brandRef.current && !brandRef.current.contains(e.target)) {
                setIsBrandOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isBrandOpen]);

    const checkDuplicate = (brand) => {
        if (formData.model_name?.trim() && brand.brand_id) {
            const normalized = formData.model_name.trim().toLowerCase();
            const exists = spus.some(
                (m) => m.model_name && m.model_name.trim().toLowerCase() === normalized && brand.brand_id == m.brand_id && formData.category_id == m.category_id && formData.set_type == m.product_type
            );
            setFormErrors(prev => ({ ...prev, model_name: exists ? "SPU Name already exists" : "" }));
        }
    };

    const validateDuplicatesOnNext = () => {
        let hasDuplicates = false;
        const updates = {};

        if (formData.model_name?.trim() && formData.brand_id) {
            const normalized = formData.model_name.trim().toLowerCase();
            const exists = spus.some(
                (m) => m.model_name && m.model_name.trim().toLowerCase() === normalized && formData.brand_id == m.brand_id && formData.category_id == m.category_id && formData.set_type == m.product_type
            );
            if (exists) {
                updates.model_name = "SPU Name already exists";
                hasDuplicates = true;
            }
        }

        if (formData.model_id?.trim()) {
            const normalized = formData.model_id.trim().toLowerCase();
            const exists = spus.some(
                (m) => m.model_id && m.model_id.trim().toLowerCase() === normalized
            );
            if (exists) {
                updates.model_id = "ID already exists";
                hasDuplicates = true;
            }
        }

        if (hasDuplicates) {
            setFormErrors(prev => ({ ...prev, ...updates }));
        }
        return hasDuplicates;
    };

    const handleSaveAndAddToSKU = async () => {
        setIsSaving(true);
        setDisabled(true);
        if (validateDuplicatesOnNext()) {
            setDisabled(false);
            setIsSaving(false);
            return;
        }

        let errors = {};
        let isError = false;

        const requiredFields = ["model_name", "brand_id", "category_id", "set_type"];
        requiredFields.forEach(field => {
            if (!formData[field] || !String(formData[field]).trim()) {
                switch (field) {
                    case "model_name":
                        errors[field] = "SPU Name is required";
                        break;
                    case "brand_id":
                        errors[field] = "Brand is required";
                        break;
                    case "category_id":
                        errors[field] = "Category is required";
                        break;
                    case "set_type":
                        errors[field] = "Type is required";
                        break;
                    default:
                        errors[field] = `${field.replace('_', ' ')} is required`;
                }
                isError = true;
            }
        });

        if (uploadedImages.length > 0) {
            const invalidFile = uploadedImages.find(img =>
                !allowedImageTypes.includes(img.file.type) || img.file.size > maxSize
            );
            if (invalidFile) {
                errors.uploaded_images = "Upload failed — Only JPEG/PNG files below 1MB are supported";
                isError = true;
            }
        }

        let customFieldErrors = {};
        let customisedArray = [];

        if (showTable && rows.length > 0) {
            rows.forEach(r => {
                let rowErrors = {};

                if (!r.fieldName?.trim()) {
                    rowErrors.field_name = "Field Name is required";
                    isError = true;
                } else {
                    const isDuplicate = rows.some(row =>
                        row.id !== r.id &&
                        row.fieldName?.trim().toLowerCase() === r.fieldName?.trim().toLowerCase()
                    );
                    if (isDuplicate) {
                        rowErrors.field_name = "Field Name already exists";
                        isError = true;
                    }
                }

                if (r.fieldType === 'Text' && !r.value?.trim()) {
                    rowErrors.field_value = "Field Value is required";
                    isError = true;
                }

                if (Object.keys(rowErrors).length) {
                    customFieldErrors[r.id] = rowErrors;
                } else {
                    customisedArray.push({
                        field_name: r.fieldName,
                        type: r.fieldType,
                        value: r.value
                    });
                }
            });
        }

        setFormErrors({ ...errors, ...customFieldErrors });

        if (isError) {
            setDisabled(false);
            setIsSaving(false);
            return;
        }

        setStepData(prev => ({
            ...prev,
            spuData: {
                ...prev.spuData,
                ...formData,
                customised: customisedArray,
                images: [
                    ...(prev.spuData?.images || []),
                    ...uploadedImages.map(i => i.file)
                ]
            }
        }));

        setActiveTab2("sku-variations");
        setDisabled(false);
        setIsSaving(false);
    };

    const handleSaveAndConfigureSKU = async () => {
    setIsSaving(true);
    let hasErrors = false;
    const newVariationErrors = {};

    rows2.forEach(row => {
        const rowErrors = {};

        if (!row.fieldName && (!row.opts || row.opts.length === 0)) {
            rowErrors.fieldName = "SKU Variation is required";
            rowErrors.options = "Variation Options are required";
            hasErrors = true;
        } else if (!row.fieldName) {
            rowErrors.fieldName = "SKU Variation is required";
            hasErrors = true;
        } else {
            const isDuplicate = rows2.some(r =>
                r.id !== row.id &&
                r.fieldName === row.fieldName
            );

            if (isDuplicate) {
                rowErrors.fieldName = "SKU Variation already exists";
                hasErrors = true;
            }
        }

        if (row.fieldName && (!row.opts || row.opts.length === 0)) {
            rowErrors.options = "Variation Options are required";
            hasErrors = true;
        }

        if (Object.keys(rowErrors).length > 0) {
            newVariationErrors[row.id] = rowErrors;
        }
    });

    if (hasErrors) {
        setVariationErrors(newVariationErrors);
        setShowMissingVariationError(true);
        setIsSaving(false);
        return;
    }

    try {
        const variations = rows2.map((row, index) => ({
            attribute_id: Number(row.fieldName),
            option_values: row.opts.map((o, optIndex) => ({
                value: Number(o.value),
                order_no: optIndex + 1
            })),
            order_no: index + 1
        }));

        setStepData(prev => ({
            ...prev,
            skuData: { variations }
        }));

        setActiveTab2('sku-configurations');
        setValidationError([]);
        setIsSaving(false);

    } catch (err) {
        console.error(err);
        setIsSaving(false);
    }
};
const handleConfigFieldBlur = (rowId, newOpts) => {
    const row = rows3.find(r => r.id === rowId);
    if (!row) return;

    const newErrors = {};

    // Validate field name
    if (!row.fieldName?.trim()) {
        newErrors.fieldName = "Configuration Name is Required";
    }
    
    if (row.fieldName?.trim()) {
        const isDuplicate = rows3.some(r =>
            r.id !== rowId &&
            r.fieldName?.trim().toLowerCase() === row.fieldName?.trim().toLowerCase()
        );

        if (isDuplicate) {
            newErrors.fieldName = "Configuration Name already exists";
        }
    }

    // Validate configuration options
    if (rows2.length > 0) {
        const validVariations = rows2.filter(v => 
            v.fieldName && v.opts && v.opts.length > 0
        );
        
        if (validVariations.length > 0) {
            const selectedOptions = newOpts || row.opts || {};
            
            // Check if ALL variation groups have at least one option selected
            let allGroupsHaveOptions = true;
            let noGroupsHaveOptions = true;
            
            validVariations.forEach(variationRow => {
                const attrId = variationRow.fieldName;
                const optionsForAttr = selectedOptions[attrId];
                
                if (optionsForAttr && Array.isArray(optionsForAttr) && optionsForAttr.length > 0) {
                    noGroupsHaveOptions = false;
                } else {
                    allGroupsHaveOptions = false;
                }
            });
            
            if (noGroupsHaveOptions) {
                // Show the general error when no options are selected at all
                newErrors.options = 'Configuration Options are required';
            } else if (!allGroupsHaveOptions) {
                // Show specific error when some groups have options but not all
                newErrors.options = `Each Variation must have at least one option selected.`;
            }
            
            // Check for overlapping options (duplicate combinations) - ONLY if all groups have options
            if (allGroupsHaveOptions) {
                // For each other configuration
                rows3.forEach(otherRow => {
                    if (otherRow.id === rowId || !otherRow.opts || Object.keys(otherRow.opts).length === 0) {
                        return;
                    }
                    
                    const otherSelectedOptions = otherRow.opts;
                    let allAttributesOverlap = true;
                    
                    // Check if every attribute has at least one overlapping option
                    validVariations.forEach(variationRow => {
                        const attrId = variationRow.fieldName;
                        const currentOptions = selectedOptions[attrId] || [];
                        const otherOptions = otherSelectedOptions[attrId] || [];
                        
                        // Check if there's at least one common option
                        const hasCommonOption = currentOptions.some(opt => 
                            otherOptions.includes(opt)
                        );
                        
                        if (!hasCommonOption) {
                            allAttributesOverlap = false;
                        }
                    });
                    
                    if (allAttributesOverlap) {
                        newErrors.options = "Please remove the overlapping Options";
                    }
                });
            }
        }
    }

    // Update errors only if there are any
    if (Object.keys(newErrors).length > 0) {
        setConfigErrors(prev => ({
            ...prev,
            [rowId]: {
                ...newErrors,
                _touched: true // Keep errors visible
            }
        }));
    } else {
        // Clear errors if validation passes
        setConfigErrors(prev => {
            const updated = { ...prev };
            delete updated[rowId];
            return updated;
        });
    }
};

    const validateImage = (file) => {
        const allowedImageTypes = ["image/jpeg", "image/png"];
        const maxSize = 1 * 1024 * 1024;

        let error = '';

        if (!allowedImageTypes.includes(file.type)) {
            error = "Upload failed — Only JPEG/PNG files below 1MB are supported";
        } else if (file.size > maxSize) {
            error = "Upload failed — Only JPEG/PNG files below 1MB are supported";
        }

        return error;
    };

    const validateImages = (files) => {
        const errors = [];

        files.forEach(file => {
            const error = validateImage(file);
            if (error) {
                errors.push(error);
            }
        });

        return errors.length > 0 ? errors[0] : '';
    };
 const validateConfigCustomFieldBlur = (rowId, tabID, fieldName, value) => {
    setRowsCf(prev => {
        const rows = prev[tabID] || [];
        const updatedRows = rows.map(row => {
            if (row.id === rowId) {
                const updatedRow = { ...row };
                
                if (fieldName === 'field_name') {
                    // Validate required
                    if (!value.trim()) {
                        updatedRow.error = "Field Name is required";
                    } else {
                        // Validate duplicate within the same tab
                        const isDuplicate = rows.some(r =>
                            r.id !== rowId &&
                            r.fieldName?.trim().toLowerCase() === value.trim().toLowerCase()
                        );
                        
                        if (isDuplicate) {
                            updatedRow.error = "Field Name already exists";
                        } else {
                            updatedRow.error = ''; // Clear error if valid
                        }
                    }
                } else if (fieldName === 'field_value') {
                    // Validate required for Text type
                    if (row.fieldType === 'Text' && !value.trim()) {
                        updatedRow.valueError = "Field Value is required";
                    } else {
                        updatedRow.valueError = ''; // Clear error if valid
                    }
                }
                
                return updatedRow;
            }
            return row;
        });
        
        return {
            ...prev,
            [tabID]: updatedRows
        };
    });
};
const handleSaveConfigurations = async () => {
    setIsSaving(true);
    setConfigError("");
    setConfigErrors({});

    try {
        if (rows3.length > 0) {
            let hasErrors = false;
            const newConfigErrors = {};
            
            // Track all option combinations to detect duplicates across rows
            const configOptionsMap = {};
            
            // 1. First, validate all configuration rows
            rows3.forEach(row => {
                const rowErrors = {};
                
                // Validate configuration name
                if (!row.fieldName?.trim()) {
                    rowErrors.fieldName = "Configuration Name is required";
                    hasErrors = true;
                } else {
                    // Check for duplicate configuration names
                    const isDuplicate = rows3.some(r =>
                        r.id !== row.id &&
                        r.fieldName?.trim().toLowerCase() === row.fieldName?.trim().toLowerCase()
                    );
                    if (isDuplicate) {
                        rowErrors.fieldName = "Configuration Name already exists";
                        hasErrors = true;
                    }
                }

                // ✅ Validate configuration options against current variations
                if (rows2.length > 0) {
                    const validVariations = rows2.filter(v => 
                        v.fieldName && v.opts && v.opts.length > 0
                    );
                    
                    if (validVariations.length > 0) {
                        const selectedOptions = row.opts || {};
                        
                        // Check if each variation has at least one option selected
                        let allGroupsHaveOptions = true;
                        let noGroupsHaveOptions = true;
                        
                        validVariations.forEach(variationRow => {
                            const attrId = variationRow.fieldName;
                            const optionsForAttr = selectedOptions[attrId];
                            
                            if (optionsForAttr && Array.isArray(optionsForAttr) && optionsForAttr.length > 0) {
                                noGroupsHaveOptions = false;
                            } else {
                                allGroupsHaveOptions = false;
                            }
                        });
                        
                        if (noGroupsHaveOptions) {
                            // Show the general error when no options are selected at all
                            rowErrors.options = 'Configuration Options are required';
                            hasErrors = true;
                        } else if (!allGroupsHaveOptions) {
                            // Show specific error when some groups have options but not all
                            rowErrors.options = `Each Variation must have at least one option selected.`;
                            hasErrors = true;
                        } else {
                            // Check for overlapping options (duplicate combinations) only if all options are selected
                            const sortedOptions = {};
                            Object.keys(selectedOptions)
                                .sort()
                                .forEach(key => {
                                    const options = selectedOptions[key];
                                    if (options && Array.isArray(options) && options.length > 0) {
                                        sortedOptions[key] = [...options].sort((a, b) => a - b);
                                    }
                                });
                            
                            const optionsKey = JSON.stringify(sortedOptions);
                            
                            // Only mark the current row as duplicate, not both
                            if (configOptionsMap[optionsKey]) {
                                // This combination already exists, mark current row as duplicate
                                rowErrors.options = "Please remove the overlapping Options";
                                hasErrors = true;
                            } else {
                                configOptionsMap[optionsKey] = row.fieldName;
                            }
                        }
                    }
                }

                if (Object.keys(rowErrors).length > 0) {
                    newConfigErrors[row.id] = rowErrors;
                }
            });
            
            // 2. Validate custom fields in configuration tabs
            Object.keys(rowsCf).forEach(tabId => {
                const rows = rowsCf[tabId] || [];
                let tabHasErrors = false;
                
                rows.forEach(row => {
                    const rowErrors = {};
                    
                    // Validate field name
                    if (!row.fieldName?.trim()) {
                        rowErrors.field_name = "Field Name is required";
                        tabHasErrors = true;
                    } else {
                        // Check for duplicates within the same tab
                        const isDuplicate = rows.some(r =>
                            r.id !== row.id &&
                            r.fieldName?.trim().toLowerCase() === row.fieldName?.trim().toLowerCase()
                        );
                        
                        if (isDuplicate) {
                            rowErrors.field_name = "Field Name already exists";
                            tabHasErrors = true;
                        }
                    }
                    
                    // Validate field value for Text type
                    if (row.fieldType === 'Text' && !row.value?.trim()) {
                        rowErrors.field_value = "Field Value is required";
                        tabHasErrors = true;
                    }
                    
                    // Update row errors in rowsCf
                    if (Object.keys(rowErrors).length > 0) {
                        setRowsCf(prev => {
                            const updated = { ...prev };
                            if (!updated[tabId]) return updated;
                            
                            updated[tabId] = updated[tabId].map(r => {
                                if (r.id === row.id) {
                                    return { 
                                        ...r, 
                                        error: rowErrors.field_name || '', 
                                        valueError: rowErrors.field_value || '' 
                                    };
                                }
                                return r;
                            });
                            
                            return updated;
                        });
                    }
                });
                
                if (tabHasErrors) {
                    hasErrors = true;
                }
            });
            
            // 3. Check for image errors in configuration tabs
            const configTabIds = rows3.map(row => row.uniqueKey).filter(Boolean);
            configTabIds.forEach(tabId => {
                if (configImageErrors[tabId]) {
                    hasErrors = true;
                }
            });
            
            // 4. Check for invalid images in configuration tabs
            configTabIds.forEach(tabId => {
                const images = configImages[tabId] || [];
                const invalidImage = images.find(img => {
                    if (img.file) {
                        const error = validateImage(img.file);
                        return error;
                    }
                    return false;
                });
                
                if (invalidImage) {
                    hasErrors = true;
                    setConfigImageErrors(prev => ({
                        ...prev,
                        [tabId]: "Upload failed — Only JPEG/PNG files below 1MB are supported"
                    }));
                }
            });
            
            // 5. Check if any custom fields have errors
            const customFieldErrorsExist = Object.keys(rowsCf).some(tabId => {
                const rows = rowsCf[tabId] || [];
                return rows.some(row => row.error || row.valueError);
            });
            
            if (customFieldErrorsExist) {
                hasErrors = true;
            }
            
            if (hasErrors) {
                // Show validation error notification using existing AlertNotification
                setNotification({
                    show: true,
                    type: 'error',
                    action: 'create',
                    recordName: 'SPU',
                    message: "Please fix the errors below"
                });
                setConfigErrors(newConfigErrors);
                
                // Scroll to the first error if there are config errors
                if (Object.keys(newConfigErrors).length > 0) {
                    setTimeout(() => {
                        const firstErrorId = Object.keys(newConfigErrors)[0];
                        if (firstErrorId) {
                            const errorElement = document.querySelector(`[data-row-id="${firstErrorId}"]`);
                            if (errorElement) {
                                errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }
                        }
                    }, 100);
                }
                
                setIsSaving(false);
                return;
            }
        }

        // Prepare configurations data
        const normalizedConfigs = rows3.map((row) => {
            const tempKey = row.uniqueKey;
            
            const selectedOptionsMap = {};
            
            if (row.opts && typeof row.opts === 'object') {
                Object.entries(row.opts).forEach(([attrId, optionIds]) => {
                    if (Array.isArray(optionIds) && optionIds.length > 0) {
                        selectedOptionsMap[attrId] = optionIds;
                    }
                });
            }

            return {
                temp_key: tempKey,
                configuration_name: row.fieldName,
                selected_options: selectedOptionsMap,
                notes: configNotes[tempKey] || "",
            };
        });

        console.log("📦 CONFIGURATION PAYLOAD:", JSON.stringify({
            configurations: normalizedConfigs.map(c => ({
                name: c.configuration_name,
                selected_options: c.selected_options,
                hasOptions: Object.keys(c.selected_options || {}).length > 0
            }))
        }, null, 2));

        // Validate that all configurations have options if variations exist
        if (rows2.length > 0) {
            const validVariations = rows2.filter(v => 
                v.fieldName && v.opts && v.opts.length > 0
            );
            
            if (validVariations.length > 0) {
                const configsWithoutOptions = normalizedConfigs.filter(config => {
                    if (!config.selected_options || Object.keys(config.selected_options).length === 0) {
                        return true;
                    }
                    
                    // Check if all variation groups have at least one option
                    const allGroupsCovered = validVariations.every(variation => {
                        const attrId = variation.fieldName;
                        const options = config.selected_options[attrId];
                        return options && Array.isArray(options) && options.length > 0;
                    });
                    
                    return !allGroupsCovered;
                });
                
                if (configsWithoutOptions.length > 0) {
                    setNotification({
                        show: true,
                        type: 'error',
                        action: 'create',
                        recordName: 'SPU',
                        message: "All configurations must have a name and one option selected per variation group."
                    });
                    setIsSaving(false);
                    return;
                }
            }
        }

        // Prepare configuration images with validation
        const validatedConfigImages = {};
        Object.keys(configImages).forEach(tabKey => {
            const images = configImages[tabKey] || [];
            // Filter out any images that might have validation errors
            validatedConfigImages[tabKey] = images.filter(img => {
                if (img.file) {
                    const error = validateImage(img.file);
                    return !error; // Only include valid images
                }
                return true;
            });
        });

        // Prepare configuration custom fields
        const validatedRowsCf = {};
        Object.keys(rowsCf).forEach(tabKey => {
            const rows = rowsCf[tabKey] || [];
            // Filter out rows with errors and map to proper format
            validatedRowsCf[tabKey] = rows
                .filter(row => !row.error && !row.valueError)
                .map(row => ({
                    field_name: row.fieldName,
                    field_type: row.fieldType,
                    field_data: row.value
                }));
        });

        const payload = {
            configurations: normalizedConfigs,
            configurationImages: validatedConfigImages,
            configurationCustomFields: validatedRowsCf,
            configurationNotes: configNotes,
        };

        setStepData(prev => ({
            ...prev,
            skuConfigurationsData: payload
        }));

        // Clear any existing errors since validation passed
        setConfigErrors({});
        setConfigImageErrors({});

        setActiveTab2("sku-code");
        setIsSaving(false);

    } catch (err) {
        console.error(err);
        // Show error notification using existing AlertNotification
        setNotification({
            show: true,
            type: 'error',
            action: 'create',
            recordName: 'SPU',
            message: "Failed to save configurations"
        });
        setIsSaving(false);
    }
};
const getEventValue = (e) => {
    if (e && e.persist) e.persist();
    return e?.target?.value || e?.currentTarget?.value || e || "";
};

// Add handler for SKU code changes with validation
const handleSkuCodeChange = (index, e) => {
    if (!isDirty) setIsDirty(true);
    
    const value = getEventValue(e);
    const trimmedValue = value.trim();
    
    setSkuCodeRows(prevRows => {
        const updated = [...prevRows];
        
        // Check for duplicate in real-time
        let skuCodeError = "";
        if (!trimmedValue) {
            skuCodeError = "SKU Code is required";
        } else {
            const duplicateIndex = prevRows.findIndex((r, i) => 
                i !== index && r?.sku_code?.trim().toLowerCase() === trimmedValue.toLowerCase()
            );
            if (duplicateIndex !== -1) {
                skuCodeError = "SKU Code already exists";
            }
        }
        
        updated[index] = {
            ...updated[index],
            sku_code: value,
            isManuallyEdited: true,
            skuCodeError: skuCodeError
        };
        return updated;
    });
    
    // Clear error from skuCodeErrors state if user starts typing
    if (skuCodeErrors[index]) {
        setSkuCodeErrors(prev => {
            const updated = { ...prev };
            delete updated[index];
            return updated;
        });
    }
};
// Add handler for SKU code blur with validation
const handleSkuCodeBlur = (index, value) => {
    const trimmedValue = value.trim().toLowerCase();
    
    if (!value.trim()) {
        setSkuCodeErrors(prev => ({
            ...prev,
            [index]: "SKU Code is required"
        }));
    } else {
        const isDuplicate = skuCodeRows.some((r, otherIdx) => 
            otherIdx !== index && 
            r.sku_code?.trim().toLowerCase() === trimmedValue
        );
        
        if (isDuplicate) {
            setSkuCodeErrors(prev => ({
                ...prev,
                [index]: "SKU Code already exists"
            }));
        } else {
            setSkuCodeErrors(prev => {
                const updated = { ...prev };
                delete updated[index];
                return updated;
            });
        }
    }
};
const handleSaveSKUCode = async () => {
    setIsSaving(true);
    
    // Validate SKU names for SAVE operation (show errors on ALL duplicates)
    const isSkuNamesValid = validateSkuNames(true); // Pass true for save operation
    
    // Validate SKU codes (keep existing validation)
    const isSkuCodesValid = validateSkuCodes();
    
    if (!isSkuNamesValid || !isSkuCodesValid) {
        setNotification({
            show: true,
            type: 'error',
            action: 'create',
            recordName: 'SKU',
            message: "Please fix the errors below"
        });
        setIsSaving(false);
        return;
    }
    
    // Validate SKU Code rows before saving
    let hasErrors = false;
    
    // Check if all SKU names are filled
    const emptySkuNames = skuCodeRows.filter(row => !row.name?.trim());
    if (emptySkuNames.length > 0) {
        hasErrors = true;
    }
    
    // Check if all SKU codes are filled
    const emptySkuCodes = skuCodeRows.filter(row => !row.sku_code?.trim());
    if (emptySkuCodes.length > 0) {
        hasErrors = true;
    }
    
    if (hasErrors) {
        setNotification({
            show: true,
            type: 'error',
            action: 'create',
            recordName: 'SKU',
            message:'Please fill all required SKU fields'
        });
        setIsSaving(false);
        return;
    }
    
    const finalData = {
        ...stepData,
        skuCodeData: skuCodeRows.map(skuRow => ({
            ...skuRow,
            configuration_temp_key: rows3.length > 0 ? skuRow.configuration_temp_key : 'default-config'
        }))
    };

    console.log("🔥 FINAL DATA FOR SAVE:", finalData);
    
    try {
        await handleFinalSave(finalData);
    } catch (error) {
        setNotification({
            show: true,
            type: 'error',
            action: 'create',
            recordName: 'SPU',
            message:'Error Saving'
        });
        setIsSaving(false);
    }
};




    const stepMapping = {
        "edit-spu": 1,
        "sku-variations": 2,
        "sku-configurations": 3,
        "sku-code": 4
    };

    const tabContent = {
        'edit-spu': {
            heading: "SPU",
            buttons: ["discard", "next"]
        },
        'sku-variations': {
            heading: "SKU Variations",
            buttons: ["discard", "back", "next"]
        },
        'sku-configurations': {
            heading: "SKU Configurations",
            buttons: ["discard", "back", "next"]
        },
        'sku-code': {
            heading: "SKU Info",
            buttons: ["discard", "back", "save"]
        }
    };

    const currentTab = tabContent[activeTab2];

    useEffect(() => {
    if (activeTab2 === 'sku-variations' && rows2.length === 0) {
        setRows2([{ id: 1, fieldName: '', opts: [], isOpen: false, search: '' }]);
    }
    
    // Trigger validation for existing rows when entering this tab
    if (activeTab2 === 'sku-variations' && rows2.length > 0) {
        rows2.forEach(row => {
            if (!row.fieldName || (!row.opts || row.opts.length === 0)) {
                handleVariationFieldBlur(row.id);
            }
        });
    }
}, [activeTab2, rows2.length]);
    
    const handleBack = () => {
        if (activeTab2 === "sku-variations") setActiveTab2("edit-spu");
        if (activeTab2 === "sku-configurations") setActiveTab2("sku-variations");
        if (activeTab2 === "sku-code") setActiveTab2("sku-configurations");
    };

const handleNext = () => {
    if (activeTab2 === "edit-spu") {
        const hasFormErrors = Object.values(errors).some(error =>
            error && (typeof error === 'string' ? error.length > 0 : Object.values(error || {}).some(v => v))
        );

        const requiredFields = ["model_name", "brand_id", "category_id", "set_type"];
        const missingRequired = requiredFields.some(field =>
            !formData[field] || !String(formData[field]).trim()
        );

        let hasCustomFieldErrors = false;
        if (showTable && rows.length > 0) {
            hasCustomFieldErrors = rows.some(row => {
                if (!row.fieldName?.trim()) return true;
                if (row.fieldType === 'Text' && !row.value?.trim()) return true;
                return false;
            });
        }

        if (hasFormErrors || missingRequired || hasCustomFieldErrors) {
            // Show AlertNotification for validation errors
            setNotification({
                show: true,
                type: 'error',
                action: 'create',
                recordName: 'SPU',
                message: "Please fix the errors below"
            });
            
            if (missingRequired) {
                requiredFields.forEach(field => {
                    if (!formData[field] || !String(formData[field]).trim()) {
                        handleFieldBlur({ target: { name: field, value: formData[field] || '' } });
                    }
                });
            }

            if (showTable && rows.length > 0) {
                rows.forEach(row => {
                    if (!row.fieldName?.trim()) {
                        handleCustomFieldBlur({
                            target: { name: "field_name", value: row.fieldName || '' }
                        }, row.id);
                    }
                    if (row.fieldType === 'Text' && !row.value?.trim()) {
                        handleCustomFieldBlur({
                            target: { name: "field_value", value: row.value || '' }
                        }, row.id);
                    }
                });
            }

            return;
        }

        handleSaveAndAddToSKU();
    }

   if (activeTab2 === "sku-variations") {
    // Force validation of all rows when Next is clicked
    let hasErrors = false;
    const newVariationErrors = {};
    
    // Track all variation names for duplicate checking
    const variationNames = {};
    
    rows2.forEach(row => {
        const rowErrors = {};
        
        // Validate field name
        if (!row.fieldName) {
            rowErrors.fieldName = "SKU Variation is required";
            hasErrors = true;
        } else {
            // Check for duplicates
            const normalizedName = row.fieldName.trim().toLowerCase();
            
            if (variationNames[normalizedName]) {
                rowErrors.fieldName = "SKU Variation already exists";
                hasErrors = true;
            } else {
                variationNames[normalizedName] = true;
            }
        }
        
        // Validate options
        if (!row.opts || !Array.isArray(row.opts) || row.opts.length === 0) {
            rowErrors.options = "Variation Options are required";
            hasErrors = true;
        }
        
        if (Object.keys(rowErrors).length > 0) {
            newVariationErrors[row.id] = rowErrors;
        }
    });
    
    if (hasErrors) {
        // Show AlertNotification for validation errors
        setNotification({
            show: true,
            type: 'error',
            action: 'create',
            recordName: 'SPU',
            message: "Please fix the errors below"
        });
        
        // Set errors to show them in the UI
        setVariationErrors(newVariationErrors);
        setShowMissingVariationError(true);
        
        // Scroll to the first error
        const firstErrorId = Object.keys(newVariationErrors)[0];
        if (firstErrorId) {
            setTimeout(() => {
                const errorElement = document.querySelector(`[data-row-id="${firstErrorId}"]`);
                if (errorElement) {
                    errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
        }
        
        return; // Don't allow moving forward
    }
    
    // ✅ NEW: Validate configurations when moving from step 2 to step 3
    // But don't prevent navigation - just set the errors to show in step 3
     if (rows3.length > 0) {
        const validVariations = rows2.filter(v => 
            v.fieldName && v.opts && v.opts.length > 0
        );
        
        const newConfigErrors = { ...configErrors };
        let hasConfigErrors = false;
        
        // Validate each configuration against current variations
        rows3.forEach(config => {
            const selectedOptions = config.opts || {};
            
            // Check if each variation has at least one option selected
            let allGroupsHaveOptions = true;
            let noGroupsHaveOptions = true;
            
            validVariations.forEach(variationRow => {
                const attrId = variationRow.fieldName;
                const optionsForAttr = selectedOptions[attrId];
                
                if (optionsForAttr && Array.isArray(optionsForAttr) && optionsForAttr.length > 0) {
                    noGroupsHaveOptions = false;
                } else {
                    allGroupsHaveOptions = false;
                }
            });
            
            if (noGroupsHaveOptions) {
                newConfigErrors[config.id] = {
                    ...newConfigErrors[config.id],
                    options: "Configuration Options are required",
                    _touched: true
                };
                hasConfigErrors = true;
            } else if (!allGroupsHaveOptions) {
                newConfigErrors[config.id] = {
                    ...newConfigErrors[config.id],
                    options: "Each Variation must have at least one option selected.",
                    _touched: true
                };
                hasConfigErrors = true;
            } else {
                // Clear errors if configuration is valid
                delete newConfigErrors[config.id];
            }
        });
        
        if (hasConfigErrors) {
            setConfigErrors(newConfigErrors);
            
            // Show warning notification but allow navigation
            setNotification({
                show: true,
                type: 'error',
                action: 'create',
                recordName: 'SPU',
                message: "Please fix the errors below"
            });
            
            // DON'T return here - allow navigation to step 3
        }
    }
    
  
    // If no errors, proceed
    handleSaveAndConfigureSKU();
}
if (activeTab2 === "sku-configurations") {
    // SKU Configurations is optional - only validate if rows exist
    if (rows3.length > 0) {
        console.log("in 3rd step")
        let hasErrors = false;
        const newConfigErrors = {};
        
        // PRESERVE EXISTING ERRORS (including overlapping ones)
        Object.keys(configErrors).forEach(key => {
            newConfigErrors[key] = { ...configErrors[key] };
        });
        
        // First pass: collect all valid configurations
        const validConfigs = [];
        rows3.forEach((currentRow, currentIndex) => {
            const rowErrors = newConfigErrors[currentRow.id] || {};
            
            // Validate configuration name (required)
            if (!currentRow.fieldName?.trim()) {
                rowErrors.fieldName = "Configuration Name is required";
                hasErrors = true;
            } else {
                // Check for duplicates
                const isDuplicate = rows3.some((otherRow, otherIndex) =>
                    otherIndex !== currentIndex &&
                    otherRow.fieldName?.trim().toLowerCase() === currentRow.fieldName?.trim().toLowerCase()
                );
                if (isDuplicate) {
                    rowErrors.fieldName = "Configuration Name already exists";
                    hasErrors = true;
                } else if (rowErrors.fieldName) {
                    // Clear field name error if it's no longer duplicate
                    delete rowErrors.fieldName;
                }
            }
            
            // Validate configuration options (required if variations exist)
            if (rows2.length > 0) {
                const validVariations = rows2.filter(v => 
                    v.fieldName && v.opts && v.opts.length > 0
                );
                
                if (validVariations.length > 0) {
                    const selectedOptions = currentRow.opts || {};
                    
                    // Check if any options are selected
                    const hasAnyOptions = Object.keys(selectedOptions).some(key => 
                        Array.isArray(selectedOptions[key]) && selectedOptions[key].length > 0
                    );
                    
                    if (!hasAnyOptions) {
                        rowErrors.options = 'Configuration Options are required';
                        rowErrors._options_force_show = true
                        hasErrors = true;
                    } else {
                        // Check for zero options in any variation
                        let hasZeroOptions = false;
                        
                        validVariations.forEach(variationRow => {
                            const attrId = variationRow.fieldName;
                            const optionsForAttr = selectedOptions[attrId];
                            
                            if (!optionsForAttr || !Array.isArray(optionsForAttr) || optionsForAttr.length === 0) {
                                hasZeroOptions = true;
                            }
                        });
                        
                        if (hasZeroOptions) {
                            rowErrors.options = `Each Variation must have at least one option selected.`;
                            hasErrors = true;
                        } else if (currentRow.fieldName?.trim()) {
                            // Only track valid configs for overlap checking
                            validConfigs.push({
                                id: currentRow.id,
                                index: currentIndex,
                                fieldName: currentRow.fieldName,
                                opts: selectedOptions
                            });
                            
                            // Clear options error if all options are now selected
                            if (rowErrors.options && !rowErrors.options.includes("overlapping")) {
                                delete rowErrors.options;
                            }
                        }
                    }
                }
            }

            if (Object.keys(rowErrors).length > 0) {
                newConfigErrors[currentRow.id] = rowErrors;
            } else if (newConfigErrors[currentRow.id]) {
                // Remove entry if no errors left
                delete newConfigErrors[currentRow.id];
            }
        });
        
        // Second pass: Check for overlaps among valid configs
        if (rows2.length > 0 && validConfigs.length > 1) {
            const validVariations = rows2.filter(v => 
                v.fieldName && v.opts && v.opts.length > 0
            );
            
            // Track all overlapping configs
            const overlappingConfigIds = new Set();
            
            // Check each pair of configurations
            for (let i = 0; i < validConfigs.length; i++) {
                for (let j = i + 1; j < validConfigs.length; j++) {
                    const configA = validConfigs[i];
                    const configB = validConfigs[j];
                    
                    let allAttributesOverlap = true;
                    
                    // Check if every attribute has at least one overlapping option
                    validVariations.forEach(variationRow => {
                        const attrId = variationRow.fieldName;
                        const optionsA = configA.opts[attrId] || [];
                        const optionsB = configB.opts[attrId] || [];
                        
                        // Check if there's at least one common option
                        const hasCommonOption = optionsA.some(opt => 
                            optionsB.includes(opt)
                        );
                        
                        if (!hasCommonOption) {
                            allAttributesOverlap = false;
                        }
                    });
                    
                    if (allAttributesOverlap) {
                        hasErrors = true;
                        overlappingConfigIds.add(configA.id);
                        overlappingConfigIds.add(configB.id);
                    }
                }
            }
            
            // Mark ALL overlapping configs with errors
            overlappingConfigIds.forEach(configId => {
                newConfigErrors[configId] = {
                    ...newConfigErrors[configId],
                    options: "Please remove the overlapping Options",
                    _touched: true // Keep error visible
                };
            });
            
            // Clear overlapping errors from non-overlapping configs
            rows3.forEach(config => {
                if (!overlappingConfigIds.has(config.id) && newConfigErrors[config.id]?.options === "Please remove the overlapping Options") {
                    delete newConfigErrors[config.id].options;
                    if (Object.keys(newConfigErrors[config.id]).length === 0) {
                        delete newConfigErrors[config.id];
                    }
                }
            });
        }
        
        // Also validate configuration custom fields
        const customFieldErrorsExist = Object.keys(rowsCf).some(tabId => {
            const rows = rowsCf[tabId] || [];
            return rows.some(row => row.error || row.valueError);
        });
        
        if (customFieldErrorsExist) {
            hasErrors = true;
        }
        
        // Also validate configuration images
        const configTabIds = rows3.map(row => row.uniqueKey).filter(Boolean);
        configTabIds.forEach(tabId => {
            if (configImageErrors[tabId]) {
                hasErrors = true;
            }
        });
        
        if (hasErrors) {
            // Show AlertNotification for validation errors
            setNotification({
                show: true,
                type: 'error',
                action: 'create',
                recordName: 'SPU',
                message: "Please fix the errors below"
            });
            
            // Keep ALL errors including overlapping ones
            setConfigErrors(newConfigErrors);
            
            // Scroll to the first error
            const firstErrorId = Object.keys(newConfigErrors)[0];
            if (firstErrorId) {
                setTimeout(() => {
                    const errorElement = document.querySelector(`[data-row-id="${firstErrorId}"]`);
                    if (errorElement) {
                        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 100);
            }
            
            return; // Don't allow moving forward
        }
    }

    handleSaveConfigurations();
}
};
 
    // Add this sorting function after your existing handleSort function

const [sortField, setSortField] = useState(null);
const [sortOrder, setSortOrder] = useState(null);

const handleSort = (field) => {
    if (!isDirty) setIsDirty(true);
    
    let newSortOrder;
    if (sortField === field) {
        newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    } else {
        newSortOrder = "asc";
    }
    
    // Create a sorted copy of the rows
    const sortedRows = [...skuCodeRows].sort((a, b) => {
        let aValue = a[field];
        let bValue = b[field];

        // Handle numeric fields
        if (field === 'msrp') {
            aValue = parseFloat(aValue) || 0;
            bValue = parseFloat(bValue) || 0;
        }

        // Handle status field
        if (field === 'status') {
            aValue = aValue === '1' ? 'Active' : 'Inactive';
            bValue = bValue === '1' ? 'Active' : 'Inactive';
        }

        // Handle string comparison
        if (typeof aValue === 'string') {
            aValue = aValue.toLowerCase();
        }
        if (typeof bValue === 'string') {
            bValue = bValue.toLowerCase();
        }

        if (aValue < bValue) {
            return newSortOrder === "asc" ? -1 : 1;
        }
        if (aValue > bValue) {
            return newSortOrder === "asc" ? 1 : -1;
        }
        return 0;
    });
    
    // Update the actual state with sorted rows
    setSkuCodeRows(sortedRows);
    setSortField(field);
    setSortOrder(newSortOrder);
};
const getSortedSkuRows = () => {
    if (!sortField) return skuCodeRows;

    return [...skuCodeRows].sort((a, b) => {
        let aValue = a[sortField];
        let bValue = b[sortField];

        // Handle numeric fields
        if (sortField === 'msrp') {
            aValue = parseFloat(aValue) || 0;
            bValue = parseFloat(bValue) || 0;
        }

        // Handle status field
        if (sortField === 'status') {
            aValue = aValue === '1' ? 'Active' : 'Inactive';
            bValue = bValue === '1' ? 'Active' : 'Inactive';
        }

        // Handle string comparison (case-insensitive)
        if (typeof aValue === 'string') {
            aValue = aValue.toLowerCase();
        }
        if (typeof bValue === 'string') {
            bValue = bValue.toLowerCase();
        }

        if (aValue < bValue) {
            return sortOrder === "asc" ? -1 : 1;
        }
        if (aValue > bValue) {
            return sortOrder === "asc" ? 1 : -1;
        }
        return 0;
    });
};

// Get sorted rows
const sortedSkuRows = getSortedSkuRows();
    const buildCategoryMap = (categories) => {
        const map = new Map();
        categories.forEach(cat => map.set(cat.category_id, cat));
        return map;
    };
    
    const getFullHierarchy = (category, map) => {
        const chain = [];
        let current = category;

        while (current) {
            chain.push({
                id: current.category_id,
                name: current.category_name,
            });

            if (!current.parent_category) break;

            current = map.get(current.parent_category);
        }

        return chain;
    };
    
    const getAllHierarchies = (categories) => {
        const map = buildCategoryMap(categories);

        return categories.map(cat => ({
            id: cat.category_id,
            name: cat.category_name,
            hierarchy: getFullHierarchy(cat, map),
        }));
    };

    const getHierarchyString = (item) => {
        if (!item?.hierarchy) return "";
        const parents = item.hierarchy.slice(1);
        // If NO parents → show item's own name
        if (parents.length === 0) return item.name || item.hierarchy[0]?.name || "";
        return parents.map(p => p.name).join(" >> ");
    };

    const validateLocalDuplicate = (field, value, rowId = null) => {
        if (field === "field_name") {
            if (!value?.trim()) return false;

            const normalized = value.trim().toLowerCase();
            let exists = rows.some(
                r =>
                    r.id !== rowId &&
                    r.custom_fields?.field_name &&
                    r.custom_fields?.field_name.trim().toLowerCase() === normalized
            );

            setFormErrors(prev => ({
                ...prev,
                [rowId]: {
                    ...prev[rowId],
                    field_name: exists ? "Field Name already exists" : ""
                }
            }));

            return exists;
        }
        return false;
    };

    const labelMap = {
        model_name: "SPU Name",
        model_id: "ID",
        field_name: "Field Name",
        field_value: "Field Value",
    };

    const handleFieldBlur = (e) => {
    const { name, value } = e.target;

    // ID field is not mandatory, so don't show required error for it
    if (name === "model_id") {
        // Only validate duplicates if there's a value
        if (value.trim()) {
            const normalized = value.trim().toLowerCase();
            const exists = spus.some(
                (m) => m.model_id && m.model_id.trim().toLowerCase() === normalized
            );
            if (exists) {
                setFormErrors(prev => ({ ...prev, [name]: "ID already exists" }));
                return;
            } else {
                setFormErrors(prev => ({ ...prev, [name]: "" }));
            }
        } else {
            // Clear any existing error for empty ID field
            setFormErrors(prev => ({ ...prev, [name]: "" }));
        }
        return;
    }

    // For SPU Name (model_name), validate on blur even if pasted
    if ((name === "model_name" && value.trim()) && formData.brand_id) {
        const normalized = value.trim().toLowerCase();
        const exists = spus.some(
            (m) => m.model_name && m.model_name.trim().toLowerCase() === normalized && formData.brand_id == m.brand_id && formData.category_id == m.category_id && formData.set_type == m.product_type
        );
        if (exists) {
            setFormErrors(prev => ({ ...prev, [name]: "SPU Name already exists" }));
            return;
        } else {
            setFormErrors(prev => ({ ...prev, [name]: "" }));
        }
    }

    // Required validation (skip for model_id since it's not required)
    if (name !== "model_id" && !value.trim()) {
        let errorMessage = "";
        switch (name) {
            case "model_name":
                errorMessage = "SPU Name is required";
                break;
            case "brand_id":
                errorMessage = "Brand is required";
                break;
            case "category_id":
                errorMessage = "Category is required";
                break;
            case "set_type":
                errorMessage = "Type is required";
                break;
            default:
                errorMessage = `${labelMap[name] || name} is required`;
        }

        if (errorMessage) {
            setFormErrors(prev => ({
                ...prev,
                [name]: errorMessage
            }));
        }
        return;
    }

    // Clear error if field is valid
    setFormErrors(prev => ({ ...prev, [name]: "" }));
};

const handleCustomFieldBlur = (e, rowId, tabKey = null) => {
    const { name, value } = e.target;

    if (name === "field_name") {
        if (!value.trim()) {
            if (tabKey) {
                setRowsCf(prev => {
                    const updated = { ...prev };
                    if (!updated[tabKey]) return updated;

                    updated[tabKey] = updated[tabKey].map(row => {
                        if (row.id === rowId) {
                            return { ...row, error: "Field Name is required" };
                        }
                        return row;
                    });

                    return updated;
                });
            } else {
                setFormErrors(prev => ({
                    ...prev,
                    [rowId]: {
                        ...prev[rowId],
                        field_name: "Field Name is required"
                    }
                }));
            }
            return;
        }

        let isDuplicate = false;

        if (tabKey) {
            const currentRows = rowsCf[tabKey] || [];
            isDuplicate = currentRows.some(row =>
                row.id !== rowId &&
                row.fieldName?.trim().toLowerCase() === value.trim().toLowerCase()
            );
        } else {
            isDuplicate = rows.some(row =>
                row.id !== rowId &&
                row.fieldName?.trim().toLowerCase() === value.trim().toLowerCase()
            );
        }

        if (isDuplicate) {
            if (tabKey) {
                setRowsCf(prev => {
                    const updated = { ...prev };
                    if (!updated[tabKey]) return updated;

                    updated[tabKey] = updated[tabKey].map(row => {
                        if (row.id === rowId) {
                            return { ...row, error: "Field Name already exists" };
                        }
                        return row;
                    });

                    return updated;
                });
            } else {
                setFormErrors(prev => ({
                    ...prev,
                    [rowId]: {
                        ...prev[rowId],
                        field_name: "Field Name already exists"
                    }
                }));
            }
        } else {
            if (tabKey) {
                setRowsCf(prev => {
                    const updated = { ...prev };
                    if (!updated[tabKey]) return updated;

                    updated[tabKey] = updated[tabKey].map(row => {
                        if (row.id === rowId) {
                            const { error, ...rest } = row;
                            return rest;
                        }
                        return row;
                    });

                    return updated;
                });
            } else {
                setFormErrors(prev => ({
                    ...prev,
                    [rowId]: {
                        ...prev[rowId],
                        field_name: ""
                    }
                }));
            }
        }
    } else if (name === "field_value") {
        if (!value.trim()) {
            if (tabKey) {
                setRowsCf(prev => {
                    const updated = { ...prev };
                    if (!updated[tabKey]) return updated;

                    updated[tabKey] = updated[tabKey].map(row => {
                        if (row.id === rowId) {
                            return { ...row, valueError: "Field Value is required" };
                        }
                        return row;
                    });

                    return updated;
                });
            } else {
                setFormErrors(prev => ({
                    ...prev,
                    [rowId]: {
                        ...prev[rowId],
                        field_value: "Field Value is required"
                    }
                }));
            }
        } else {
            if (tabKey) {
                setRowsCf(prev => {
                    const updated = { ...prev };
                    if (!updated[tabKey]) return updated;

                    updated[tabKey] = updated[tabKey].map(row => {
                        if (row.id === rowId) {
                            const { valueError, ...rest } = row;
                            return rest;
                        }
                        return row;
                    });

                    return updated;
                });
            } else {
                setFormErrors(prev => ({
                    ...prev,
                    [rowId]: {
                        ...prev[rowId],
                        field_value: ""
                    }
                }));
            }
        }
    }
};

const handleVariationFieldBlur = (rowId) => {
    // Only validate on blur if errors already exist
    if (variationErrors[rowId]) {
        const row = rows2.find(r => r.id === rowId);
        if (!row) return;

        const newErrors = {};

        // Validate field name
        if (!row.fieldName) {
            newErrors.fieldName = "SKU Variation is required";
        } else {
            const isDuplicate = rows2.some(r =>
                r.id !== rowId &&
                r.fieldName === row.fieldName
            );
            if (isDuplicate) {
                newErrors.fieldName = "SKU Variation already exists";
            }
        }

        // Validate options
        if (!row.opts || !Array.isArray(row.opts) || row.opts.length === 0) {
            newErrors.options = "Variation Options are required";
        }

        if (Object.keys(newErrors).length > 0) {
            setVariationErrors(prev => ({
                ...prev,
                [rowId]: newErrors
            }));
        } else {
            // Clear errors if all valid
            setVariationErrors(prev => {
                const updated = { ...prev };
                delete updated[rowId];
                return updated;
            });
        }
    }
};
    const finalPayload = {
        spuData: stepData.spuData,
        spuImages: uploadedImages.map(img => ({
            image: img.base64 || img.fileBase64 || img.file
        })),
        spuCustomFields: rows.map(r => ({
            field_name: r.fieldName,
            field_data: r.value,
            field_type: r.fieldType
        })),
        skuVariations: stepData.skuData?.variations || [],
        skuConfigurations: {
            configurations: stepData.skuConfigurationsData?.configurations || [],
            configurationImages: stepData.skuConfigurationsData?.configurationImages || {}
        },
        skuCodeData: skuCodeRows
    };

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });

    const convertSpuImage = async (img) => {
    if (img?.image && typeof img.image === "string") {
        return { 
            image: img.image,
            user_image_name: img.user_image_name 
        };
    }

    if (typeof img === "string" && img.startsWith("data:image")) {
        return { 
            image: img,
            user_image_name: img.user_image_name 
        };
    }

    if (img instanceof File) {
        return { 
            image: await toBase64(img),
            user_image_name: img.name // Use original filename
        };
    }

    if (img?.file instanceof File) {
        return { 
            image: await toBase64(img.file),
            user_image_name: img.user_image_name || img.file.name // Use original filename
        };
    }

    if (img?.preview?.startsWith("blob:")) {
        const blob = await fetch(img.preview).then(r => r.blob());
        return { 
            image: await toBase64(blob),
            user_image_name: img.user_image_name || 'image.jpg' // Fallback if no name
        };
    }

    return null;
};

    const handleFinalSave = async (finalStepData) => {
    try {
        setIsSaving(true);
        console.log("🔥 FINAL SAVE - Checking SKU Code Data:");
        console.log("SKU Code Rows:", skuCodeRows);
        
        const uniqueSkuCodeRows = skuCodeRows.map(skuRow => ({
            ...skuRow,
            configuration_temp_key: null 
        }));

        console.log("Unique SKU Code Rows:", uniqueSkuCodeRows.length, uniqueSkuCodeRows);

        const spuImages = (await Promise.all(
            (finalStepData.spuData?.images || []).map(convertSpuImage)
        )).filter(Boolean);

        const skuCodeRowsFinal = Array.isArray(uniqueSkuCodeRows)
            ? uniqueSkuCodeRows
            : Object.values(uniqueSkuCodeRows || {});

        const spuCustomFields = (finalStepData.spuData?.customised || [])
            .map(cf => ({
                field_name: cf.field_name,
                field_type: cf.type,
                field_data: cf.value
            }));

        const skuVariations = Array.isArray(finalStepData.skuData?.variations)
            ? finalStepData.skuData.variations
            : [];

        const cfgData = finalStepData.skuConfigurationsData || {};

        const normalizedConfigs = (cfgData.configurations || []).map(cfg => ({
            temp_key: cfg.temp_key,
            configuration_name: cfg.configuration_name,
            selected_options: cfg.selected_options || {},
            notes: cfg.notes || ""
        }));

        // In handleFinalSave function, update the configuration images processing:

// Process configuration images with user_image_name (original filename)
let finalConfigImages = {};

for (const [key, images] of Object.entries(configImages || {})) {
    finalConfigImages[key] = (await Promise.all(
        images.map(async img => {
            let finalBase64 = null;
            let finalUserImageName = img.user_image_name;

            if (typeof img?.file === "string" && img.file.startsWith("data:image")) {
                finalBase64 = img.file;
            } else if (img?.file instanceof File) {
                finalBase64 = await toBase64(img.file);
                finalUserImageName = img.file.name; // Use original filename
            } else if (img?.preview?.startsWith("blob:")) {
                const blob = await fetch(img.preview).then(res => res.blob());
                finalBase64 = await toBase64(blob);
                finalUserImageName = img.user_image_name || 'image.jpg'; // Use stored name or fallback
            }

            if (!finalBase64) return null;
            return { 
                image: finalBase64,
                user_image_name: finalUserImageName // Original filename
            };
        })
    )).filter(Boolean);
}

        const skuConfigurations = {
            configurations: normalizedConfigs,
            configurationImages: finalConfigImages,
            configurationCustomFields: cfgData.configurationCustomFields || {}
        };

        const finalPayload = {
            spuData: finalStepData.spuData,
            spuImages,
            spuCustomFields,
            skuVariations,
            skuConfigurations,
            skuCodeData: skuCodeRowsFinal
        };

        console.log("📦 FINAL PAYLOAD SENT TO API:", JSON.stringify({
            skuCodeDataCount: skuCodeRowsFinal.length,
            configurationsCount: normalizedConfigs.length,
            configurationsWithOptions: normalizedConfigs.filter(c => 
                c.selected_options && Object.keys(c.selected_options).length > 0
            ).length
        }, null, 2));

        const response = await apiHelper(
            "inventory/spu-sku/full-create/",
            "POST",
            finalPayload,
            "application/json"
        );

        if (!response.ok) {
            const errorJson = await response.json();
            console.error("❌ API Error Response:", errorJson);

            // Show "Error Saving" notification
            setNotification({
                show: true,
                type: 'error',
                action: 'create',
                recordName: 'SPU',
                message:'Error Saving'
            });
            setIsSaving(false);
            return;
        }

        setNotification({
            show: true,
            type: 'success',
            action: 'create',
            recordName: 'SPU & SKU'
            // message:"Error Saving"
        });

        setIsDirty(false);
        invalidateSpuNamesCache(); // ensure next Add/Edit SPU sees the newly created record

        setTimeout(() => {
            history.push("/spu-sku");
            setIsSaving(false);
        }, 2000);

    } catch (err) {
        console.error("❌ Unexpected Final Save Error:", err);

        // Show "Error Saving" notification
        setNotification({
            show: true,
            type: 'error',
            action: 'create',
            recordName: 'SPU',
            message:"Error Saving"
        });
        setIsSaving(false);
    }
};

    const generateSKUCode = (finalData) => {
        const TYPE_PREFIX = {
            Device: 'DE',
            'Spare Part': 'SP',
            Accessory: 'ACC',
            Others: 'OTH'
        };

        const { spuData } = finalData;

        const skuCodeArray = Array.isArray(finalData.skuCodeData)
            ? finalData.skuCodeData
            : Object.values(finalData.skuCodeData || {});

        if (!skuCodeArray.length) return [];

        const brandPrefix =
            brands.find(b => b.id === spuData.brand_id)?.prefix || '';

        const categoryPrefix =
            categories.find(c => c.id === spuData.category_id)?.prefix || '';

        const spuPrefix =
            spuData.prefix ||
            spuData.model_name?.replace(/[^0-9A-Za-z]/g, '').slice(-4) ||
            '';

        const typePrefix = TYPE_PREFIX[spuData.set_type] || '';

        return skuCodeArray.map(sku => {
            let skuAbbr = '';

            Object.values(sku.values || {}).forEach(optionId => {
                const opt = skuAttributeOptions.find(
                    o => o.sku_preset_option_id === optionId
                );
                if (opt?.sku_preset_option_abbr) {
                    skuAbbr += opt.sku_preset_option_abbr;
                }
            });

            return {
                ...sku,
                sku_code:
                    typePrefix +
                    brandPrefix +
                    categoryPrefix +
                    spuPrefix +
                    skuAbbr
            };
        });
    };

    const handleNotificationClose = () => {
        setNotification(prev => ({ ...prev, show: false }));
    };

    return (
        <>
            {notification.show && (
                <AlertNotification
                    type={notification.type}
                    recordName={notification.recordName}
                    action={notification.action}
                    message={notification.message}
                    onClose={handleNotificationClose}
                />
            )}

            <div className="company-body main-company-body-inner new-look" style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                overflow: 'hidden',
            }}>
                <div className="breadcrumb">
                    {breadcrumbs.map((crumb, index) => {
                        const isLast = index === breadcrumbs.length - 1;
                        return (
                            <span
                                key={index}
                                className={`breadcrumb-item ${crumb === "SPU & SKU" ? "clickable" : ""}`}
                                onClick={(e) => {
                                    e.stopPropagation(); // Stop event bubbling
                                    if (crumb === "SPU & SKU") {
                                        if (!isDirty || isSaving) {
                                            history.push("/spu-sku");
                                        } else {
                                            setDiscardModalOpen(true);
                                        }
                                    }
                                }}
                                style={{ cursor: crumb === "SPU & SKU" ? "pointer" : "default" }}
                            >
                                {crumb}
                                {!isLast ? "  " : ""}
                            </span>
                        );
                    })}
                </div>
                <div className="progress-stepper-container mb-4">
                    <SpuProgressStepper currentStep={stepMapping[activeTab2]} />
                </div>
                <div className='edit-organisation-info'>

                    <div className='edit-organisation-left'>
                        <h1>{currentTab?.heading}</h1>
                    </div>

                    <div className='discard-save-organisation-right d-flex align-items-center justify-content-end flex-wrap gap-2'>

                        {currentTab?.buttons?.includes("discard") && (
                           <button
                                className="dark-button"
                                type='button'
                                onClick={(e) => handleDiscard(e)}
                            >
                                Discard
                            </button>
                        )}

                        <DiscardConfirmationModal
                            isOpen={discardModalOpen}
                            onCancel={handleCancelDiscard}
                            onConfirm={handleDiscardConfirm}
                            entityName="SPU and SKU"
                        />

                        {currentTab?.buttons?.includes("back") && (
                            <button
                                className="dark-button"
                                type="button"
                                onClick={handleBack}
                            >
                                Back
                            </button>
                        )}

                        {currentTab?.buttons?.includes("next") && (
                            <button
                                className={`dark-border ${(currentRowsEmpty || (spusLoading && activeTab2 === 'edit-spu')) ? 'disabled' : ''}`}
                                type="button"
                                onClick={handleNext}
                                disabled={currentRowsEmpty || (spusLoading && activeTab2 === 'edit-spu')}
                                style={currentRowsEmpty ? {
                                    display: 'flex',
                                    height: '34px',
                                    minWidth: '100px',
                                    padding: '8px',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    gap: '10px',
                                    borderRadius: '8px',
                                    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.10)",
                                } : {}}
                            >
                                Next
                            </button>
                        )}

                        {currentTab?.buttons?.includes("save") && (
                            <button
                                className={`dark-border ${currentRowsEmpty ? 'disabled' : ''}`}
                                type="button"
                                onClick={handleSaveSKUCode}
                                disabled={currentRowsEmpty}
                                style={currentRowsEmpty ? {
                                    backgroundColor: '#CED4DA',
                                    color: '#fff',
                                    borderColor: 'transparent'
                                } : {}}
                            >
                                Save
                            </button>
                        )}
                    </div>
                </div>

                {saveModalOpen && (
                    <>
                        <div className="drawer-overlay" />
                        <div
                            className="entity-drawer modal-popup-cls"
                            ref={saveRef}
                            style={{
                                maxWidth: 650,
                                margin: "0 auto",
                                background: "white",
                                borderRadius: 12,
                                zIndex: 1050,
                                padding: 24,
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                height: "auto",
                                right: "auto",
                                overflow: "inherit",
                            }}
                        >
                            <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                <button className="close-btn" onClick={() => setSaveModalOpen(false)}>
                                    <X size={20} />
                                </button>
                            </div>
                            <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>Please create SKU before proceed</h3>
                            <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                <button className="btn-save" onClick={handleSaveConfirm}>
                                    OK
                                </button>
                            </div>
                        </div>
                    </>
                )}
                <div
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                        paddingBottom: '24px',
                    }}
                >
                    <div className="employee-tabs-container">
                        {saveModalOpen2 && (
                            <>
                                <div className="drawer-overlay" />
                                <div
                                    className="entity-drawer modal-popup-cls"
                                    ref={saveRef2}
                                    style={{
                                        maxWidth: 650,
                                        margin: "0 auto",
                                        background: "white",
                                        borderRadius: 12,
                                        zIndex: 1050,
                                        padding: 24,
                                        position: "fixed",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                        height: "auto",
                                        right: "auto",
                                        overflow: "inherit",
                                    }}
                                >
                                    <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                        <button className="close-btn" onClick={() => setSaveModalOpen2(false)}>
                                            <X size={20} />
                                        </button>
                                    </div>
                                    <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>The edit function implemenation</h3>
                                    <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                        <button className="btn-save" onClick={handleSaveConfirm2}>
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                        
                        {!discardModalOpen && (
                            <UnsavedChangesPrompt
                                isDirty={isDirty && !isSaving}
                                entityName={'SPU and SKU'}
                            />
                        )}
                        
                        {activeTab2 === 'edit-spu' && (
                            <div className="tab-content" id="edit-spu-content">
                                <div className="info-section">
                                    <div className="info-card new-info-overflow-auto">
                                        <div className="info-header">
                                            <h4 className="info-title">Basic Info</h4>
                                        </div>
                                        <div className="info-content d-block">
                                            <div className='grid-info-adding'>
                                                <div className='row gappingcls-added'>
                                                    <div className='col-lg-6 col-md-6 col-12'>
                                                        <div className="info-inner">
                                                            <label
                                                                htmlFor="spuName"
                                                                className="form-label d-flex align-items-center gap-1"
                                                            >
                                                                SPU Name <span className='error-color'>*</span>
                                                            </label>

                                                            <input
                                                                type="text"
                                                                className="form-control common-input-all"
                                                                id="spuName"
                                                                name="model_name"
                                                                value={formData.model_name}
                                                                onChange={handleChange}
                                                                onBlur={handleFieldBlur}
                                                                style={errors.model_name ? { borderColor: '#dc3545' } : { border: '1px solid #6C757D' }}
                                                            />

                                                            {errors.model_name && (
                                                                <div className="invalid-feedback d-block">
                                                                    {errors.model_name}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className='col-lg-6 col-md-6 col-12'>
                                                        <div className="info-inner">
                                                            <label htmlFor="status" className="form-label">
                                                                Status <span className='error-color'>*</span>
                                                            </label>
                                                            <div className='flexing-type-radio'>
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        id="flexRadioDefault1"
                                                                        name="status"
                                                                        value="1"
                                                                        checked={formData.status === '1'}
                                                                        onChange={handleChange}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor="flexRadioDefault1"
                                                                        style={{ fontWeight: 'normal', fontSize: '14px' }}
                                                                    >
                                                                        Active
                                                                    </label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        id="flexRadioDefault2"
                                                                        name="status"
                                                                        value="0"
                                                                        checked={formData.status === '0'}
                                                                        onChange={handleChange}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor="flexRadioDefault2"
                                                                        style={{ fontWeight: 'normal', fontSize: '14px' }}
                                                                    >
                                                                        Inactive
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row gappingcls-added'>
                                                    <div className='col-lg-6 col-md-6 col-12'>
                                                        <div className="info-inner">
                                                            <label
                                                                htmlFor="modelPrefix"
                                                                className="form-label d-flex align-items-center gap-1"
                                                            >
                                                                Prefix
                                                                <Tooltip title="Prefix" body="A short code for the SPU, used in automating SKU Code generation">
                                                                    <Info size={16} className="info-icon" />
                                                                </Tooltip>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className={`form-control common-input-all`}
                                                                id="modelPrefix"
                                                                name="prefix"
                                                                value={formData.prefix} onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-6 col-md-6 col-12'>
                                                        <div className="info-inner">
                                                            <label
                                                                htmlFor="modelPrefix"
                                                                className="form-label d-flex align-items-center gap-1"
                                                            >
                                                                ID
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control common-input-all"
                                                                id="modelPrefix"
                                                                name="model_id"
                                                                value={formData.model_id}
                                                                onChange={handleChange}
                                                                onBlur={handleFieldBlur}
                                                                style={errors.model_id ? { borderColor: '#dc3545' } : { border: '1px solid #6C757D' }}
                                                            />
                                                            {errors.model_id && (
                                                                <div className="invalid-feedback d-block">
                                                                    {errors.model_id}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="info-card new-info-overflow-auto">
                                        <div className="info-header">
                                            <h4 className="info-title">Product Info</h4>
                                        </div>
                                        <div className="info-content d-block">
                                            <div className='grid-info-adding'>
                                                <div className='row gappingcls-added'>
                                                    <div className='col-lg-6 col-md-6 col-12'>
                                                        <MultiSelectSearch
                                                            label="Brand"
                                                            tooltip={<span className='error-color'>*</span>}
                                                            options={brands}
                                                            selected={
                                                                formData.brand_id
                                                                    ? [brands.find(b => b.brand_id === formData.brand_id)]
                                                                    : []
                                                            }
                                                            setSelected={(sel) => {
                                                                if (!isDirty) setIsDirty(true);
                                                                const brand = sel[0] || null;
                                                                setFormData(prev => ({ ...prev, brand_id: brand ? brand.brand_id : "" }));
                                                                setFormErrors(prev => ({ ...prev, brand_id: "" }));
                                                            }}
                                                            idKey="brand_id"
                                                            displayKey="brand_name"
                                                            logoKey="original_logo_url"
                                                            multiple={false}
                                                            keysToSearch={["brand_name"]}
                                                            fallbackImage={noImage}
                                                            error={!!errors.brand_id}
                                                            triggerValidation={(item) => {
                                                                checkDuplicate(item);
                                                            }}
                                                            subTitleFn={(item) => {
                                                                const h = item.brand_hierarchy || [];
                                                                return h.length >= 1 ? h.map(b => b.name).join(' >> ') : null;
                                                            }}
                                                        />

                                                        {errors.brand_id && (
                                                            <div className="invalid-feedback d-block" style={{ marginTop: '4px' }}>
                                                                {errors.brand_id}
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className='col-lg-6 col-md-6 col-12'>
                                                        <div className="info-inner">
                                                            <MultiSelectSearch
                                                                label="Category"
                                                                tooltip={<span className='error-color'>*</span>}
                                                                options={categories}
                                                                selected={
                                                                    formData.category_id
                                                                        ? [categories.find(c => c.category_id === formData.category_id)]
                                                                        : []
                                                                }
                                                                setSelected={(sel) => {
                                                                    if (!isDirty) setIsDirty(true);
                                                                    const category = sel[0] || null;
                                                                    const newCategoryId = category ? category.category_id : "";
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        category_id: newCategoryId
                                                                    }));
                                                                    setFormErrors(prev => ({ ...prev, category_id: "" }));
                                                                }}
                                                                idKey="category_id"
                                                                displayKey="category_name"
                                                                logoKey={null}
                                                                multiple={false}
                                                                keysToSearch={["category_name"]}
                                                                fallbackImage={null}
                                                                error={!!errors.category_id}
                                                                customRender={(category) => {
                                                                    const hierarchy = getHierarchyString({
                                                                        hierarchy: getAllHierarchies([category])[0]?.hierarchy || []
                                                                    });
                                                                    return (
                                                                        <div>
                                                                            <div style={{ color: '#000', fontWeight: '500' }}>
                                                                                {category.category_name}
                                                                            </div>
                                                                            {hierarchy && (
                                                                                <div style={{ fontSize: '12px', color: '#6C757D' }}>
                                                                                    {hierarchy}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                }}
                                                            />

                                                            {errors.category_id && (
                                                                <div className="invalid-feedback d-block" style={{ marginTop: '4px' }}>
                                                                    {errors.category_id}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row gappingcls-added'>
                                                   {/* Find this section in the code (around line 2000-2050) - Type field */}
<div className='col-lg-6 col-md-6 col-12'>
    <div className="info-inner">
        <label
            htmlFor="type"
            className="form-label d-flex align-items-center gap-1"
        >
            Type<span className='error-color'>*</span>
        </label>
        <div style={{ position: "relative" }} ref={osTypeRef}>
            <div
                className="`form-control common-input-all d-flex justify-between items-center cursor-pointer rounded p-"
                onClick={toggleOsType}
                style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    height: '40px', 
                    alignContent: 'center', 
                    border: errors.set_type ? '1px solid #dc3545' : '1px solid #6C757D',
                    position: 'relative'
                }}
            >
                <div style={{ flex: 1 }}>
                    {isOsTypeOpen ? (
                        <input
                            type="text"
                            autoFocus
                            value={osTypeSearch}
                            onChange={(e) => setOsTypeSearch(e.target.value)}
                            style={{
                                width: "100%",
                                border: "none",
                                outline: "none",
                                background: "transparent",
                            }}
                        />
                    ) : (
                        formData.set_type || ''
                    )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* Clear icon - only show when there's a value and dropdown is closed */}
                    {formData.set_type && !isOsTypeOpen && (
                        <X
                            size={12} 
                            style={{ 
                                cursor: 'pointer'
                            }}
                            onClick={(e) => {
                                e.stopPropagation(); // Prevent dropdown from opening
                                if (!isDirty) setIsDirty(true);
                                setFormData(prev => ({ ...prev, set_type: '' }));
                                setFormErrors(prev => ({ ...prev, set_type: '' }));
                                setOsTypeSearch(''); // Clear search as well
                            }}
                        />
                    )}
                    <ChevronDown size={19} strokeWidth={2.3}/>
                </div>
            </div>

            {isOsTypeOpen && (
                <div
                    className="bg-white border rounded shadow-lg mt-1"
                    style={{ maxHeight: '270px', overflowY: 'auto', position: "absolute", right: 0, left: 0, width: "100%", zIndex: 1 }}
                >
                    {filteredOsTypes.length > 0 ? (
                        filteredOsTypes.map((type, index) => (
                            <div
                                key={index}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#FFFDE7'}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                className="p-2 hover:bg-gray-100 flex items-center cursor-pointer"
                                onClick={() => {
                                    if (!isDirty) setIsDirty(true);
                                    const newSetType = type?.product_type;
                                    handleOsTypeSelect(newSetType);
                                    setFormErrors(prev => ({ ...prev, set_type: "" }));
                                }}
                            >
                                {type?.product_type}
                            </div>
                        ))
                    ) : (
                        <div className="p-2 text-gray-500">No types found</div>
                    )}
                </div>
            )}

            {errors.set_type && (
                <div className="invalid-feedback d-block">
                    {errors.set_type}
                </div>
            )}
        </div>
    </div>
</div>
                                                    <div className='col-lg-6 col-md-6 col-12'>
                                                        <CalendarInput
                                                            label="Release Date"
                                                            name="release_date"
                                                            value={formData.release_date}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row gappingcls-added">
                                                    <div className="col-12">
                                                        <div className="info-inner">
                                                            <label className="form-label d-flex align-items-center gap-2">
                                                                Images
                                                            </label>

                                                            <div
                                                                className="upload-container"
                                                                onClick={handleBrowseClick}
                                                                onDragOver={e => e.preventDefault()}
                                                                onDragEnter={() => setIsDragging(true)}
                                                                onDragLeave={() => setIsDragging(false)}
                                                                onDrop={handleDrop}
                                                                style={{
                                                                    border: '2px dashed #ccc',
                                                                    borderRadius: 4,
                                                                    padding: '3rem 1.5rem',
                                                                    textAlign: 'center',
                                                                    cursor: 'pointer',
                                                                    backgroundColor: isDragging ? '#CFE2FF' : '#fff',
                                                                    borderColor: errors.uploaded_images ? '#dc3545' : (isDragging ? '#0D6EFD' : '#ccc'),
                                                                    transition: 'background-color 0.3s ease',
                                                                }}
                                                            >
                                                                <CloudUpload size={32} />
                                                                <p style={{ margin: 0, color: '#555', fontSize: '0.9rem' }}>
                                                                    Drag your image here or{' '}
                                                                    <span style={{ color: '#007bff', textDecoration: 'underline' }}>
                                                                        Browse
                                                                    </span>
                                                                </p>
                                                                <input
                                                                    type="file"
                                                                    accept="image/*"
                                                                    multiple
                                                                    ref={fileInputRef}
                                                                    style={{ display: 'none' }}
                                                                    onChange={handleImageChange}
                                                                />
                                                            </div>

                                                            {errors.uploaded_images && (
                                                                <div className="invalid-feedback d-block">
                                                                    {errors.uploaded_images}
                                                                </div>
                                                            )}

                                                            {uploadedImages.length > 0 && (
                                                                <div className="uploaded-images mt-3">
                                                                    <p className='mb-3'>
                                                                        {uploadedImages.length} Image
                                                                        {uploadedImages.length > 1 ? 's' : ''} uploaded
                                                                    </p>

                                                                    <ReactSortable
                                                                        list={uploadedImages}
                                                                        setList={setUploadedImages}
                                                                        handle=".drag-handle"
                                                                        tag="div"
                                                                        className="row g-2"
                                                                        chosenClass="is-dragging"
                                                                    >
                                                                        {uploadedImages.map(img => (
                                                                            <div className="col-md-4 col-sm-6" key={img.spu_image_id}>
                                                                                <div className="d-flex align-items-center justify-content-between p-2 border rounded" style={{ boxShadow: '0px 1px 4px 0px #0000001A' }}>
                                                                                    <div className="d-flex align-items-center gap-2">
                                                                                        <X size={18} onClick={() => handleRemove(img.id)} className="cursor-pointer" style={{ flex: 'none' }} />
                                                                                        <img
                                                                                            src={img.preview}
                                                                                            alt="preview"
                                                                                            style={{
                                                                                                width: 40,
                                                                                                height: 40,
                                                                                                objectFit: 'cover',
                                                                                                borderRadius: 4,
                                                                                            }}
                                                                                        />
                                                                                        <div>
                                                                                            <div style={{ fontSize: '0.85rem', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '150px', color: '#6C757D' }}>
                                                                                                {img.file.name}
                                                                                            </div>
                                                                                            <div style={{ fontSize: '0.75rem', color: '#6C757D' }}>{formatSize(img.file.size)}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <Menu
                                                                                        size={16}
                                                                                        className="drag-handle text-muted"
                                                                                        style={{ cursor: 'grab', flex: 'none' }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </ReactSortable>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="info-card new-info-overflow-auto main-company-body-inner">
                                        <div className="info-header"><h4 className="info-title">Customised Info</h4></div>
                                        <div className="info-content d-block entities-tab">
                                            <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                                                {showTable && rows.length > 0 ? (
                                                    <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto', marginBottom:"20px"}}>
                                                        <table className="entities-table">
                                                            <thead>
                                                                <tr>
                                                                    <th />
                                                                    <th>
                                                                        Field Name <span style={{ color: "red" }}>*</span>
                                                                    </th>
                                                                    <th>
                                                                        Field Type <span style={{ color: "red" }}>*</span>
                                                                    </th>
                                                                    <th>
                                                                        Field Value <span style={{ color: "red" }}>*</span>
                                                                    </th>
                                                                    <th />
                                                                </tr>
                                                            </thead>
                                                            <ReactSortable list={rows} setList={setRows} handle=".drag-handle" tag="tbody">
                                                                {rows.map((r, idx) => {
                                                                    if (!rowRefs.current[r.id]) rowRefs.current[r.id] = React.createRef();
                                                                    const ref = rowRefs.current[r.id];
                                                                    return <EntityRow
                                                                        key={r.id}
                                                                        refNode={ref}
                                                                        rowState={r}
                                                                        index={idx}
                                                                        deleteRow={deleteRow}
                                                                        updateRowBulk={updateRowBulk}
                                                                        errors={errors}
                                                                        handleCustomFieldBlur={handleCustomFieldBlur}
                                                                        setFormErrors={setFormErrors}
                                                                    />;
                                                                })}
                                                            </ReactSortable>
                                                        </table>
                                                    </div>
                                                ) : showTable && rows.length === 0 ? (
                                                    <div style={{ textAlign: 'center', padding: '20px', color: '#6C757D' }}>
                                                        No custom fields added yet. Click "Add Field" to add one.
                                                    </div>
                                                ) : null}

                                                <div className="edit-organisation-info" style={{ display: 'flex', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                                                    <button
                                                        onClick={addRow}
                                                        className="dark-button"
                                                    >
                                                        Add Field
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="info-card">
                                        <div className="info-header">
                                            <h4 className="info-title">Notes</h4>
                                        </div>
                                        <div className="info-content">
                                            <div className="info-inner common-textarea">
                                                <textarea
                                                    className="form-control w-100 common-textarea-all"
                                                    id="exampleFormControlTextarea1"
                                                    rows="3"
                                                    name="notes"
                                                    value={formData.notes} onChange={handleChange}
                                                ></textarea>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {activeTab2 === 'sku-variations' && (
                            <div className="tab-content" id="sku-variations-content">
                                <div className="info-section">
                                    <div className="info-card new-info-overflow-auto main-company-body-inner">
                                        <div className="info-content d-block entities-tab">
                                            <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                                                <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                                                    <table className="entities-table tab-table w-100" style={{ borderCollapse: 'collapse' }}>
                                                        <thead height="45px">
                                                            <tr>
                                                                <th />
                                                                <th>
                                                                    SKU Variation <span style={{ color: "red" }}>*</span>
                                                                </th>
                                                                <th>
                                                                    Variation Options <span style={{ color: "red" }}>*</span>
                                                                </th>
                                                                <th />
                                                            </tr>
                                                        </thead>
                                                        <ReactSortable list={rows2} setList={setRows2} handle=".drag-handle" tag="tbody">
                                                            {rows2?.length ? rows2.map((r, idx) => {
                                                                if (!rowRefs2.current[r.id]) rowRefs2.current[r.id] = React.createRef();
                                                                return (
                                                                    <VariationRow
    key={r.id}
    refNode={rowRefs2.current[r.id]}
    rowState={r}
    deleteRow={deleteRow2}
    updateRow={updateRow2}
    skuAttributes={skuAttributes}
    skuAttributeOptions={skuAttributeOptions}
    rows2={rows2 || []}
    showMissingVariationError={showMissingVariationError}
    errors={variationErrors}
    onFieldBlur={handleVariationFieldBlur}
    setVariationErrors={setVariationErrors} // Add this
    setNotification={setNotification} 
/>
                                                                );
                                                            }) : null}
                                                        </ReactSortable>
                                                    </table>
                                                </div>
                                                <div className="edit-organisation-info" style={{ display: 'flex', marginTop: '20px', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                                                    {/* <button onClick={addRow2} className="dark-button" disabled={isAddVariationDisabled}>Add SKU</button> */}
                                                            {/* button should be enable all time */}
                                                    <button style={{padding:'10px'}} onClick={addRow2} className="dark-button" >Add Variation</button> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {archivedModalOpen && (
                            <>
                                <div className="drawer-overlay" />

                                <div
                                    className="entity-drawer modal-popup-cls"
                                    ref={archivedRef}
                                    style={{
                                        maxWidth: 650,
                                        margin: "0 auto",
                                        background: "white",
                                        borderRadius: 12,
                                        zIndex: 1050,
                                        padding: 24,
                                        position: "fixed",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                        height: "auto",
                                        right: "auto",
                                        overflow: "inherit",
                                    }}
                                >
                                    <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                        <button className="close-btn" onClick={() => setArchivedModalOpen(false)}>
                                            <X size={20} />
                                        </button>
                                    </div>

                                    <h3 style={{
                                        textAlign: "left", color: "#212529", fontSize: "20px",
                                        fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat",
                                        marginBottom: "5px"
                                    }}>The SPU can't be archived</h3>

                                    <p style={{
                                        marginBottom: "0", textAlign: "left", color: "#6C757D",
                                        fontSize: "14px", fontWeight: "400", lineHeight: "20px",
                                        fontFamily: "Montserrat"
                                    }}>
                                        This SPU can't be archived because it's referenced by one or more SPUs.
                                        Please remove or reassign those SPUs before archiving.
                                    </p>

                                    <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                        <button className="btn-save" onClick={handleArchivedConfirm}>
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}

                        {activeTab2 === 'sku-configurations' && (
                            <div className="tab-content" id="sku-configurations-content">
                                <div className="info-section">
                                    <div className="info-card new-info-overflow-auto main-company-body-inner">
                                        <div className="info-content d-block entities-tab">
                                            <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                                                {showConfigTable && (
                                                    <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                                                    <table className="entities-table tab-table w-100">
                                                        <thead height="35px">
                                                            <tr>
                                                                    <th />
                                                                    <th style={{maxWidth: "150px"}}>Configuration Name <span style={{ color: "#DC3545" }}>*</span></th>
                                                                    <th style={{maxWidth:"400px"}}>Configuration Options <span style={{ color: "#DC3545" }}>*</span></th>
                                                                    <th />
                                                                </tr>
                                                        </thead>
                                                        <ReactSortable
                                                            list={rows3}
                                                            setList={(newList) => {
                                                                if (!isDirty) setIsDirty(true);
                                                                setRows3(newList);

                                                                const newRowsCf = {};
                                                                const newConfigNotes = {};
                                                                const newConfigImages = {};

                                                                newList.forEach(row => {
                                                                    const tabKey = row.uniqueKey;
                                                                    if (rowsCf[tabKey]) {
                                                                        newRowsCf[tabKey] = rowsCf[tabKey];
                                                                    }
                                                                    if (configNotes[tabKey]) {
                                                                        newConfigNotes[tabKey] = configNotes[tabKey];
                                                                    }
                                                                    if (configImages[tabKey]) {
                                                                        newConfigImages[tabKey] = configImages[tabKey];
                                                                    }
                                                                });

                                                                Object.keys(rowsCf).forEach(key => {
                                                                    if (!newRowsCf[key]) {
                                                                        newRowsCf[key] = rowsCf[key];
                                                                    }
                                                                });

                                                                Object.keys(configNotes).forEach(key => {
                                                                    if (!newConfigNotes[key]) {
                                                                        newConfigNotes[key] = configNotes[key];
                                                                    }
                                                                });

                                                                Object.keys(configImages).forEach(key => {
                                                                    if (!newConfigImages[key]) {
                                                                        newConfigImages[key] = configImages[key];
                                                                    }
                                                                });

                                                                setRowsCf(newRowsCf);
                                                                setConfigNotes(newConfigNotes);
                                                                setConfigImages(newConfigImages);
                                                            }}
                                                            handle=".drag-handle"
                                                            tag="tbody"
                                                        >
                                                            {rows3.map((r, idx) => {
                                                                if (!rowRefs3.current[r.id]) rowRefs3.current[r.id] = React.createRef();
                                                                return (
                                                                    <ConfigRow
                                                                        key={r.uniqueKey}
                                                                        refNode={rowRefs3.current[r.id]}
                                                                        rowState={r}
                                                                        index={idx}
                                                                        deleteRow={deleteRow3}
                                                                        updateRow={updateRow3}
                                                                        rows2={rows2}
                                                                        skuAttributes={skuAttributes}
                                                                        skuAttributeOptions={skuAttributeOptions}
                                                                        errors={configErrors}
                                                                        onFieldBlur={handleConfigFieldBlur}
                                                                        setShowConfigTable = {setShowConfigTable}
                                                                        rows3 = {rows3}
                                                                    />
                                                                );
                                                            })}
                                                        </ReactSortable>
                                                    </table>
                                                </div>
                                                )}
                                                {/* <div className="edit-organisation-info" > */}

                                                {/* commented by asfaq : need design as figma */}
                                                <div style={{paddingTop:"10px", boxShadow:'none', marginBottom:'-20px'}} className='edit-organisation-info'>
                                                    {/* <button onClick={() => {addRow3(); setShowConfigTable(true);  }} className="dark-button" style={{ display: 'flex', height: '34px', minWidth: '100px', padding: '10px', justifyContent: 'center', alignItems: 'center', gap: '10px', borderRadius: '8px', fontSize: '12px', fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '600', lineHeight: 'normal', border: '1px solid #212529', }} disabled={isAddConfigDisabled}>Add Configurations</button> */}
                                                    <button onClick={() => {addRow3(); setShowConfigTable(true);  }} className="dark-button" style={{ display: 'flex', height: '34px', minWidth: '100px', padding: '10px', justifyContent: 'center', alignItems: 'center', gap: '10px', borderRadius: '8px', fontSize: '12px', fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '600', lineHeight: 'normal', border: '1px solid #212529' }} >Add Configuration</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {rows3.length > 0 && (
                                        <div className="info-card new-info-overflow-auto main-company-body-inner">
                                            <div className="info-content d-block entities-tab">
                                                <div className="pt-container">
                                                    <div className="tabs-wrapper">
                                                        <div className="tabs" ref={containerRef}>
                                                            {productTabs
                                                                .filter(t => !overflowTabs.includes(t.key))
                                                                .map(tab => (
                                                                    <button
                                                                        key={tab.key}
                                                                        ref={el => el && (tabRefs.current[tab.key] = el)}
                                                                        className={`tab ${activeTab === tab.key ? "active" : ""}`}
                                                                        onClick={() => {
                                                                            setUserSwitchedTab(true);
                                                                            setActiveTab(tab.key);
                                                                            setMenuOpen(false);
                                                                        }}
                                                                    >
                                                                        {tab.label}
                                                                    </button>
                                                                ))}
                                                        </div>

                                                        <button
                                                            ref={triggerRef}
                                                            className={`tab-trigger ${menuOpen ? "active" : ""}`}
                                                            onClick={toggleMenu}
                                                        >
                                                            <ChevronDown className="h-5 w-5" />
                                                        </button>
                                                    </div>

                                                    {portalMenu}

                                                <div className="tab-content" style={{ marginTop: '20px' }}>
    {productTabs.length > 0 ? (
        productTabs.map(tab => (
            <div 
                key={tab.key} 
                style={{ display: activeTab === tab.key ? 'block' : 'none' }}  // Only show active tab
            >
                <div className='grid-info-adding' style={{
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "auto",
                    boxSizing: "border-box",
                }}>
                    <div className="row gappingcls-added">
                        <div className="col-12">
                            <div className="info-inner">
                                <label className="form-label d-flex align-items-center gap-2">
                                    Images
                                </label>

                                <div style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
                                    <div
                                        className="upload-container"
                                        onClick={() => {
                                            const input = document.createElement('input');
                                            input.type = 'file';
                                            input.accept = 'image/*';
                                            input.multiple = true;
                                            input.onchange = (e) => handleConfigImageChange(e, tab.id);
                                            input.click();
                                        }}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDragEnter={() => setIsDragging(true)}
                                        onDragLeave={() => setIsDragging(false)}
                                        onDrop={(e) => handleConfigDrop(e, tab.id)}
                                        style={{
                                            width: "100%",
                                            maxWidth: "100%",
                                            boxSizing: "border-box",
                                            border: `2px dashed ${configImageErrors[tab.id] ? '#dc3545' : (isDragging ? '#0D6EFD' : '#ccc')}`,
                                            borderRadius: 4,
                                            padding: "1.5rem",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            minHeight: "120px",
                                            textAlign: "center",
                                            cursor: "pointer",
                                            backgroundColor: isDragging ? "#CFE2FF" : "#fff",
                                            transition: "background-color 0.3s ease, border-color 0.3s ease",
                                        }}
                                    >
                                        <CloudUpload size={32} style={{ marginBottom: "0.5rem" }} />
                                        <p style={{ margin: 0, color: "#555", fontSize: "0.9rem" }}>
                                            Drag your image here or{" "}
                                            <span style={{ color: "#007bff", textDecoration: "underline" }}>
                                                Browse
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                
                                {configImageErrors[tab.id] && (
                                    <div className="invalid-feedback d-block mb-2">
                                        {configImageErrors[tab.id]}
                                    </div>
                                )}
                                
                                {configImages[tab.id]?.length > 0 && (
                                    <div className="uploaded-images mt-3">
                                        <p className="mb-3">
                                            {configImages[tab.id].length} Image
                                            {configImages[tab.id].length > 1 ? "s" : ""} uploaded
                                        </p>

                                        <ReactSortable
                                            list={configImages[tab.id] || []}
                                            setList={(newList) => {
                                                if (!isDirty) setIsDirty(true);
                                                setConfigImages(prev => ({
                                                    ...prev,
                                                    [tab.id]: newList
                                                }));
                                            }}
                                            handle=".drag-handle"
                                            tag="div"
                                            className="row g-2"
                                            chosenClass="is-dragging"
                                        >
                                            {(configImages[tab.id] || []).map((img) => (
                                                <div className="col-md-4 col-sm-6" key={img.id}>
                                                    <div
                                                        className="d-flex align-items-center justify-content-between p-2 border rounded"
                                                        style={{ boxShadow: "0px 1px 4px 0px #0000001A" }}
                                                    >
                                                        <div className="d-flex align-items-center gap-2">
                                                            <X
                                                                size={18}
                                                                onClick={() => handleConfigRemove(img.id, tab.id)}
                                                                className="cursor-pointer"
                                                                style={{ flex: "none" }}
                                                            />
                                                            <img
                                                                src={img.preview}
                                                                alt="preview"
                                                                style={{
                                                                    width: 40,
                                                                    height: 40,
                                                                    objectFit: "cover",
                                                                    borderRadius: 4,
                                                                }}
                                                            />
                                                            <div>
                                                                <div
                                                                    style={{
                                                                        fontSize: "0.85rem",
                                                                        fontWeight: 500,
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        maxWidth: "150px",
                                                                        color: "#6C757D",
                                                                    }}
                                                                >
                                                                    {img.file.name}
                                                                </div>
                                                                <div style={{ fontSize: "0.75rem", color: "#6C757D" }}>
                                                                    {formatSize(img.file.size)}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <Menu
                                                            size={16}
                                                            className="drag-handle text-muted"
                                                            style={{ cursor: "grab", flex: "none" }}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </ReactSortable>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="row gappingcls-added" style={{ marginTop: '20px' }}>
                        <div className="col-12">
                            <div className="info-inner">
                                <label className="form-label d-flex align-items-center gap-2">
                                    Customised Info
                                </label>
                                <div className="info-content d-block entities-tab" style={{ padding: '0' }}>
                                    <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                                        <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                                            <table className="entities-table tab-table w-100">
                                                <thead>
                                                    <tr>
                                                        <th />
                                                        <th>
                                                            <span style={{
                                                                fontFamily: "Montserrat",
                                                                fontSize: "12px",
                                                                fontWeight: 700,
                                                                fontStyle: "normal",
                                                                color: "#212529",
                                                                display: "flex",
                                                                lineHeight: "normal",
                                                            }}>
                                                                Field Name <span style={{ color: "#DC3545" }}>*</span>
                                                            </span>
                                                        </th>
                                                        <th>
                                                            <span style={{
                                                                fontFamily: "Montserrat",
                                                                fontSize: "12px",
                                                                fontWeight: 700,
                                                                color: "#212529",
                                                                display: "flex",
                                                                lineHeight: "normal",
                                                                fontStyle: "normal",
                                                            }}>
                                                                Field Type <span style={{ color: "#DC3545" }}>*</span>
                                                            </span>
                                                        </th>
                                                        <th>
                                                            <span style={{
                                                                fontFamily: "Montserrat",
                                                                fontSize: "12px",
                                                                fontWeight: 700,
                                                                color: "#212529",
                                                                display: "flex",
                                                                lineHeight: "normal",
                                                                fontStyle: "normal",
                                                            }}>
                                                                Field Value  <span style={{ color: "#DC3545" }}>*</span>
                                                            </span>
                                                        </th>
                                                        <th />
                                                    </tr>
                                                </thead>
                                                <ReactSortable
                                                    list={rowsCf[tab.id] ?? []}
                                                    setList={(newList) => {
                                                        if (!isDirty) setIsDirty(true);
                                                        setRowsCf(prev => ({
                                                            ...prev,
                                                            [tab.id]: newList
                                                        }));
                                                    }}
                                                    handle=".drag-handle"
                                                    tag="tbody"
                                                >
                                                    {(rowsCf[tab.id] ?? []).map((r, idx) => {
                                                        if (!rowRefs.current[r.id]) rowRefs.current[r.id] = React.createRef();
                                                        const ref = rowRefs.current[r.id];
                                                        return <EntityRow
                                                            key={r.id}
                                                            refNode={ref}
                                                            rowState={r}
                                                            index={idx}
                                                            deleteRow={deleteRowCf}
                                                            updateRowBulk={updateRowBulkCf}
                                                            tabID={tab.id}
                                                            errors={errors}
                                                            handleCustomFieldBlur={handleCustomFieldBlur}
                                                            isConfigTab={true}
                                                            setFormErrors={setFormErrors}
                                                        />;
                                                    })}
                                                </ReactSortable>
                                            </table>
                                        </div>
                                        <div className="edit-organisation-info" style={{ display: 'flex', marginTop: '20px', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                                            <button 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    addRowCf(tab.id);
                                                }} 
                                                className="dark-button"
                                            >
                                                Add Fields
                                            </button>
                                        </div>
                                    </div>
                                    <div className="info-content" style={{ padding: "20px 0" }}>
                                        <div className="info-inner common-textarea">
                                            <label className="form-label d-flex align-items-center gap-2">
                                                Notes
                                            </label>
                                            <textarea
                                                className="form-control w-100 common-textarea-all"
                                                id="exampleFormControlTextarea1"
                                                rows="3"
                                                name="notes"
                                                value={configNotes[tab.id] || ''}
                                                onChange={(e) => handleChangeConfigNote(e.target.value, tab.id)}
                                                style={{ border: '1px solid #6C757D' }}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ))
    ) : (
        <div>No configurations available</div>
    )}
</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {activeTab2 === 'sku-code' && (
                            <div className="tab-content" id="sku-code-content">
                                <div className="info-section">
                                    <div className="info-card new-info-overflow-auto main-company-body-inner">
                                        <div className="info-content d-block entities-tab">
                                            {/* {console.log("handleSort debug:", typeof handleSort, handleSort)} */}
                                            <div ref={tableRef} className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                                                <table className="entities-table tab-table w-100 forth-page-table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{minWidth:'245px', padding:'10px'}}><span>SKU Spec </span></th>
                                                            <SortableHeader
                                                                label={<span>SKU Name <span style={{ color: "red" }}>*</span></span>}
                                                                field="name"
                                                                sortField={sortField}
                                                                sortOrder={sortOrder}
                                                                handleSort={(field) => handleSort(field)} 
                                                                sortable={false}
                                                            />
                                                            <SortableHeader
                                                                label={<span>SKU Code <span style={{ color: "red" }}>*</span>
                                                                    <Tooltip title="SKU Code" body="Auto generated by the rule defined in the SKU Code Scheme, it can be used to tag and track a SKU">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                            <g clip-path="url(#clip0_4743_12572)">
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                                                                                <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.14559 7.39094C4.97372 7.39094 4.91122 7.27031 4.95559 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                                                                                <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                                                                            </g>
                                                                            <defs>
                                                                                <clipPath id="clip0_4743_12572">
                                                                                    <rect width="10" height="10" fill="white" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>
                                                                    </Tooltip>
                                                                </span>}
                                                                field="sku_code"
                                                                sortField={sortField}
                                                                sortOrder={sortOrder}
                                                                sortable={false}
                                                                handleSort={(field) => handleSort(field)} 
                                                            />
                                                            <SortableHeader
                                                                label={<span>Enable <span style={{ color: "red" }}>*</span></span>}
                                                                field="status"
                                                                sortField={sortField}
                                                                sortOrder={sortOrder}
                                                                handleSort={(field) => handleSort(field)} 
                                                                sortable={false}
                                                            />
                                                            <SortableHeader
                                                                label={<span>GTIN
                                                                    <Tooltip title="GTIN" body="Global Trade Item Number of the SKU" >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                            <g clip-path="url(#clip0_4743_12572)">
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                                                                                <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.14559 7.39094C4.97372 7.39094 4.91122 7.27031 4.95559 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                                                                                <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                                                                            </g>
                                                                            <defs>
                                                                                <clipPath id="clip0_4743_12572">
                                                                                    <rect width="10" height="10" fill="white" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>
                                                                    </Tooltip>
                                                                </span>}
                                                                field="gtin"
                                                                sortField={sortField}
                                                                sortOrder={sortOrder}
                                                                handleSort={(field) => handleSort(field)} 
                                                                sortable={false}
                                                            />
                                                            <SortableHeader
                                                                label={<span>MSRP
                                                                    <Tooltip title="MSRP" body="Manufacturer's Suggested Retail Price of the SKU">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                        <g clip-path="url(#clip0_4743_12572)">
                                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                                                                            <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.14559 7.39094C4.97372 7.39094 4.91122 7.27031 4.95559 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                                                                            <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_4743_12572">
                                                                                <rect width="10" height="10" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                    </Tooltip>
                                                                </span>}
                                                                field="gtin"
                                                                sortField={sortField}
                                                                sortOrder={sortOrder}
                                                                handleSort={(field) => handleSort(field)} 
                                                                sortable={false}
                                                            />
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {paginatedRows.map((row, idx) => {
                                                            const realIndex = startIndex + idx;

                                                            return (
                                                            <tr
                                                                key={realIndex}
                                                                style={{
                                                                backgroundColor: idx % 2 === 0 ? "#FFFFFF" : "#F8F9FA",
                                                                }}
                                                            >
                                                                {/* NAME TAGS */}
<td style={{minWidth:'245px', padding:'10px'}}>
    <div
        style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            minHeight: "40px",
            gap: "10px",
            minWidth: "150px",
            maxWidth: "350px",
        }}
    >
        {/* 🔥 FIX: Use rows2 to maintain the correct variation order */}
        {rows2
            .filter((variation) => variation.fieldName && variation.opts?.length > 0)
            .map((variation, varIdx) => {
                const attribute = skuAttributes?.find(
                    (s) => s?.sku_preset_id == variation.fieldName
                );
                const optionId = row?.values?.[variation.fieldName];
                const option = skuAttributeOptions?.find(
                    (o) => o?.sku_preset_option_id == optionId
                );

                return (
                    <div key={varIdx}>
                        <span
                            style={{
                                color: "#212529",
                                fontSize: "12px",
                                lineHeight: "15px",
                                fontWeight: "400",
                                marginBottom: "5px",
                                display: "block",
                            }}
                        >
                            {attribute?.sku_preset_name ||
                                variation.fieldNameLabel ||
                                ""}
                        </span>
                        <span
                            style={{
                                backgroundColor: "#FFEB00",
                                color: "#212529",
                                borderRadius: "16px",
                                padding: "4px 8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "12px",
                                fontWeight: "600",
                                lineHeight: "17px",
                            }}
                        >
                            {option?.sku_preset_option_name || ""}
                        </span>
                    </div>
                );
            })}
    </div>
</td>

                                                                {/* SKU NAME */}
                                                                <td>
                                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                                    <input
                                                                    type="text"
                                                                    style={{
                                                                        minWidth: "200px",
                                                                        maxWidth: "200px",
                                                                        borderColor: skuNameErrors[realIndex]
                                                                        ? "#dc3545"
                                                                        : "#6C757D",
                                                                    }}
                                                                    className="form-control common-input-all"
                                                                    value={row?.name || ""}
                                                                    // In the SKU Name input onChange handler, update it to:
onChange={(e) => {
    if (!isDirty) setIsDirty(true);
    const val = e.target.value;
    setSkuCodeRows((prev) => {
        const updated = [...prev];
        updated[realIndex] = {
            ...updated[realIndex],
            name: val,
            isManuallyEdited: true,
        };
        return updated;
    });
    
    // Clear only this row's error when user starts typing
    setSkuNameErrors((prev) => {
        const updated = { ...prev };
        delete updated[realIndex];
        return updated;
    });
}}
onBlur={(e) => {
    const val = e.target.value.trim().toLowerCase();
    
    // For onBlur: Only validate the current field
    if (!val) {
        setSkuNameErrors((prev) => ({
            ...prev,
            [realIndex]: "SKU Name is required",
        }));
    } else {
        // Check if this specific value is duplicate in ANY other row
        const isDuplicate = skuCodeRows.some(
            (r, i) => i !== realIndex && r.name?.trim().toLowerCase() === val
        );
        
        if (isDuplicate) {
            setSkuNameErrors((prev) => ({
                ...prev,
                [realIndex]: "SKU Name already exists",
            }));
        } else {
            setSkuNameErrors((prev) => {
                const updated = { ...prev };
                delete updated[realIndex];
                return updated;
            });
        }
    }
}}

                                                                    />
                                                                    {skuNameErrors[realIndex] && (
                                                                    <div
                                                                        className="invalid-feedback d-block"
                                                                        style={{
                                                                        fontSize: "12px",
                                                                        marginTop: "4px",
                                                                        color: "#dc3545",
                                                                        }}
                                                                    >
                                                                        {skuNameErrors[realIndex]}
                                                                    </div>
                                                                    )}
                                                                </div>
                                                                </td>

                                                                {/* SKU CODE */}
                                                                <td>
                                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                                    <input
                                                                        type="text"
                                                                        style={{
                                                                            minWidth: "200px",
                                                                            maxWidth: "200px",
                                                                            borderColor: (skuCodeErrors[realIndex] || row?.skuCodeError)
                                                                                ? "#dc3545"
                                                                                : "#6C757D",
                                                                        }}
                                                                        className="form-control common-input-all"
                                                                        value={row?.sku_code || ""}
                                                                        onChange={(e) => handleSkuCodeChange(realIndex, e.target.value)}
                                                                        onBlur={(e) => handleSkuCodeBlur(realIndex, e.target.value)}
                                                                    />
                                                                    {(skuCodeErrors[realIndex] || row?.skuCodeError) && (
                                                                        <div
                                                                            className="invalid-feedback d-block"
                                                                            style={{ fontSize: "12px", marginTop: "4px", color: "#dc3545" }}
                                                                        >
                                                                            {skuCodeErrors[realIndex] || row?.skuCodeError}
                                                                        </div>
                                                                    )}
                                                                </div>
</td> 

                                                                {/* STATUS DROPDOWN */}
                                                                <td style={{ overflow: "visible" }}>
                                                                <div
                                                                    style={{ position: "relative", width: 200 }}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <div
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        const rect = e.currentTarget.getBoundingClientRect();
                                                                        setSkuCodeRows((prev) => {
                                                                        const updated = [...prev];
                                                                        updated[realIndex] = {
                                                                            ...updated[realIndex],
                                                                            _open: !updated[realIndex]?._open,
                                                                            _dropdownPos: {
                                                                            left: rect.left,
                                                                            top: rect.bottom + 6,
                                                                            width: rect.width,
                                                                            },
                                                                        };
                                                                        return updated;
                                                                        });
                                                                    }}
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        border: "1px solid #6C757D",
                                                                        borderRadius: 8,
                                                                        padding: "10px",
                                                                        height: 40,
                                                                        cursor: "pointer",
                                                                        background: "#fff",
                                                                        justifyContent: "space-between",
                                                                    }}
                                                                    >
                                                                    <span
                                                                        style={{
                                                                        padding: "5px 10px",
                                                                        fontWeight: 600,
                                                                        fontSize: 12,
                                                                        borderRadius: 99,
                                                                        minWidth: "72px",
                                                                        textAlign: "center",
                                                                        border:
                                                                            row?.status === "1"
                                                                            ? "1px solid #198754"
                                                                            : "1px solid #DC3545",
                                                                        backgroundColor:
                                                                            row?.status === "1" ? "#D1E7DD" : "#F8D7DA",
                                                                        color:
                                                                            row?.status === "1" ? "#198754" : "#DC3545",
                                                                        }}
                                                                    >
                                                                        {row?.status === "1" ? "YES" : "NO"}
                                                                    </span>

                                                                    <ChevronDown size={16} />
                                                                    </div>

                                                                    {/* PORTAL DROPDOWN */}
                                                                    {row?._open &&
                                                                    ReactDOM.createPortal(
                                                                        <div
                                                                        onMouseDown={(e) => e.stopPropagation()}
                                                                        style={{
                                                                            position: "fixed",
                                                                            top: row._dropdownPos.top,
                                                                            left: row._dropdownPos.left,
                                                                            width: row._dropdownPos.width,
                                                                            background: "#fff",
                                                                            border: "1px solid #cfd4dc",
                                                                            borderRadius: 12,
                                                                            padding: 6,
                                                                            zIndex: 99999,
                                                                            boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                                                                        }}
                                                                        >
                                                                        <div
                                                                            onMouseDown={() => {
                                                                            if (!isDirty) setIsDirty(true);
                                                                            setSkuCodeRows((prev) => {
                                                                                const updated = [...prev];
                                                                                updated[realIndex] = {
                                                                                ...updated[realIndex],
                                                                                status: "1",
                                                                                _open: false,
                                                                                };
                                                                                return updated;
                                                                            });
                                                                            }}
                                                                            style={{
                                                                            padding: 8,
                                                                            borderRadius: 10,
                                                                            cursor: "pointer",
                                                                            background:
                                                                                row?.status === "1"
                                                                                ? "#f5f7fa"
                                                                                : "transparent",
                                                                            }}
                                                                        >
                                                                            <span
                                                                            style={{
                                                                                padding: "5px 20px",
                                                                                borderRadius: 99,
                                                                                fontWeight: 600,
                                                                                fontSize: 12,
                                                                                minWidth: "72px",
                                                                                textAlign: "center",
                                                                                backgroundColor: "#D1E7DD",
                                                                                color: "#198754",
                                                                                border: "1px solid #198754",
                                                                            }}
                                                                            >
                                                                            YES
                                                                            </span>
                                                                        </div>

                                                                        <div
                                                                            onMouseDown={() => {
                                                                            if (!isDirty) setIsDirty(true);
                                                                            setSkuCodeRows((prev) => {
                                                                                const updated = [...prev];
                                                                                updated[realIndex] = {
                                                                                ...updated[realIndex],
                                                                                status: "0",
                                                                                _open: false,
                                                                                };
                                                                                return updated;
                                                                            });
                                                                            }}
                                                                            style={{
                                                                            padding: 8,
                                                                            borderRadius: 10,
                                                                            cursor: "pointer",
                                                                            background:
                                                                                row?.status === "0"
                                                                                ? "#f5f7fa"
                                                                                : "transparent",
                                                                            }}
                                                                        >
                                                                            <span
                                                                            style={{
                                                                                padding: "5px 20px",
                                                                                borderRadius: 99,
                                                                                fontWeight: 600,
                                                                                fontSize: 12,
                                                                                minWidth: "72px",
                                                                                textAlign: "center",
                                                                                backgroundColor: "#F8D7DA",
                                                                                color: "#c62828",
                                                                                border: "1px solid #dc3545",
                                                                            }}
                                                                            >
                                                                            NO
                                                                            </span>
                                                                        </div>
                                                                        </div>,
                                                                        document.body
                                                                    )}
                                                                </div>
                                                                </td>

                                                                {/* GTIN */}
<td>
    <input
        type="text"
        style={{ minWidth: "200px", maxWidth: "200px" }}
        className="form-control common-input-all"
        value={row?.gtin || ""}
        onChange={(e) => {
            if (!isDirty) setIsDirty(true);
            // Extract value safely
            const value = e.target?.value || e?.currentTarget?.value || "";
            setSkuCodeRows((prev) => {
                const updated = [...prev];
                updated[realIndex] = {
                    ...updated[realIndex],
                    gtin: value,
                };
                return updated;
            });
        }}
    />
</td>

                                                                {/* MSRP */}
<td>
    <div
        style={{
            display: "flex",
            alignItems: "center",
            width: "150px",
            height: "40px",
            border: "1px solid #6C757D",
            borderRadius: "8px",
            backgroundColor: "#fff",
            overflow: "hidden",
        }}
    >
        <span
            style={{
                padding: "0 12px",
                fontSize: "14px",
                color: "#6b7280",
                borderRight: "1px solid #6C757D",
                height: "100%",
                display: "flex",
                alignItems: "center",
                whiteSpace: "nowrap",
            }}
        >
            SGD
        </span>

        <input
            type="text"
            value={row?.msrp || ""}
            onChange={(e) => {
                if (!isDirty) setIsDirty(true);
                const value = e.target?.value || e?.currentTarget?.value || "";
                setSkuCodeRows((prev) => {
                    const updated = [...prev];
                    updated[realIndex] = {
                        ...updated[realIndex],
                        msrp: value,
                    };
                    return updated;
                });
            }}
            style={{
                flex: 1,
                border: "none",
                outline: "none",
                padding: "0 12px",
                fontSize: "14px",
                height: "100%",
            }}
        />
    </div>
</td>
                                                            </tr>
                                                            );
                                                        })}
                                                        </tbody>



                                                </table>
                                            </div>
                                            <div className="pagination">
                                                <div className="pagination-info">
                                                {`${startIndex + 1} - ${endIndex} of ${totalItems}`}
                                                </div>
                                                <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                onPageChange={setCurrentPage}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <style>
                    {`
                        .forth-page-table th,
                        .forth-page-table td {
                        position: relative;
                        overflow: visible;
                        }

                        /* Shadow only on first column */
                        .forth-page-table th:nth-child(1)::after,
                        .forth-page-table td:nth-child(1)::after {
                        content: "";
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 6px;       /* width of shadow */
                        height: 100%;
                        background: linear-gradient(
                            to right,
                            rgba(0, 0, 0, 0.12),
                            rgba(0, 0, 0, 0)
                        );
                        pointer-events: none;
                        z-index: 5;
                        }
                    `}
                </style>
            </div>
        </>
    );
}

// Replace the entire EntityRow component with this updated version:

function EntityRow({
    refNode,
    rowState: r,
    index: idx,
    deleteRow,
    updateRowBulk,
    tabID = null,
    errors,
    handleCustomFieldBlur,
    isConfigTab = false,
    setFormErrors
}) {
    const typeRef = useRef(null);
    const valueRef = useRef(null);
    const [portalStyle, setPortalStyle] = useState({});
    const [typePortalStyle, setTypePortalStyle] = useState({});

    useEffect(() => {
        if (r.isOpen && valueRef.current) {
            const rect = valueRef.current.getBoundingClientRect();
            setPortalStyle({
                position: 'absolute',
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
                background: '#fff',
                border: '1px solid #6c757d',
                borderRadius: '8px',
                overflow: 'visible',
                zIndex: 2000,
            });
        }
    }, [r.isOpen, r.opts, r.search]);

    useEffect(() => {
        if (r.typeOpen && typeRef.current) {
            const rect = typeRef.current.getBoundingClientRect();
            setTypePortalStyle({
                position: 'absolute',
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
                background: '#fff',
                border: '1px solid #6c757d',
                borderRadius: '8px',
                zIndex: 2000,
            });
        }
    }, [r.typeOpen]);

    // Get errors based on whether it's a config tab or SPU tab
    const getFieldNameError = () => {
        if (isConfigTab && tabID) {
            return r.error;
        }
        return errors?.[r.id]?.field_name;
    };

    const getFieldValueError = () => {
        if (isConfigTab && tabID) {
            return r.valueError;
        }
        return errors?.[r.id]?.field_value;
    };

    const handleFieldNameBlur = (e) => {
        if (handleCustomFieldBlur) {
            handleCustomFieldBlur(e, r.id, tabID);
        }
    };

    const handleFieldValueBlur = (e) => {
        if (handleCustomFieldBlur) {
            handleCustomFieldBlur(e, r.id, tabID);
        }
    };

    const handleFieldNameChange = (e) => {
        const newValue = e.target.value;
        updateRowBulk(r.id, { fieldName: newValue }, tabID);

        if (isConfigTab && tabID) {
            // For config tabs, clear error when user types
            const updatedRow = { ...r, fieldName: newValue };
            if (r.error && newValue.trim()) {
                updatedRow.error = '';
            }
            updateRowBulk(r.id, updatedRow, tabID);
        } else {
            // For SPU tab, clear error when user types
            if (setFormErrors && errors?.[r.id]?.field_name) {
                setFormErrors(prev => ({
                    ...prev,
                    [r.id]: {
                        ...prev[r.id],
                        field_name: ""
                    }
                }));
            }
        }
    };

    const handleFieldValueChange = (e) => {
        const newValue = e.target.value;
        updateRowBulk(r.id, { value: newValue }, tabID);

        if (isConfigTab && tabID) {
            // For config tabs, clear error when user types
            const updatedRow = { ...r, value: newValue };
            if (r.valueError && newValue.trim()) {
                updatedRow.valueError = '';
            }
            updateRowBulk(r.id, updatedRow, tabID);
        } else {
            // For SPU tab, clear error when user types
            if (setFormErrors && errors?.[r.id]?.field_value) {
                setFormErrors(prev => ({
                    ...prev,
                    [r.id]: {
                        ...prev[r.id],
                        field_value: ""
                    }
                }));
            }
        }
    };

    // Handle type selection for config tabs
    const handleTypeSelect = (fieldType) => {
        const updates = {
            fieldType: fieldType,
            refChild: '',
            value: '',
            opts: [],
            typeOpen: false,
        };

        if (isConfigTab && tabID && r.valueError) {
            updates.valueError = '';
        }

        updateRowBulk(r.id, updates, tabID);
    };

    // Handle option toggle for config tabs
    const handleOptionToggle = (opt, isAdding) => {
        const currentOpts = r.opts || [];
        let newOpts;
        
        if (isAdding) {
            newOpts = [...currentOpts, opt];
        } else {
            newOpts = currentOpts.filter(o => o.value !== opt.value);
        }
        
        updateRowBulk(r.id, { opts: newOpts }, tabID);
        
        // For config tabs, clear value error if options are selected
        if (isConfigTab && tabID && r.valueError && newOpts.length > 0) {
            const updatedRow = { ...r, opts: newOpts, valueError: '' };
            updateRowBulk(r.id, updatedRow, tabID);
        }
    };

    return (
        <tr ref={refNode} style={{
            position: (r.isOpen || r.typeOpen || r.refMenuOpen) ? 'relative' : 'static',
            zIndex: (r.isOpen || r.typeOpen || r.refMenuOpen) ? 1000 : 'auto'
        }}>
            <td>
                <button
                    className="btn p-0"
                    onClick={() => deleteRow(r.id, tabID)}
                    style={{ 
                        boxShadow: 'none',
                        border: 'none',
                        outline: 'none'
                    }}
                >
                    <Trash2 size={18} />
                </button>
            </td>

            <td style={{ minWidth: '200px', maxWidth: '200px', verticalAlign: 'top' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <input
                        className="form-control common-input-all"
                        value={r.fieldName}
                        onChange={handleFieldNameChange}
                        onBlur={handleFieldNameBlur}
                        name="field_name"
                        style={{
                            borderColor: getFieldNameError() ? '#dc3545' : '#6C757D'
                        }}
                    />
                    {getFieldNameError() && (
                        <div className="invalid-feedback d-block" style={{
                            fontSize: '12px',
                            marginTop: '4px',
                            color: '#dc3545'
                        }}>
                            {getFieldNameError()}
                        </div>
                    )}
                </div>
            </td>

            <td style={{ minWidth: "200px", maxWidth: "200px", verticalAlign: "top" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                        ref={typeRef}
                        className="form-select new-form-select-cls"
                        onClick={() => updateRowBulk(r.id, { typeOpen: !r.typeOpen }, tabID)}
                        style={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '0.5rem',
                            minHeight: '40px',
                            background: 'none',
                            border: '1px solid #6C757D',
                            borderRadius: '8px'
                        }}
                    >
                        <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            {r.fieldType === 'Text' ? (
                                'Text'
                            ) : (
                                <>
                                    Reference
                                    {r.refChild && (
                                        <span className="pill" style={{
                                            backgroundColor: '#e9ecef',
                                            color: '#495057',
                                            padding: '2px 8px',
                                            borderRadius: '12px',
                                            fontSize: '12px'
                                        }}>
                                            {r.refChild}
                                        </span>
                                    )}
                                </>
                            )}
                        </span>
                        <ChevronDown size={16} style={{ transform: r.typeOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
                    </div>

                    {r.typeOpen && (
                        <OptionPortal style={typePortalStyle}>
                            <ul
                                className="custom-check"
                                style={{
                                    margin: 0,
                                    padding: '8px 0',
                                    listStyle: 'none',
                                    overflow: 'visible',
                                    position: 'relative',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    borderRadius: '8px',
                                    minWidth: '200px'
                                }}
                            >
                                <li
                                    style={{
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        fontFamily: 'Montserrat',
                                        fontSize: '14px',
                                        color: '#212529',
                                        transition: 'background-color 0.2s'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                    onClick={() => handleTypeSelect('Text')}
                                >
                                    Text
                                </li>
                            </ul>
                        </OptionPortal>
                    )}
                </div>
            </td>

            <td style={{ position: 'relative', minWidth: '200px', maxWidth: '200px', verticalAlign: 'top' }}>
                {r.fieldType === 'Text' ? (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <input
                            className="form-control common-input-all"
                            value={r.value || ''}
                            onChange={handleFieldValueChange}
                            onBlur={handleFieldValueBlur}
                            name="field_value"
                            style={{
                                borderColor: getFieldValueError() ? '#dc3545' : '#6C757D'
                            }}
                        />

                        {getFieldValueError() && (
                            <div className="invalid-feedback d-block" style={{
                                fontSize: '12px',
                                marginTop: '4px',
                                color: '#dc3545'
                            }}>
                                {getFieldValueError()}
                            </div>
                        )}
                    </div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div
                            ref={valueRef}
                            className="select-box form-control common-input-all"
                            onClick={() => updateRowBulk(r.id, { isOpen: !r.isOpen }, tabID)}
                            style={{
                                padding: '0.5rem',
                                display: 'flex',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                cursor: 'pointer',
                                minHeight: '40px',
                                border: getFieldValueError() ? '1px solid #dc3545' : '1px solid #6C757D',
                                borderRadius: '4px',
                                gap: '4px'
                            }}
                        >
                            {r.opts && r.opts.length > 0 ? (
                                <>
                                    <span
                                        className="tag"
                                        style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            backgroundColor: 'transparent',
                                            color: '#6C757D',
                                            maxWidth: '100%',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {r.opts[0].label}
                                    </span>
                                    {r.opts.length > 1 && (
                                        <span style={{
                                            width: '24px',
                                            height: '24px',
                                            borderRadius: '50%',
                                            marginLeft: '5px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            backgroundColor: '#212529',
                                            color: '#fff',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}>
                                            +{r.opts.length - 1}
                                        </span>
                                    )}
                                </>
                            ) : (
                                <span style={{ color: '#999', fontSize: '14px' }}>
                                    {r.refChild ? `Select ${r.refChild}` : 'Select reference'}
                                </span>
                            )}
                            <ChevronDown size={16} style={{ marginLeft: 'auto', transform: r.isOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
                        </div>

                        {getFieldValueError() && (
                            <div className="invalid-feedback d-block" style={{
                                fontSize: '12px',
                                marginTop: '4px',
                                color: '#dc3545'
                            }}>
                                {getFieldValueError()}
                            </div>
                        )}

                        {r.isOpen && (
                            <OptionPortal style={portalStyle}>
                                <div style={{ padding: '0.5rem', position: 'relative' }}>
                                    <Search
                                        size={18}
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '18px',
                                            transform: 'translateY(-50%)',
                                            color: '#6c757d',
                                        }}
                                    />
                                    <input
                                        type="text"
                                        className="form-control common-input-all search-input select-box"
                                        placeholder="Search..."
                                        value={r.search || ''}
                                        onChange={(e) => updateRowBulk(r.id, { search: e.target.value }, tabID)}
                                        style={{
                                            paddingLeft: '2rem',
                                            border: '1px solid #6C757D'
                                        }}
                                    />
                                </div>

                                <div style={{
                                    padding: '0 15px 8px',
                                    fontSize: '12px',
                                    fontWeight: '400',
                                    color: '#6C757D',
                                    borderBottom: '1px solid #e9ecef'
                                }}>
                                    Search Results
                                </div>

                                <ul
                                    className="options-list custom-check info-inner"
                                    style={{
                                        listStyle: 'none',
                                        margin: 0,
                                        padding: '8px 0',
                                        maxHeight: '200px',
                                        overflowY: 'auto'
                                    }}
                                >
                                    {REFERENCE_OPTIONS[r.refChild]
                                        ?.filter(opt => opt.label.toLowerCase().includes((r.search || '').toLowerCase()))
                                        ?.filter(opt => !r.opts?.some(o => o.value === opt.value))
                                        ?.map(opt => (
                                            <li key={opt.value} style={{ marginBottom: '4px' }}>
                                                <label
                                                    className="option-item"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: '400',
                                                        lineHeight: '1.4',
                                                        padding: '8px 16px',
                                                        transition: 'background-color 0.2s'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        style={{
                                                            marginRight: '8px',
                                                            marginTop: '2px',
                                                            cursor: 'pointer',
                                                            width: '16px',
                                                            height: '16px'
                                                        }}
                                                        checked={false}
                                                        onChange={() => handleOptionToggle(opt, true)}
                                                    />
                                                    {renderLabel(opt.label)}
                                                </label>
                                            </li>
                                        ))}

                                    {(!REFERENCE_OPTIONS[r.refChild] ||
                                        REFERENCE_OPTIONS[r.refChild]?.filter(opt =>
                                            opt.label.toLowerCase().includes((r.search || '').toLowerCase()) &&
                                            !r.opts?.some(o => o.value === opt.value)
                                        ).length === 0) && (
                                            <div style={{
                                                padding: '16px',
                                                textAlign: 'center',
                                                color: '#6C757D',
                                                fontSize: '14px'
                                            }}>
                                                No results found
                                            </div>
                                        )}
                                </ul>

                                {r.opts && r.opts.length > 0 && (
                                    <>
                                        <div style={{
                                            padding: '8px 15px',
                                            fontSize: '12px',
                                            lineHeight: '15px',
                                            fontWeight: '400',
                                            color: '#6C757D',
                                            borderTop: '1px solid #e9ecef',
                                            borderBottom: '1px solid #e9ecef',
                                            marginTop: '8px'
                                        }}>
                                            Selected
                                        </div>

                                        <ul
                                            className="selected-list custom-check info-inner"
                                            style={{
                                                listStyle: 'none',
                                                margin: 0,
                                                padding: '8px 0',
                                                maxHeight: '150px',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            {r.opts.map(opt => (
                                                <li key={opt.value} style={{ marginBottom: '4px' }}>
                                                    <label
                                                        className="option-item"
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            fontSize: '14px',
                                                            fontWeight: '400',
                                                            lineHeight: '1.4',
                                                            padding: '8px 16px',
                                                            transition: 'background-color 0.2s'
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            style={{
                                                                marginRight: '8px',
                                                                marginTop: '2px',
                                                                cursor: 'pointer',
                                                                width: '16px',
                                                                height: '16px'
                                                            }}
                                                            checked={true}
                                                            onChange={() => handleOptionToggle(opt, false)}
                                                        />
                                                        {renderLabel(opt.label)}
                                                    </label>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                            </OptionPortal>
                        )}
                    </div>
                )}
            </td>

            {/* taking too much space to right side */}
            {/* <td className="drag-handle" style={{ cursor: 'grab', verticalAlign: 'middle' }}>
                <Menu size={18} />
            </td> */} 

            {/* updated */}
            <td
                className="drag-handle"
                style={{
                    cursor: "grab",
                    verticalAlign: "middle",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border:"none",
                    paddingTop:"20px",
                }}
                >
                <Menu size={18} />
            </td>
        </tr>
    );
}


function VariationRow({
    refNode,
    rowState: r,
    deleteRow,
    updateRow,
    skuAttributes,
    skuAttributeOptions,
    rows2,
    showMissingVariationError,
    errors,
    onFieldBlur,
    setVariationErrors,
    setNotification
}) {
    const valueRef = useRef(null);
    const skuRef = useRef(null);
    const [portalStyle, setPortalStyle] = useState({});
    
    // Store the portal element reference
    const [portalElement, setPortalElement] = useState(null);
    const [skuSearch, setSkuSearch] = useState('');
    const skuInputRef = useRef(null);
    const [optionSearch, setOptionSearch] = useState('');
    const optionSearchRef = useRef(null);

    useEffect(() => {
        if (r.isOpen && valueRef.current) {
            const rect = valueRef.current.getBoundingClientRect();
            setPortalStyle({
                position: 'absolute',
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
                background: '#fff',
                boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                borderRadius: '8px',
                overflow: 'visible',
                zIndex: 2000,
            });
        }
    }, [r.isOpen, r.opts, r.search]);

    // Add click-outside handler for SKU dropdown
   
useEffect(() => {
    console.log('⚠️ useEffect for SKU dropdown is RUNNING');
    console.log('openSkuDropdown value:', r.openSkuDropdown);
    
    const handleClickOutside = (event) => {
        console.log('🎯 Click outside handler TRIGGERED - Row:', r.id);
        console.log('Event target:', event.target);
        console.log('openSkuDropdown:', r.openSkuDropdown);
        
        if (!r.openSkuDropdown) return;
        
        // Get the portal element
        const portalId = `sku-dropdown-${r.id}`;
        const portalEl = document.getElementById(portalId);
        console.log('Portal element found:', !!portalEl);
        
        if (skuRef.current && !skuRef.current.contains(event.target)) {
            console.log('✅ Click outside trigger');
            if (!portalEl || (portalEl && !portalEl.contains(event.target))) {
                console.log('✅ Click outside portal too, closing dropdown');
                updateRow(r.id, { openSkuDropdown: false });
            }
        }
    };

    // Use capture phase to ensure we catch the event
    document.addEventListener('mousedown', handleClickOutside, true);
    document.addEventListener('click', handleClickOutside, true);
    
    return () => {
        console.log('🧹 Cleaning up event listener');
        document.removeEventListener('mousedown', handleClickOutside, true);
        document.removeEventListener('click', handleClickOutside, true);
    };
}, [r.openSkuDropdown, r.id, updateRow]);

useEffect(() => {
    if (r.openSkuDropdown) {
        if (skuInputRef.current) skuInputRef.current.focus();
    } else {
        setSkuSearch('');
    }
}, [r.openSkuDropdown]);

useEffect(() => {
    if (r.isOpen) {
        if (optionSearchRef.current) optionSearchRef.current.focus();
    } else {
        setOptionSearch('');
    }
}, [r.isOpen]);

    const getAttributeOptions = () => {
        if (!r.fieldName) return [];

        return skuAttributeOptions
            ?.filter(opt => opt?.sku_preset_id?.toString() === r.fieldName)
            ?.map(opt => ({
                label: opt.sku_preset_option_name,
                value: opt.sku_preset_option_id
            })) || [];
    };

    // Show ALL variation attributes, not filtering out already selected ones
    const availableAttributes = skuAttributes
        ?.filter(attr => attr?.sku_preset_id) // Only filter out invalid ones
        ?.map(attr => ({
            value: attr?.sku_preset_id?.toString(),
            label: attr?.sku_preset_name,
            isSelected: rows2.some(row => 
                row.id !== r.id && row.fieldName === attr?.sku_preset_id?.toString()
            )
        }))
        ?.sort((a, b) => a.label.localeCompare(b.label))
        || [];

    const filteredSkuAttributes = skuSearch.trim()
        ? availableAttributes.filter(attr => attr.label.toLowerCase().includes(skuSearch.toLowerCase()))
        : availableAttributes;

    const handleOpenOptions = () => {
        if (valueRef.current) {
            const rect = valueRef.current.getBoundingClientRect();
            setPortalStyle({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
                position: "absolute",
                background: "#FFF",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                maxHeight: "280px",
                overflowY: "auto",
                zIndex: 2000,
            });
            updateRow(r.id, { isOpen: true });
        }
    };

    const handleFieldNameBlur = () => {
        if (errors?.[r.id]) {
            if (onFieldBlur) {
                onFieldBlur(r.id);
            }
        }
    };

    const handleOptionsBlur = () => {
        if (onFieldBlur) {
            onFieldBlur(r.id);
        }
    };

    const handleDragStart = (index) => {
        updateRow(r.id, { dragIndex: index });
    };

    const handleDragOver = (e, index) => {
        e.preventDefault();
        if (r.dragIndex === index) return;

        const updated = [...r.opts];
        const draggedItem = updated[r.dragIndex];

        updated.splice(r.dragIndex, 1);
        updated.splice(index, 0, draggedItem);

        updateRow(r.id, { opts: updated, dragIndex: index });
    };

    const handleDrop = () => {
        updateRow(r.id, { dragIndex: null });
    };

    const handleFieldNameChange = (e) => {
        const newValue = e.target.value;
        updateRow(r.id, { fieldName: newValue });
        
        // Clear error if field is being filled and error exists
        if (newValue.trim() && errors?.[r.id]?.fieldName) {
            setTimeout(() => {
                setVariationErrors(prev => {
                    const updated = { ...prev };
                    if (updated[r.id]) {
                        delete updated[r.id].fieldName;
                        
                        // Check for duplicate after clearing
                        const isDuplicate = rows2.some(row =>
                            row.id !== r.id &&
                            row.fieldName === newValue
                        );
                        
                        if (!isDuplicate) {
                            delete updated[r.id].fieldName;
                        } else {
                            updated[r.id].fieldName = "SKU Variation already exists";
                        }
                        
                        if (Object.keys(updated[r.id]).length === 0) {
                            delete updated[r.id];
                        }
                    }
                    return updated;
                });
            }, 10);
        }
    };
    
    const handleOptionToggle = (opt) => {
        const selected = r.opts.some(o => o.value === opt.value);
        
        if (selected) {
            // Remove option
            const newOpts = r.opts.filter(o => o.value !== opt.value);
            updateRow(r.id, { opts: newOpts });
        } else {
            // Add option
            const newOpts = [...r.opts, opt];
            updateRow(r.id, { opts: newOpts });
        }
        
        // Clear options error if options are present and error exists
        if (errors?.[r.id]?.options) {
            setTimeout(() => {
                setVariationErrors(prev => {
                    const updated = { ...prev };
                    if (updated[r.id] && (r.opts.length > 0 || (!selected && r.opts.length > 0))) {
                        delete updated[r.id].options;
                        if (Object.keys(updated[r.id]).length === 0) {
                            delete updated[r.id];
                        }
                    }
                    return updated;
                });
            }, 10);
        }
    };

    const handleSkuSelect = (attr) => {
        // Check if this variation is already selected by another row
        const isDuplicate = rows2.some(row => 
            row.id !== r.id && row.fieldName === attr.value
        );
        
        if (isDuplicate) {
            updateRow(r.id, {
                fieldName: attr.value,
                fieldNameLabel: attr.label,
                opts: [],
                openSkuDropdown: false,
            });
        } else {
            // Clear any existing error if selection is valid
            setVariationErrors(prev => {
                const updated = { ...prev };
                if (updated[r.id]) {
                    delete updated[r.id].fieldName;
                    if (Object.keys(updated[r.id]).length === 0) {
                        delete updated[r.id];
                    }
                }
                return updated;
            });
            
            updateRow(r.id, {
                fieldName: attr.value,
                fieldNameLabel: attr.label,
                opts: [],
                openSkuDropdown: false,
            });
        }
    };

    const rowIndex = rows2.findIndex(row => row.id === r.id);
    const isFirstRow = rowIndex === 0;

    // Determine border color - only show red if error exists
    const fieldNameBorderColor = errors?.[r.id]?.fieldName ? "#dc3545" : "#6C757D";
    const optionsBorderColor = errors?.[r.id]?.options ? "#dc3545" : "#6C757D";
    
    return (
        <tr
            ref={refNode}
            data-row-id={r.id}
            style={{
                backgroundColor: rowIndex % 2 === 0 ? "#FFFFFF" : "#F8F9FA",
                position: r.isOpen || r.openSkuDropdown ? 'relative' : 'static',
                zIndex: r.isOpen || r.openSkuDropdown ? 999 : 'auto',
                height: 'auto',
                minHeight: '70px',
                verticalAlign: 'top'
            }}
        >
            <td style={{ verticalAlign: 'middle', paddingTop: '15px' }}>
                <Trash2
                    size={16}
                    style={{
                        cursor: isFirstRow ? "not-allowed" : "pointer",
                        opacity: isFirstRow ? 0.3 : 1,
                        border:'none',
                    }}
                    onClick={() => {
                        if (!isFirstRow) {
                            deleteRow(r.id);
                            // Remove any errors for this row
                            setVariationErrors(prev => {
                                const updated = { ...prev };
                                delete updated[r.id];
                                return updated;
                            });
                        }
                    }}
                />
            </td>

            <td style={{ padding: "10px", maxWidth: "210px", position: "relative", verticalAlign:errors?.[r.id]?.options ? 'top':'middle', minWidth: '210px' }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight:  '43.2px'
                }}>
                    <div
                        ref={skuRef}
                        onClick={() => {
                            if (skuRef.current && !r.openSkuDropdown) {
                                const rect = skuRef.current.getBoundingClientRect();
                                updateRow(r.id, {
                                    openSkuDropdown: true,
                                    skuPos: {
                                        top: rect.bottom + window.scrollY,
                                        left: rect.left + window.scrollX,
                                        width: rect.width,
                                    },
                                });
                            }
                        }}
                        onBlur={handleFieldNameBlur}
                        style={{
                            width: "100%",
                            height: r.opts && r.opts.length > 0 ? '49.2px' : '43.2px',
                            border: `1px solid ${fieldNameBorderColor}`,
                            borderRadius: "8px",
                            padding: "8.8px 12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            cursor: "text",
                            background: "#FFF",
                            flexShrink: 0,
                        }}

                    >
                        <input
                            ref={skuInputRef}
                            type="text"
                            value={r.fieldName && !r.openSkuDropdown ? r.fieldNameLabel : skuSearch}
                            readOnly={!!(r.fieldName && !r.openSkuDropdown)}
                            onChange={(e) => {
                                setSkuSearch(e.target.value);
                                if (!r.openSkuDropdown && skuRef.current) {
                                    const rect = skuRef.current.getBoundingClientRect();
                                    updateRow(r.id, {
                                        openSkuDropdown: true,
                                        skuPos: {
                                            top: rect.bottom + window.scrollY,
                                            left: rect.left + window.scrollX,
                                            width: rect.width,
                                        },
                                    });
                                }
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!r.openSkuDropdown && skuRef.current) {
                                    const rect = skuRef.current.getBoundingClientRect();
                                    updateRow(r.id, {
                                        openSkuDropdown: true,
                                        skuPos: {
                                            top: rect.bottom + window.scrollY,
                                            left: rect.left + window.scrollX,
                                            width: rect.width,
                                        },
                                    });
                                }
                            }}
                            placeholder={r.openSkuDropdown && r.fieldNameLabel ? r.fieldNameLabel : 'Select Variation'}
                            style={{ border: 'none', flex: 1, outline: 'none', background: 'transparent', color: '#000', fontSize: 'inherit', padding: 0, cursor: r.fieldName && !r.openSkuDropdown ? 'default' : 'text' }}
                        />

                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            {r.fieldName && (
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        updateRow(r.id, { fieldName: '', fieldNameLabel: '', opts: [], openSkuDropdown: false });
                                        setSkuSearch('');
                                    }}
                                    style={{ border: 'none', background: 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2px' }}
                                    title="Clear"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M9 3L3 9M3 3L9 9" stroke="#212529" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            )}
                            <div
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', transition: '0.2s', cursor: 'pointer' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (skuRef.current) {
                                        const rect = skuRef.current.getBoundingClientRect();
                                        updateRow(r.id, {
                                            openSkuDropdown: !r.openSkuDropdown,
                                            skuPos: {
                                                top: rect.bottom + window.scrollY,
                                                left: rect.left + window.scrollX,
                                                width: rect.width,
                                            },
                                        });
                                    }
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    style={{ transform: r.openSkuDropdown ? 'rotate(0deg)' : 'rotate(180deg)', transition: '0.2s' }}
                                >
                                    <path d="M4.5 11.25L9 6.75L13.5 11.25" stroke="#212529" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    {errors?.[r.id]?.fieldName && (
                        <div
                            className="invalid-feedback d-block"
                            style={{
                                marginTop: '4px',
                                fontSize: '12px',
                                color: '#dc3545',
                                lineHeight: '1.2',
                                minHeight: '20px',
                                flexShrink: 0,
                            }}
                        >
                            {errors[r.id].fieldName}
                        </div>
                    )}
                </div>

                {r.openSkuDropdown && (
                    createPortal(
                        <div 
                            id={`sku-dropdown-${r.id}`}
                            className="sku-variation-dropdown-container" 
                            style={{
                                position: "fixed",
                                top: r.skuPos?.top || 0,
                                left: r.skuPos?.left || 0,
                                width: r.skuPos?.width || 200,
                                background: "#FFF",
                                borderRadius: "8px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                maxHeight: "200px",
                                overflowY: "auto",
                                zIndex: 9999,
                            }}
                        >
                            {filteredSkuAttributes.length === 0 ? (
                                skuSearch.trim() ? (
                                    <div style={{ padding: "12px 15px", color: "#adb5bd", fontSize: "13px" }}>No match found</div>
                                ) : null
                            ) : filteredSkuAttributes.map(attr => {
                                const isSelectedInOtherRow = rows2.some(row =>
                                    row.id !== r.id && row.fieldName === attr.value
                                );

                                return (
                                    <div
                                        key={attr.value}
                                        onMouseEnter={() =>
                                            updateRow(r.id, { hoverVariation: attr.value })
                                        }
                                        onMouseLeave={() =>
                                            updateRow(r.id, { hoverVariation: null })
                                        }
                                        onClick={() => handleSkuSelect(attr)}
                                        style={{
                                            padding: "12px 15px",
                                            cursor: "pointer",
                                            background: r.hoverVariation === attr.value ? "#FFFEF0" : "#FFF",
                                            position: "relative",
                                        }}
                                    >
                                        {attr.label}
                                    </div>
                                );
                            })}
                        </div>,
                        document.body
                    )
                )}
            </td>

            <td style={{ padding: "10px", flexGrow: 1, maxWidth: "644px",verticalAlign:errors?.[r.id]?.fieldName?'top':'middle',  minWidth: '644px' }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '40px'
                }}>
                    <div
                        ref={valueRef}
                        onClick={() => {
                            if (!r.isOpen) handleOpenOptions();
                            if (optionSearchRef.current) optionSearchRef.current.focus();
                        }}
                        onBlur={handleOptionsBlur}
                        className="form-control"
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            minHeight: "40px",
                            cursor: "text",
                            border: `1px solid ${optionsBorderColor}`,
                            flexShrink: 0,
                        }}
                    >
                        {r.opts.map((opt, index) => (
                                <span
                                    key={opt.value}
                                    draggable
                                    onDragStart={() => handleDragStart(index)}
                                    onDragOver={(e) => handleDragOver(e, index)}
                                    onDrop={handleDrop}
                                    onDragEnd={handleDrop}
                                    style={{
                                        backgroundColor: "#FFEB00",
                                        color: "#212529",
                                        borderRadius: "16px",
                                        padding: "4px 8px",
                                        margin: "2px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        cursor: "grab",
                                        opacity: r.dragIndex === index ? 0.5 : 1,
                                        userSelect: "none",
                                    }}
                                >
                                    <span style={{ display: "flex", alignItems: "center", cursor: "grab" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                            viewBox="0 0 12 12" fill="none">
                                            <path d="M2 6H10M2 9H10M2 3H10"
                                                stroke="black"
                                                strokeWidth="1.33333"
                                                strokeLinecap="round"
                                                strokeLinejoin="round" />
                                        </svg>
                                    </span>

                                    <span style={{ fontWeight: 600, fontSize: "12px" }}>{opt.label}</span>

                                    <button
                                        type="button"
                                        style={{
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            const newOpts = r.opts.filter((o) => o.value !== opt.value);
                                            updateRow(r.id, {
                                                opts: newOpts,
                                            });
                                            
                                            // Clear error if it exists and options are still present
                                            if (errors?.[r.id]?.options && newOpts.length > 0) {
                                                setTimeout(() => {
                                                    setVariationErrors(prev => {
                                                        const updated = { ...prev };
                                                        if (updated[r.id]) {
                                                            delete updated[r.id].options;
                                                            if (Object.keys(updated[r.id]).length === 0) {
                                                                delete updated[r.id];
                                                            }
                                                        }
                                                        return updated;
                                                    });
                                                }, 10);
                                            }
                                        }}
                                    >
                                        <X size={14} strokeWidth={3} />
                                    </button>
                                </span>
                            ))}

                        <input
                            ref={optionSearchRef}
                            type="text"
                            value={optionSearch}
                            onChange={(e) => {
                                setOptionSearch(e.target.value);
                                if (!r.isOpen) handleOpenOptions();
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!r.isOpen) handleOpenOptions();
                            }}
                            placeholder={r.opts.length === 0 ? "Select options..." : ""}
                            style={{ border: 'none', outline: 'none', flex: 1, background: 'transparent', minWidth: '60px', fontSize: 'inherit', padding: 0, alignSelf: 'center' }}
                        />

                        <ChevronDown
                            size={18}
                            style={{
                                marginLeft: "auto",
                                transform: r.isOpen ? "rotate(180deg)" : "rotate(0)",
                                color:'#6C757D'
                            }}
                        />
                    </div>

                    {errors?.[r.id]?.options && (
                        <div
                            className="invalid-feedback d-block"
                            style={{
                                marginTop: '4px',
                                fontSize: '12px',
                                color: '#dc3545',
                                lineHeight: '1.2',
                                minHeight: '20px',
                                flexShrink: 0,
                            }}
                        >
                            {errors[r.id].options}
                        </div>
                    )}
                </div>

                {r.isOpen && (
                    <OptionPortal style={portalStyle}>
                        <ul
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "12px",
                                padding: "10px",
                                listStyle: "none",
                                maxHeight: "200px",
                                overflowY: "auto"
                            }}
                        >
                            {(() => {
                                const filtered = optionSearch.trim()
                                    ? getAttributeOptions().filter(opt => opt.label.toLowerCase().includes(optionSearch.toLowerCase()))
                                    : getAttributeOptions();
                                if (filtered.length === 0) {
                                    return optionSearch.trim()
                                        ? <li style={{ color: "#adb5bd", fontSize: "13px", listStyle: "none" }}>No match found</li>
                                        : null;
                                }
                                return filtered.map(opt => {
                                    const selected = r.opts.some(o => o.value === opt.value);
                                    return (
                                        <li key={opt.value}>
                                            <div
                                                onClick={() => { handleOptionToggle(opt); setOptionSearch(''); }}
                                                style={{
                                                    padding: "6px 12px",
                                                    borderRadius: "999px",
                                                    border: "1px solid #FFEB00",
                                                    background: selected ? "#FFEB00" : "#FFF",
                                                    color: "#212529",
                                                    cursor: "pointer",
                                                    fontWeight: 600,
                                                    opacity: 1,
                                                }}
                                            >
                                                {opt.label}
                                            </div>
                                        </li>
                                    );
                                });
                            })()}
                        </ul>
                    </OptionPortal>
                )}
            </td>

            <td
                className="drag-handle"
                style={{
                    cursor: "grab",
                    verticalAlign: "middle",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border:"none",
                    paddingTop:"20px",
                }}
                >
                <Menu size={18} />
            </td>
        </tr>
    );
}
function ConfigRow({
    refNode,
    rowState: r,
    index: idx,
    deleteRow,
    updateRow,
    rows2,
    skuAttributes,
    skuAttributeOptions,
    errors,
    onFieldBlur,
    setShowConfigTable,
    rows3
}) {
    const valueRef = useRef(null);
    const fieldNameRef = useRef(null);
    const [portalStyle, setPortalStyle] = useState({});
    const [fieldNameTouched, setFieldNameTouched] = useState(false);
    const [optionsTouched, setOptionsTouched] = useState(false);
    const [wasDropdownOpen, setWasDropdownOpen] = useState(false);

    useEffect(() => {
        if (r.isOpen && valueRef.current) {
            const rect = valueRef.current.getBoundingClientRect();
            setPortalStyle({
                position: "absolute",
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
                background: "#FFF",
                // border: "1px solid #6c757d", //no need of border
                boxShadow: "0 4px 12px rgba(0,0,0,0.12)", // add shodaw
                borderRadius: "8px",
                padding: "1rem",
                zIndex: 2000
            });
        }
    }, [r.isOpen]);

    useEffect(() => {
        if (wasDropdownOpen && !r.isOpen) {
            setOptionsTouched(true);
            if (onFieldBlur) {
                onFieldBlur(r.id, r.opts);
            }
        }
        setWasDropdownOpen(r.isOpen);
    }, [r.isOpen, r.id, r.opts, onFieldBlur, wasDropdownOpen]);

    const variationGroups = rows2
        ?.filter(row => row.fieldName && row.opts?.length > 0)
        ?.map(row => {
            const attribute = skuAttributes?.find(
                a => a?.sku_preset_id?.toString() === row.fieldName
            );

            if (!attribute) return null;

            return {
                attrId: attribute.sku_preset_id,
                attrName: attribute.sku_preset_name,
                options: row.opts.map(o => ({
                    label: o.label,
                    value: o.value
                }))
            };
        })
        ?.filter(Boolean) || [];

    useEffect(() => {
        if (!r.opts && rows2.length > 0) {
            const initialOpts = {};
            rows2.forEach(variation => {
                if (variation.fieldName) {
                    initialOpts[variation.fieldName] = [];
                }
            });
            updateRow(r.id, { opts: initialOpts });
        }
    }, [r.id, r.opts, rows2, updateRow]);

  const toggleOption = (attrId, optionValue) => {
    const currentOpts = r.opts || {};
    
    const currentOptions = currentOpts[attrId] || [];
    
    let updatedOptions;
    if (currentOptions.includes(optionValue)) {
        updatedOptions = currentOptions.filter(v => v !== optionValue);
    } else {
        updatedOptions = [...currentOptions, optionValue];
    }
    
    const newOpts = {
        ...currentOpts,
        [attrId]: updatedOptions.length > 0 ? updatedOptions : []
    };
    
    Object.keys(newOpts).forEach(key => {
        if (Array.isArray(newOpts[key]) && newOpts[key].length === 0) {
            delete newOpts[key];
        }
    });
    
    updateRow(r.id, { opts: newOpts });
    
    // Clear options error if user selects an option
    if (errors?.[r.id]?.options) {
        // Check if all required variations now have at least one option
        const validVariations = rows2.filter(v => 
            v.fieldName && v.opts && v.opts.length > 0
        );
        
        if (validVariations.length > 0) {
            let allGroupsHaveOptions = true;
            validVariations.forEach(variationRow => {
                const attrId = variationRow.fieldName;
                const optionsForAttr = newOpts[attrId];
                if (!optionsForAttr || !Array.isArray(optionsForAttr) || optionsForAttr.length === 0) {
                    allGroupsHaveOptions = false;
                }
            });
            
            if (allGroupsHaveOptions) {
                // Trigger validation to check for overlapping errors
                if (onFieldBlur) {
                    setTimeout(() => {
                        onFieldBlur(r.id, newOpts);
                    }, 10);
                }
            }
        }
    }
};

    const renderSelectedOptions = () => {
        if (!r.opts || Object.keys(r.opts).length === 0) {
            return <span style={{ color: "#999", fontSize: "14px" }}>Select options…</span>;
        }

        const groups = [];
        
        rows2.forEach(variationRow => {
            const attrId = variationRow.fieldName;
            if (!attrId) return;
            
            const selectedOptions = r.opts?.[attrId] || [];
            if (selectedOptions.length === 0) return;

            const attribute = skuAttributes?.find(a => a?.sku_preset_id?.toString() === attrId);
            if (!attribute) return;

            const selectedNames = selectedOptions
                .map(optId => {
                    const option = skuAttributeOptions?.find(o => 
                        o?.sku_preset_option_id?.toString() === optId?.toString()
                    );
                    return option?.sku_preset_option_name || optId;
                })
                .filter(Boolean);

            if (selectedNames.length > 0) {
                groups.push({
                    attrId,
                    attrName: attribute.sku_preset_name,
                    values: selectedNames.join(', ')
                });
            }
        });

        if (groups.length === 0) {
            return <span style={{ color: "#999", fontSize: "14px" }}>Select options…</span>;
        }

        return groups.map((group, index) => (
            <div key={group.attrId} style={{ 
                display: 'inline-flex', 
                alignItems: 'center', 
                marginRight: '8px',
            }}>
                <span style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#1F1F1F',
                }}>
                    {group.attrName}:
                </span>
                <span style={{
                    fontSize: '14px',
                    color: '#1F1F1F',
                    fontWeight: '400',
                    marginLeft: '4px',
                }}>
                    {group.values}
                </span>
                {index < groups.length - 1 && (
                    <span style={{ margin: '0 4px', fontSize: '14px', color: '#6C757D' }}>;</span>
                )}
            </div>
        ));
    };

    const handleFieldNameBlur = (e) => {
        setFieldNameTouched(true);
        if (onFieldBlur) {
            onFieldBlur(r.id, r.opts);
        }
    };

  const handleFieldNameChange = (e) => {
    const newValue = e.target.value;
    updateRow(r.id, { fieldName: newValue });
    
    // Clear fieldName error when user types
    if (errors?.[r.id]?.fieldName) {
        // Check if the new value is valid (not empty and not duplicate)
        if (newValue.trim()) {
            const isDuplicate = rows3.some(row => // Changed from rows2 to rows3
                row.id !== r.id &&
                row.fieldName?.trim().toLowerCase() === newValue.trim().toLowerCase()
            );
            
            if (!isDuplicate) {
                // Value is valid, clear error
                setFieldNameTouched(true);
                if (onFieldBlur) {
                    setTimeout(() => {
                        onFieldBlur(r.id, r.opts);
                    }, 10);
                }
            }
        }
    }
};

    const handleOptionsClick = () => {
        const newIsOpen = !r.isOpen;
        updateRow(r.id, { isOpen: newIsOpen });
        
        if (!newIsOpen) {
            setOptionsTouched(true);
            if (onFieldBlur) {
                onFieldBlur(r.id, r.opts);
            }
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (r.isOpen && valueRef.current && !valueRef.current.contains(event.target)) {
                updateRow(r.id, { isOpen: false });
            }
            
            if (fieldNameRef.current && !fieldNameRef.current.contains(event.target) && document.activeElement !== fieldNameRef.current) {
                setFieldNameTouched(true);
                if (onFieldBlur) {
                    onFieldBlur(r.id, r.opts);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [r.isOpen, r.id, updateRow]);

    // Determine if we should show errors
    // Show errors if they exist AND (field has been touched OR errors were marked as touched from Next button click)
    const showFieldNameError = errors?.[r.id]?.fieldName && (fieldNameTouched || errors?.[r.id]?._touched);
    const showOptionsError = errors?.[r.id]?.options && (optionsTouched || (errors?.[r.id]?._touched && errors?.[r.id]?._options_force_show));

    return (
        <tr
            ref={refNode}
            data-row-id={r.id}
            style={{
                position: r.isOpen ? "relative" : "static",
                zIndex: r.isOpen ? 999 : "auto",
                minHeight: '70px',
                backgroundColor: idx % 2 === 0 ? "#FFFFFF" : "#F8F9FA",
            }}
        >
            <td style={{ verticalAlign: 'top', paddingTop: '15px' }}>
                <button 
                    className="btn p-0" 
                    onClick={() => {deleteRow(r.id); 
                        if(rows3.length===1){setShowConfigTable(false);}}}
                    style={{ 
                        boxShadow: 'none',
                        border: 'none',
                        outline: 'none'
                    }}
                >
                    <Trash2 size={18} />
                </button>
            </td>

            <td style={{ minWidth: "200px", maxWidth: "200px", paddingRight:'0px', verticalAlign: 'top' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <input
                        ref={fieldNameRef}
                        className="form-control common-input-all"
                        value={r.fieldName || ''}
                        onChange={handleFieldNameChange}
                        onBlur={handleFieldNameBlur}
                        style={{
                            borderColor: showFieldNameError ? '#dc3545' : '#6C757D',
                            borderWidth: '1px'
                        }}
                        placeholder="Enter configuration name"
                    />

                    {showFieldNameError && (
                        <div className="invalid-feedback d-block" style={{
                            fontSize: '12px',
                            marginTop: '4px',
                            color: '#dc3545',
                            lineHeight: '1.2'
                        }}>
                            {errors[r.id].fieldName}
                        </div>
                    )}
                </div>
            </td>

            <td style={{ minWidth: "400px", position: "relative", verticalAlign: 'top',maxWidth: '400px', paddingRight:'0px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div
                        ref={valueRef}
                        className="select-box form-control"
                        onClick={handleOptionsClick}
                        style={{
                            cursor: "pointer",
                            minHeight: "40px",
                            padding: "0.5rem",
                            display: "flex",
                            alignItems: "center",
                            borderColor: showOptionsError && (optionsTouched || errors?.[r.id]?._options_force_show) ? '#dc3545' : '#6C757D',
                            borderWidth: '1px',
                            flexWrap: 'wrap',
                            gap: '4px',
                            borderRadius: '8px'
                        }}
                    >
                        <div style={{ 
                            display: 'flex', 
                            flexWrap: 'wrap', 
                            alignItems: 'center', 
                            gap: '4px',
                            flex: 1
                        }}>
                            {renderSelectedOptions()}
                        </div>

                        <ChevronDown
                            size={16}
                            style={{
                                marginLeft: "auto",
                                transform: r.isOpen ? "rotate(180deg)" : "rotate(0)",
                                transition: 'transform 0.2s'
                            }}
                        />
                    </div>

{showOptionsError && (optionsTouched || errors?.[r.id]?._options_force_show) && (
    <div className="invalid-feedback d-block" style={{
        fontSize: '12px',
        marginTop: '10px',
        color: '#dc3545',
        lineHeight: '1.2'
    }}>
        {errors[r.id].options}
    </div>
)}
                </div>

                {r.isOpen && (
                    <OptionPortal style={portalStyle}>
                        {variationGroups.length === 0 ? (
                            <div
                                style={{
                                    color: "#999",
                                    textAlign: "center",
                                    padding: "1rem"
                                }}
                            >
                                No variation options available. Please add SKU variations first.
                            </div>
                        ) : (
                            <>
                                {variationGroups.map(group => {
                                    const currentSelected = r.opts?.[group.attrId] || [];
                                    return (
                                        <div key={group.attrId} style={{ marginBottom: "1rem" }}>
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                marginBottom: "6px"
                                            }}>
                                                <strong
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "600",
                                                        color: "#6C757D"
                                                    }}
                                                >
                                                    {group.attrName}
                                                </strong>
                                            </div>

                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: "8px"
                                                }}
                                            >
                                                {group.options.map(opt => {
                                                    const isSelected = currentSelected.includes(opt.value);
                                                    return (
                                                        <div
                                                            key={opt.value}
                                                            onClick={() => toggleOption(group.attrId, opt.value)}
                                                            style={{
                                                                padding: "6px 12px",
                                                                borderRadius: "999px",
                                                                border: "1px solid #FFEB00",
                                                                background: isSelected ? "#FFEB00" : "#FFF",
                                                                cursor: "pointer",
                                                                fontWeight: 600,
                                                                fontSize: "12px",
                                                                transition: "all 0.2s",
                                                                // color: isSelected ? "#6C757D" : "#212529",
                                                                color: "#212529",
                                                                opacity: isSelected ? 1 : 0.8,
                                                                '&:hover': {
                                                                    backgroundColor: isSelected ? "#FFD700" : "#FFFDE7"
                                                                }
                                                            }}
                                                        >
                                                            {opt.label}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                                
                                {/* Show warning if no options are selected */}
                                {/* {Object.keys(r.opts || {}).length === 0 && (
                                    <div style={{
                                        padding: "8px",
                                        backgroundColor: "#FFF3CD",
                                        border: "1px solid #FFEEBA",
                                        borderRadius: "4px",
                                        color: "#856404",
                                        fontSize: "12px",
                                        marginTop: "8px"
                                    }}>
                                        Please select at least one option from each variation group.
                                    </div>
                                )} */}
                            </>
                        )}
                    </OptionPortal>
                )}
            </td>

            {/* taking too much space to right side */}
            {/* <td className="drag-handle" style={{ verticalAlign: 'top', paddingTop: '15px' }}>
                <Menu size={18} style={{ cursor: "grab" }} />
            </td> */}
            <td
                className="drag-handle"
                style={{
                    cursor: "grab",
                    verticalAlign: "middle",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border:"none",
                    paddingTop:"20px",
                }}
                >
                <Menu size={18} />
            </td>
        </tr>
    );
}